// French
const fr = {
  "lang.switch": "Langue",

  "nav.marketplace": "Marché",
  "nav.coaches": "Coachs",
  "nav.login": "Se connecter",
  "nav.signup": "Commencer gratuitement",
  "nav.dashboard": "Tableau de bord",
  "nav.circles": "Cercles",
  "nav.collab_packages": "Packs collaboratifs",
  "cp.cta_book": "Réserver une séance",
  "cp.cta_signup": "Créez un compte pour réserver",
  "nav.credits": "Crédits",
  "nav.membership": "Abonnement",
  "nav.account": "Compte",
  "nav.support": "Support",
  "nav.billing": "Facturation",
  "home.meta_title": "Coaching & réflexion intérieure",
  "home.meta_desc": "Trouve ton coach, réserve des séances et grandis intérieurement grâce à l'autoréflexion assistée par IA.",
  "home.hero_eyebrow": "Ton espace pour la croissance intérieure",
  "home.hero_title": "Trouve le calme, la clarté et le bon coach pour ton chemin.",
  "home.hero_sub": "My Within relie de vrais coachs vérifiés à une autoréflexion douce assistée par IA — dans un espace calme et sûr.",
  "home.hero_cta_marketplace": "Découvrir les offres",
  "home.hero_cta_signup": "Commencer gratuitement",
  "home.hero_free_hint": "Inscription 100 % gratuite · sans carte bancaire",
  "home.step1_title": "Trouve ton coach",
  "home.step1_text": "Parcours des coachs et offres vérifiés — par thème, région et langue.",
  "home.step2_title": "Avancez ensemble",
  "home.step2_text": "Réserve des séances, échange et grandis avec un accompagnement humain réel.",
  "home.step3_title": "Réfléchis avec l'IA",
  "home.step3_text": "WEVA et EVA accompagnent ton travail intérieur entre les séances — à tout moment.",
  "home.offerings_title": "Offres à la une",
  "home.offerings_sub": "Fraîchement issues du marché de nos coachs.",
  "home.see_all": "Tout voir",
  "home.coaches_title": "Rencontre nos coachs",
  "home.coaches_sub": "Vérifiés, expérimentés et prêts à t'accompagner.",
  "home.all_coaches": "Tous les coachs",
  "home.cta_title": "Commence ton travail intérieur dès aujourd'hui.",
  "home.cta_sub": "Crée un compte en moins d'une minute — gratuit et sans risque.",
  "home.cta_btn": "Commencer gratuitement",
  "announce.coach_call": "Deviens coach – réserve un appel découverte gratuit",
  "announce.free_signup": "Ou inscris-toi gratuitement – en moins d'une minute",
  "announce.founder": "Offre Founder – paiement unique",
  "foot.tagline": "Un lieu calme pour le travail intérieur — guidé par de vrais coachs et une réflexion assistée par IA.",
  "foot.discover": "Découvrir",
  "foot.create_account": "Créer un compte",
  "foot.legal": "Mentions légales",
  "foot.privacy": "Confidentialité",
  "foot.terms": "CGU",
  "foot.built_in_austria": "Conçu avec soin en Autriche",
  "oc.recommended": "Recommandé",
  "oc.minutes": "{n} min",
  "oc.parts": "{n} parties",
  "nav.account_fallback": "Compte",
  "nav.signout": "Se déconnecter",

  "common.or": "OU",
  "common.loading": "Chargement…",
  "common.active": "Actif",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",

  "auth.email": "E-mail",
  "auth.password": "Mot de passe",
  "auth.email_placeholder": "toi@exemple.com",
  "auth.quote": "« Le chemin vers l'intérieur est le seul qui mène vraiment vers l'avant. »",
  "auth.quote_attr": "My Within · ton espace de calme",
  "auth.back_home": "← Retour à l'accueil",
  "auth.google": "Continuer avec Google",
  "auth.apple": "Continuer avec Apple",
  "auth.apple_toast": "La connexion Apple sera activée avec le lancement web sur my-within.app.",

  "login.meta_title": "Se connecter",
  "login.meta_desc": "Connecte-toi à ton compte My Within.",
  "login.title": "Bon retour",
  "login.subtitle": "Connecte-toi pour poursuivre ton travail intérieur.",
  "login.footer_q": "Pas encore de compte ?",
  "login.footer_link": "Inscris-toi",
  "login.forgot": "Oublié ?",
  "login.submit": "Se connecter",
  "login.welcome_back": "Bon retour !",
  "login.failed": "Échec de la connexion.",

  "signup.meta_title": "S'inscrire",
  "signup.meta_desc": "Crée ton compte My Within gratuit.",
  "signup.title": "Créer un compte",
  "signup.subtitle": "Commence gratuitement — tu décides quand et avec qui tu travailles.",
  "signup.footer_q": "Déjà inscrit ?",
  "signup.footer_link": "Se connecter",
  "signup.role_client": "Je cherche un accompagnement",
  "signup.role_coach": "Je suis coach",
  "signup.name": "Nom",
  "signup.name_placeholder": "Ton nom",
  "signup.password_placeholder": "Au moins 8 caractères",
  "signup.consent_pre": "J'accepte les",
  "signup.terms": "CGU",
  "signup.consent_mid": "et la",
  "signup.privacy": "Politique de confidentialité",
  "signup.consent_post": ", je consens expressément au traitement de mes données de santé et je confirme avoir au moins 16 ans.",
  "signup.consent_required": "Merci de confirmer ton consentement pour continuer.",
  "signup.submit": "S'inscrire gratuitement",
  "signup.created": "Compte créé — bienvenue sur My Within !",
  "signup.failed": "Échec de l'inscription.",

  "dash.meta_title": "Tableau de bord",
  "dash.welcome": "Bon retour",
  "dash.hello_fallback": "Ravi de te voir",
  "dash.balance": "Ton solde",
  "dash.credits": "Crédits",
  "dash.topup": "Recharger",
  "dash.membership": "Abonnement",
  "dash.upgrade": "Améliorer",
  "dash.manage": "Gérer",
  "dash.next": "La suite",
  "dash.action_credits_title": "Recharger des crédits",
  "dash.action_credits_text": "Achète des crédits pour les rapports WEVA et le contenu.",
  "dash.action_membership_title": "Abonnement",
  "dash.action_membership_text": "Débloque la réflexion IA illimitée.",
  "dash.action_marketplace_title": "Marché",
  "dash.action_marketplace_text": "Découvre les offres et cours des coachs.",
  "dash.action_coaches_title": "Coachs",
  "dash.action_coaches_text": "Trouve l'accompagnement qui te convient.",

  "tier.free": "Gratuit",
  "tier.plus": "Plus",
  "tier.plus_yearly": "Plus (annuel)",
  "tier.pro": "Pro",
  "tier.pro_yearly": "Pro (annuel)",
  "tier.unlimited": "Illimité",
  "tier.unlimited_yearly": "Illimité (annuel)",
  "tier.coach_pro": "Coach Pro",
  "tier.coach_pro_yearly": "Coach Pro (annuel)",

  "credits.meta_title": "Crédits",
  "credits.title": "Recharger des crédits",
  "credits.subtitle": "Les crédits débloquent les rapports WEVA et le contenu exclusif.",
  "credits.suffix": "Crédits",
  "credits.popular": "Populaire",
  "credits.incl_vat": "TVA incl.",
  "credits.per_credit": "/crédit",
  "credits.buy": "Acheter",
  "credits.secure": "Paiement sécurisé via Stripe. Tu seras brièvement redirigé vers Stripe pour le paiement, puis ramené ici.",
  "credits.payment_received": "Paiement reçu — tes crédits seront ajoutés.",
  "credits.purchase_cancelled": "Achat annulé.",
  "credits.granted": "{n} crédits ajoutés.",
  "credits.failed": "Échec de l'achat.",

  "account.meta_title": "Compte",
  "account.title": "Compte",
  "account.referral": "Ton code de parrainage",
  "account.billing": "Informations de facturation",
  "account.billing_complete": "Complet",
  "account.billing_incomplete": "Incomplet",
  "account.devices": "Appareils connectés",
  "account.session": "Session {n}",
  "account.logged_in": "Connecté",
  "account.last_active": "Dernière activité",
  "account.no_sessions": "Aucune session active.",
  "account.logout": "Se déconnecter",
  "account.logout_all": "Fermer toutes les sessions",
  "account.logout_all_done": "Déconnecté de tous les appareils.",

  // Common (extended)
  "common.saving": "Enregistrement…",
  "common.search": "Rechercher…",
  "common.none_found": "Aucun résultat.",

  // Coach · Offres / Produits / Bundles
  "off.meta_title": "Coach · Offres",
  "off.back": "Tableau de bord coach",
  "off.eyebrow": "Offres",
  "off.title": "Offres et produits",
  "off.subtitle": "Gérez séances, forfaits, bundles et produits.",
  "off.tab_offerings": "Offres",
  "off.tab_products": "Produits",
  "off.new": "Nouvelle offre",
  "off.new_bundle": "Bundle",
  "off.hide_inactive": "Masquer inactives",
  "off.empty_title": "Aucune offre pour l'instant",
  "off.empty_sub": "Créez votre première offre — p. ex. une séance 1:1.",
  "off.inactive": "Inactive",
  "off.active": "Active",
  "off.standard": "Standard",
  "off.min": "min",
  "off.edit": "Modifier",
  "off.delete": "Supprimer",
  "off.delete_confirm": "Désactiver cette offre ?",
  "off.deleted": "Offre désactivée.",
  "off.saved": "Offre enregistrée.",
  "off.save_failed": "Impossible d'enregistrer l'offre.",
  "off.min_price": "Prix minimum 14,99 €.",
  "off.dialog_new": "Nouvelle offre",
  "off.dialog_edit": "Modifier l'offre",
  "off.f_type": "Type",
  "off.f_custom_label": "Libellé personnalisé",
  "off.f_custom_ph": "p. ex. Breathwork intensif",
  "off.f_title": "Titre",
  "off.f_title_ph": "p. ex. Séance profonde 90 min",
  "off.f_desc": "Description",
  "off.f_desc_ph": "Ce que reçoit le client…",
  "off.f_duration": "Durée (min)",
  "off.f_price": "Prix (EUR)",
  "off.f_modality": "Format",
  "off.f_online": "En ligne (Zoom)",
  "off.f_inperson": "En présentiel",
  "off.f_location": "Lieu",
  "off.f_location_note": "Note de lieu (optionnel)",
  "off.f_location_online_ph": "Zoom (lien automatique)",
  "off.f_location_ph": "Vienne, AT · Adresse du studio",
  "off.online_hint": "Nous créons un lien Zoom automatiquement dès que votre compte Zoom est connecté.",
  "off.f_start": "Début (ISO)",
  "off.f_start_ph": "2026-09-14T10:00",
  "off.f_end": "Fin (retraite, ISO)",
  "off.f_end_ph": "2026-09-17T18:00",
  "off.f_capacity": "Capacité",
  "off.f_sessions": "Nombre de séances",
  "off.cover": "Image de couverture (optionnel)",
  "off.cover_hint": "Une image chaleureuse 16:9 affichée en haut de l'écran de réservation.",
  "off.cover_library": "Choisir dans la bibliothèque",
  "off.cover_hide": "Fermer la bibliothèque",
  "off.cover_remove": "Retirer",
  "off.toggle_standard": "Marquer comme séance standard",
  "off.toggle_standard_hint": "S'ouvre quand les clients appuient sur « Réserver une séance ».",
  "off.toggle_weekly": "Réservable dans le calendrier hebdo",
  "off.toggle_weekly_hint": "Cette offre apparaît quand le client choisit un créneau.",
  "off.commission_hint": "Commission de la plateforme : 10 % (Free) · 5 % (Coach Pro).",
  "off.bundle_title": "Créer un bundle",
  "off.bundle_pick": "Sélectionnez des offres (min. 2)",
  "off.bundle_discount": "Remise (%)",
  "off.bundle_total": "Total prix individuels",
  "off.bundle_effective": "Prix du bundle",
  "off.bundle_savings": "Économie",
  "off.bundle_none": "Aucune offre combinable. Créez d'abord 2 offres normales.",
  "off.bundle_need2": "Sélectionnez au moins 2 offres.",
  "off.bundle_saved": "Bundle créé.",
  "off.p_new": "Nouveau produit",
  "off.p_empty_title": "Aucun produit pour l'instant",
  "off.p_empty_sub": "Les produits sont des séances simples payées en credits ou via Stripe.",
  "off.p_dialog_new": "Nouveau produit",
  "off.p_dialog_edit": "Modifier le produit",
  "off.p_name": "Nom",
  "off.p_name_ph": "p. ex. Appel découverte",
  "off.p_desc": "Description",
  "off.p_duration": "Durée (min)",
  "off.p_capacity": "Capacité",
  "off.p_group": "Séance de groupe",
  "off.p_payment": "Paiement",
  "off.p_accept_credits": "Accepter les credits",
  "off.p_price_credits": "Prix (credits)",
  "off.p_accept_stripe": "Accepter Stripe",
  "off.p_price_eur": "Prix (EUR)",
  "off.p_saved": "Produit enregistré.",
  "off.p_deleted": "Produit supprimé.",
  "off.p_delete_confirm": "Supprimer ce produit ?",
  "off.p_payment_required": "Sélectionnez au moins un mode de paiement.",
  "off.p_name_required": "Veuillez saisir un nom.",
  "off.type.one_on_one": "Séance 1:1",
  "off.type.group_online": "Cours de groupe (en ligne)",
  "off.type.group_inperson": "Cours de groupe (présentiel)",
  "off.type.retreat": "Retraite",
  "off.type.workshop": "Atelier",
  "off.type.package": "Forfait",
  "off.type.custom": "Personnalisé…",

  // Nav (extended)
  "nav.notifications": "Notifications",
  "nav.inner": "Inner Circle",
  "nav.mein_kreis": "Mon Cercle",
  "nav.pulse": "Pouls clients",
  "nav.offerings": "Offres",
  "nav.bookings": "Réservations",
  "nav.earnings": "Revenus",
  "nav.availability": "Disponibilité",
  "nav.analytics": "Analytics",
  "nav.collab": "Collaboration",
  "nav.content": "Social",
  "nav.profile": "Profil et marque",
  "nav.verify": "Vérification",
  "nav.admin": "Admin",
  "nav.group.start": "Accueil",
  "nav.group.circles": "Cercles",
  "nav.group.sell": "Vendre",
  "nav.group.grow": "Croissance",
  "nav.group.account": "Compte",
  "nav.group.admin": "Admin",
  "nav.experience.journey": "Mon Parcours",
  "nav.experience.practice": "Ma Pratique",
  "nav.group.home": "Accueil",
  "nav.group.explore": "Explorer",
  "nav.group.breathe": "Respirer",
  "nav.group.weva": "WEVA",
  "nav.group.connect": "Se connecter",
  "nav.group.my_space": "Mon Espace",
  "nav.group.overview": "Aperçu",
  "nav.group.clients": "Clients",
  "nav.group.schedule": "Agenda & Plans",
  "nav.group.create": "Créer & Proposer",
  "nav.group.community": "Communauté",
  "nav.group.business": "Business",
  "nav.group.settings": "Réglages",
  "nav.practices": "Pratiques",
  "nav.collectives": "Collectifs",
  "nav.referral": "Parrainage",
  "nav.client_wins": "Réussites clients",
  "home.welcome_back": "Bon retour.",
  "home.welcome_q": "Qu'est-ce qui te ferait du bien aujourd'hui ?",
  "home.action_breathe_title": "Respirer",
  "home.action_breathe_sub": "Retrouve le calme sur le moment",
  "home.action_reflect_title": "Réfléchir",
  "home.action_reflect_sub": "Explore tes pensées et émotions",
  "home.action_weva_title": "Explorer avec WEVA",
  "home.action_weva_sub": "Échange avec ta compagne",
  "home.continue_title": "Poursuis ton parcours",
  "home.continue_empty": "Tes prochaines étapes apparaîtront ici au fil de ton exploration.",
  "home.plan_pending": "Plan hebdomadaire en attente",
  "home.plan_cta": "Voir le plan",
  "home.report_latest": "Dernier rapport WEVA",
  "home.reflections_title": "Tes réflexions",
  "home.stat_journal": "Entrées de journal",
  "home.stat_reports": "Rapports WEVA",
  "home.stat_practices": "Pratiques faites",
  "home.stat_areas": "Domaines explorés",
  "home.more_title": "Plus à explorer",
  "home.open": "Ouvrir",

  // Coach · Profil et Marque
  "prof.meta_title": "Coach · Profil",
  "prof.back": "Tableau de bord coach",
  "prof.eyebrow": "Profil",
  "prof.title": "Profil et marque",
  "prof.subtitle": "Votre profil public de coach et votre marque.",
  "prof.tab_profile": "Profil",
  "prof.tab_branding": "Marque",
  "prof.photo": "Photo de profil",
  "prof.photo_hint": "Photo de profil et bannière (max 2,5 Mo). Carrée recommandée pour la photo.",
  "prof.header": "Image de bannière",
  "prof.upload": "Téléverser",
  "prof.remove": "Retirer",
  "prof.too_large": "Image trop grande (max 2,5 Mo).",
  "prof.name": "Nom",
  "prof.bio": "À propos de vous",
  "prof.bio_ph": "Expliquez aux clients comment vous travaillez…",
  "prof.professions": "Profession(s)",
  "prof.professions_hint": "Choisissez jusqu'à 5 dans la liste.",
  "prof.professions_ph": "Ajouter une profession…",
  "prof.topics": "Thèmes",
  "prof.topics_hint": "Choisissez des thèmes pertinents.",
  "prof.topics_ph": "Ajouter un thème…",
  "prof.methods": "Méthodes",
  "prof.methods_hint": "Choisissez vos méthodes / modalités.",
  "prof.methods_ph": "Ajouter une méthode…",
  "prof.location": "Lieu",
  "prof.location_ph": "Vienne, Autriche",
  "prof.website": "Site web",
  "prof.website_ph": "https://…",
  "prof.languages": "Langues",
  "prof.languages_hint": "Séparées par des virgules, p. ex. Allemand, Anglais.",
  "prof.experience": "Années d'expérience",
  "prof.audience": "Public cible",
  "prof.audience_ph": "Qui accompagnez-vous ?",
  "prof.visibility_public": "Visible publiquement",
  "prof.visibility_hint": "Votre profil apparaît dans le marketplace et l'annuaire des coachs.",
  "prof.saved": "Profil enregistré.",
  "prof.save_failed": "Impossible d'enregistrer le profil.",
  "prof.view_public": "Voir le profil public",

  // Coach · Marque
  "brand.subtitle": "Logo, couleur de marque et pied de page pour les emails clients et votre profil.",
  "brand.locked_title": "La marque est une fonction Coach Pro",
  "brand.locked_sub": "Passez à Coach Pro pour définir logo, couleur et pied de page.",
  "brand.upgrade": "Passer à Coach Pro",
  "brand.logo": "URL du logo",
  "brand.logo_ph": "https://… (PNG/SVG)",
  "brand.color": "Couleur de marque",
  "brand.footer": "Texte de pied de page",
  "brand.footer_ph": "p. ex. « Accompagné avec cœur par … » (max 200 caractères)",
  "brand.saved": "Marque enregistrée.",
  "brand.reset": "Réinitialiser",
  "brand.reset_done": "Réinitialisé aux valeurs par défaut.",

  // Coach · Vérification
  "verify.meta_title": "Coach · Vérification",
  "verify.eyebrow": "Vérification",
  "verify.title": "Vérifiez votre qualification",
  "verify.subtitle": "Téléversez votre certificat pour débloquer toutes les fonctions coach.",
  "verify.status": "Statut actuel",
  "verify.status_approved": "Vérifié",
  "verify.status_pending_ai": "Vérification IA en cours",
  "verify.status_pending_admin": "En cours d'examen",
  "verify.status_rejected": "Rejeté",
  "verify.status_unverified": "Non vérifié",
  "verify.approved_title": "Vous êtes vérifié 🎉",
  "verify.approved_sub": "Toutes les fonctions coach sont débloquées — cercles, offres, réservations.",
  "verify.reviewer_title": "Accès évaluateur actif",
  "verify.reviewer_sub": "Ce compte contourne la vérification pour les évaluations.",
  "verify.step_dpa_title": "Accepter l'accord de responsabilité conjointe",
  "verify.step_dpa_sub": "Accord de protection des données pour responsables conjoints.",
  "verify.dpa_accept": "J'accepte l'accord de responsabilité conjointe.",
  "verify.dpa_accepted": "Accord accepté.",
  "verify.accept_btn": "Accepter",
  "verify.step_upload_title": "Téléverser le certificat",
  "verify.step_upload_sub": "Photo/scan de votre certificat (PNG/JPEG, max 4 Mo).",
  "verify.upload_btn": "Téléverser le certificat",
  "verify.reupload_btn": "Re-téléverser",
  "verify.uploading": "Téléversement…",
  "verify.upload_failed": "Échec du téléversement.",
  "verify.too_large": "Image trop grande (max 4 Mo).",
  "verify.pending_admin_title": "Transmis pour examen",
  "verify.pending_admin_sub": "Une personne examine votre certificat. Vous serez notifié une fois approuvé.",
  "verify.rejected_title": "Vérification rejetée",
  "verify.rejected_sub": "Veuillez téléverser un certificat plus net.",
  "verify.ai_verdict": "Évaluation IA",
  "verify.ai_subject": "Domaine",
  "verify.ai_confidence": "Confiance",

  // Notifications
  "notif.meta_title": "Notifications",
  "notif.title": "Notifications",
  "notif.subtitle": "Mises à jour sur les réservations, cercles et votre compte.",
  "notif.empty_title": "Aucune notification",
  "notif.empty_sub": "Les nouvelles mises à jour apparaîtront ici.",
  "notif.mark_all": "Tout marquer comme lu",
  "notif.marked_all": "Tout marqué comme lu.",

  // Common (Phase 4c)
  "common.refresh": "Actualiser",

  // Coach · Social & Contenu (Phase 4c)
  "soc.meta_title": "Coach · Social",
  "soc.back": "Tableau de bord coach",
  "soc.eyebrow": "Social",
  "soc.title": "Social & Contenu",
  "soc.subtitle": "Publications, stories, mur de stories, messages et WEVA — tout au même endroit.",
  "soc.tab_posts": "Publications",
  "soc.tab_stories": "Stories",
  "soc.tab_wall": "Mur de stories",
  "soc.tab_impact": "Impact",
  "soc.tab_messages": "Messages",
  "soc.tab_weva": "WEVA",

  "soc.posts_new": "Nouvelle publication",
  "soc.posts_stat_posts": "Publications",
  "soc.posts_stat_unlocks": "Déverrouillages",
  "soc.posts_stat_credits": "Crédits gagnés",
  "soc.posts_stat_reports": "Signalements",
  "soc.posts_empty_title": "Pas encore de publications",
  "soc.posts_empty_sub": "Crée ta première publication pour le fil.",
  "soc.posts_unlocks": "{n} déverrouillages",
  "soc.posts_credits": "{n} crédits",
  "soc.posts_hidden": "Masquée",
  "soc.posts_dialog_title": "Nouvelle publication",
  "soc.posts_f_title": "Titre",
  "soc.posts_f_title_ph": "Titre de la publication",
  "soc.posts_f_body": "Texte",
  "soc.posts_f_body_ph": "Partage une impulsion, une réflexion ou un exercice…",
  "soc.posts_paid": "Contenu payant",
  "soc.posts_paid_sub": "Les clients paient des crédits pour débloquer.",
  "soc.posts_price": "Prix (crédits)",
  "soc.posts_price_ph": "p. ex. 10",
  "soc.posts_publish": "Publier",
  "soc.posts_publishing": "Publication…",
  "soc.posts_created": "Publication publiée.",
  "soc.posts_title_required": "Saisis un titre.",
  "soc.posts_price_required": "Le contenu payant nécessite au moins 1 crédit.",
  "soc.posts_create_failed": "La publication n'a pas pu être créée.",

  "soc.stories_new": "Nouvelle story",
  "soc.stories_sub": "Stories de 24 heures et temps forts permanents.",
  "soc.stories_empty_title": "Pas encore de stories",
  "soc.stories_empty_sub": "Partage une courte story de 24 heures avec tes clients.",
  "soc.stories_kind_image": "Image",
  "soc.stories_kind_text": "Texte",
  "soc.stories_pick": "Choisir une image",
  "soc.stories_replace": "Remplacer l'image",
  "soc.stories_pick_hint": "Choisis une image (max. 10 Mo).",
  "soc.stories_text_ph": "Que veux-tu partager ?",
  "soc.stories_ttl_hint": "Les stories disparaissent automatiquement après 24 heures.",
  "soc.stories_dialog_title": "Nouvelle story",
  "soc.stories_publish": "Partager",
  "soc.stories_publishing": "Partage…",
  "soc.stories_created": "Story partagée.",
  "soc.stories_too_large": "Image trop grande (max. 10 Mo).",
  "soc.stories_uploading": "Téléversement…",
  "soc.stories_upload_failed": "L'image n'a pas pu être téléversée.",
  "soc.stories_need_content": "Choisis une image ou saisis du texte.",
  "soc.stories_create_failed": "La story n'a pas pu être créée.",
  "soc.stories_status_active": "Active",
  "soc.stories_status_expired": "Expirée",
  "soc.stories_highlight_badge": "Temps fort",
  "soc.stories_views": "{n} vues",
  "soc.stories_pin": "Épingler",
  "soc.stories_unpin": "Détacher",
  "soc.stories_delete_confirm": "Vraiment supprimer cette story ?",
  "soc.stories_deleted": "Story supprimée.",
  "soc.stories_pinned": "Épinglée comme temps fort.",
  "soc.stories_unpinned": "Temps fort retiré.",
  "soc.stories_pin_title": "Épingler comme temps fort",
  "soc.stories_pin_sub": "Donne un titre court au temps fort (facultatif).",
  "soc.stories_pin_ph": "p. ex. Témoignages",
  "soc.stories_pin_save": "Épingler",

  "soc.wall_new": "Nouveau moment",
  "soc.wall_sub": "Partage publiquement des moments clients avec double consentement.",
  "soc.wall_empty_title": "Pas encore de moments",
  "soc.wall_empty_sub": "Capture une étape particulière — avec le consentement du client.",
  "soc.wall_create_title": "Créer un moment",
  "soc.wall_client": "Client",
  "soc.wall_kind": "Type",
  "soc.wall_title_lbl": "Titre",
  "soc.wall_title_ph": "Titre court et puissant",
  "soc.wall_body_lbl": "Texte",
  "soc.wall_body_ph": "Que s'est-il passé ? Décris le moment…",
  "soc.wall_metric_lbl": "Mesure (facultatif)",
  "soc.wall_metric_ph": "p. ex. −40 % de stress",
  "soc.wall_color_lbl": "Couleur",
  "soc.wall_consent_note": "La publication nécessite ton consentement ET celui du client.",
  "soc.wall_missing_fields": "Remplis client, titre et texte.",
  "soc.wall_save": "Enregistrer le moment",
  "soc.wall_saved": "Moment créé.",
  "soc.wall_kind_reflection": "Réflexion",
  "soc.wall_kind_wellbeing_shift": "Bien-être",
  "soc.wall_kind_streak": "Série",
  "soc.wall_kind_quote": "Citation",
  "soc.wall_kind_milestone": "Jalon",
  "soc.wall_status_draft": "Brouillon",
  "soc.wall_status_published": "Publié",
  "soc.wall_status_unlisted": "Non listé",
  "soc.wall_coach_consent": "Ton consentement",
  "soc.wall_client_consent": "Consentement du client",
  "soc.wall_consent_granted": "Accordé",
  "soc.wall_consent_pending": "En attente",
  "soc.wall_consent_waiting_client": "En attente du client",
  "soc.wall_review_agree": "Vérifier et accepter",
  "soc.wall_review": "Voir le consentement",
  "soc.wall_coach_consent_title": "Ton consentement",
  "soc.wall_coach_consent_body": "Avec ton consentement, ce moment peut être partagé publiquement une fois que le client accepte aussi.",
  "soc.wall_show_name": "Afficher mon nom",
  "soc.wall_show_name_sub": "Ton nom apparaît sur le moment publié.",
  "soc.wall_consent_grant": "Accepter",
  "soc.wall_consent_revoke": "Retirer",
  "soc.wall_publish": "Publier",
  "soc.wall_unpublish": "Dépublier",
  "soc.wall_archive": "Archiver",
  "soc.wall_archive_confirm": "Vraiment archiver ce moment ?",
  "soc.wall_published_ok": "Moment publié.",
  "soc.wall_publish_needs_consents": "Les deux consentements sont requis pour publier.",

  "soc.impact_sub": "Combien de personnes tes réussites touchent.",
  "soc.impact_empty_title": "Pas encore de moments",
  "soc.impact_empty_sub": "Dès que tu publies des réussites clients, tu verras ici vues, partages et tendances.",
  "soc.impact_overall": "Vue d'ensemble",
  "soc.impact_views": "Vues",
  "soc.impact_shares": "Partages",
  "soc.impact_previews": "Ouvertures d'aperçu",
  "soc.impact_engagement": "Engagement",
  "soc.impact_engagement_hint": "Vues ÷ ouvertures d'aperçu",
  "soc.impact_share_rate": "Taux de partage",
  "soc.impact_share_hint": "Partages ÷ vues",
  "soc.impact_trend": "Tendance des 7 derniers jours",
  "soc.impact_views_7d": "Vues des 7 derniers jours",
  "soc.impact_vs_prev": "vs. précédent",
  "soc.impact_ranking": "Classement d'impact par moment",

  "soc.msg_sub": "Messages directs et chats partagés.",
  "soc.msg_shared": "Chats partagés",
  "soc.msg_dms": "Messages directs",
  "soc.msg_empty": "Pas encore de messages. Les clients et coachs apparaîtront ici.",
  "soc.msg_three_way": "Accompagnement conjoint",
  "soc.msg_input_ph": "Écris un message…",
  "soc.msg_empty_thread": "Pas encore de messages. Écris le premier 👋",
  "soc.msg_deleted": "Message supprimé",
  "soc.msg_delete_confirm": "Supprimer ce message ?",

  "soc.weva_sub": "Tendances anonymisées de ton cercle intérieur — avec des impulsions de coaching.",
  "soc.weva_trends_title": "Tendances anonymisées du cercle",
  "soc.weva_trends_clients": "{a} sur {t} actifs · {d} jours",
  "soc.weva_trends_emotions": "Top émotions",
  "soc.weva_trends_themes": "Top thèmes",
  "soc.weva_trends_beliefs": "Top croyances",
  "soc.weva_trends_practices": "Top pratiques",
  "soc.weva_intro": "Demande-moi des schémas dans ton cercle intérieur — émotions, thèmes, pratiques — et je te donnerai des impulsions de coaching.",
  "soc.weva_placeholder": "Demande quelque chose à WEVA…",
  "soc.weva_thinking": "WEVA réfléchit…",
  "soc.weva_clear": "Effacer l'historique",
  "soc.weva_clear_confirm": "Effacer tout l'historique WEVA ?",
  "soc.weva_locked_title": "Le chat WEVA coach est une fonction Coach Pro",
  "soc.weva_locked_sub": "Passe à Coach Pro pour utiliser WEVA avec des aperçus anonymisés du cercle.",
  "soc.weva_upgrade": "Passer à Coach Pro",
  "soc.weva_send_failed": "Le message n'a pas pu être envoyé.",

  // Common (Phase 4d)
  "common.close": "Fermer",
  "nav.methods": "Méthodes",
  "nav.plans": "Plans",

  // Coach · Méthodes & Modèles (Phase 4d)
  "cm.meta_title": "Coach · Méthodes",
  "cm.back": "Tableau de bord coach",
  "cm.eyebrow": "Méthodes",
  "cm.title": "Méthodes & Modèles",
  "cm.subtitle": "Crée tes propres exercices, gère-les, enregistre-les comme modèles et mesure leur impact.",
  "cm.tab_methods": "Méthodes",
  "cm.tab_templates": "Modèles",
  "cm.tab_breathwork": "Respiration",
  "cm.tab_stats": "Statistiques",
  "cm.tab_social": "Partagé dans le fil",
  "cm.social_title": "Méthodes dans ton fil social",
  "cm.social_sub": "Les méthodes partagées (gratuites ou payantes) apparaissent comme publications dans ton fil — avec vues et achats.",
  "cm.social_cta": "Voir mes publications du fil",

  "cm.new_method": "Nouvelle méthode",
  "cm.filter_all": "Toutes",
  "cm.filter_shared": "Partagées",
  "cm.filter_template": "Modèles",
  "cm.no_methods_title": "Pas encore de méthode",
  "cm.no_methods_sub": "Commence par une méditation audio ou un jeu de questions.",
  "cm.no_templates": "Pas encore de modèle",
  "cm.create_first": "Créer ta première méthode",
  "cm.edit": "Modifier",
  "cm.tpl": "Modèle",
  "cm.duplicated": "Méthode dupliquée.",
  "cm.deleted": "Méthode supprimée.",
  "cm.delete_confirm": "Vraiment supprimer la méthode « {title} » ?",

  "cm.kind_audio": "Méditation audio",
  "cm.kind_audio_sub": "Séance guidée voix/musique.",
  "cm.kind_video": "Guide vidéo",
  "cm.kind_video_sub": "Courte vidéo avec toi comme coach.",
  "cm.kind_breathwork": "Respiration",
  "cm.kind_breathwork_sub": "Référence à ta propre technique de respiration.",
  "cm.kind_questions": "Jeu de questions",
  "cm.kind_questions_sub": "Questions de réflexion, réponses libres.",
  "cm.kind_combo": "Méthode combinée",
  "cm.kind_combo_sub": "Plusieurs blocs à la suite.",
  "cm.kind_body_scan": "Scan corporel",
  "cm.kind_body_scan_sub": "Guider l'attention à travers le corps.",
  "cm.kind_gratitude": "Gratitude",
  "cm.kind_gratitude_sub": "3 choses · focus sur le cœur.",
  "cm.kind_visualization": "Visualisation",
  "cm.kind_visualization_sub": "Images intérieures & voyage futur.",
  "cm.kind_movement": "Mouvement",
  "cm.kind_movement_sub": "Yoga · somatique · shaking.",
  "cm.kind_check_in": "Check-in",
  "cm.kind_check_in_sub": "Pouls quotidien · émotion & besoin.",

  "cm.vis_private": "Privé",
  "cm.vis_shared_with_clients": "Clients",
  "cm.vis_public": "Public",

  "cm.pick_title": "Créer une méthode",
  "cm.pick_hint": "Choisis le type de ta nouvelle méthode.",
  "cm.editing": "Modifier la méthode",
  "cm.change_kind": "Changer de type",
  "cm.save_new": "Enregistrer la méthode",
  "cm.saved": "Méthode enregistrée.",
  "cm.save_failed": "La méthode n'a pas pu être enregistrée.",
  "cm.load_failed": "La méthode n'a pas pu être chargée.",
  "cm.title_required": "Saisis un titre.",
  "cm.cover": "Image de couverture (facultatif)",
  "cm.f_title": "Titre",
  "cm.title_ph": "Court & clair (max. 140 car.)",
  "cm.f_subtitle": "Sous-titre (facultatif)",
  "cm.subtitle_ph": "p. ex. « Arriver & lâcher prise »",
  "cm.description": "Description",
  "cm.description_ph": "À quoi sert cette méthode ?",
  "cm.suggest_titles": "Suggestions IA",
  "cm.ai_no_titles": "Aucune suggestion trouvée. Rédige une description plus détaillée.",
  "cm.ai_locked": "Les suggestions de titre par IA sont une fonction Coach Pro.",
  "cm.audio_field": "Audio",
  "cm.video_field": "Vidéo",
  "cm.pick_technique": "Ta propre technique de respiration",
  "cm.no_bw_yet": "Crée d'abord ton propre exercice de respiration dans l'app mobile.",
  "cm.questions": "Questions",
  "cm.no_questions": "Pas encore de question. Ajoute la première.",
  "cm.q_required": "Obligatoire",
  "cm.q_prompt_ph": "Question, p. ex. « Comment te sens-tu maintenant ? »",
  "cm.q_add": "Ajouter une question",
  "cm.steps": "Blocs (ordre)",
  "cm.steps_empty": "Pas encore de bloc. Ajoute p. ex. scan corporel + respiration + gratitude.",
  "cm.step_title_ph": "Titre du bloc, p. ex. « 3 minutes de scan corporel »",
  "cm.step_body_ph": "Texte d'instruction…",
  "cm.step_duration_ph": "Durée (secondes)",
  "cm.step_breathwork": "Respiration",
  "cm.step_audio": "Audio",
  "cm.step_video": "Vidéo",
  "cm.step_body_scan": "Corps",
  "cm.step_gratitude": "Gratitude",
  "cm.step_visualization": "Vision",
  "cm.step_movement": "Mouvement",
  "cm.step_questions": "Questions",
  "cm.step_check_in": "Check-in",
  "cm.step_timer": "Minuteur",
  "cm.step_text": "Texte",
  "cm.settings": "Réglages",
  "cm.duration_min": "Durée (min)",
  "cm.preview_seconds": "Aperçu (sec)",
  "cm.visibility": "Visibilité",
  "cm.price": "Prix (crédits)",
  "cm.is_template": "Comme modèle",
  "cm.tpl_on": "Modèle actif",
  "cm.tpl_off": "Enregistrer comme modèle",
  "cm.ethics_title": "Coaching, pas un substitut à la thérapie",
  "cm.ethics_body": "Formule ta méthode comme une offre de coaching. Elle ne remplace pas un diagnostic médical ni une psychothérapie. En cas de trauma, de pensées suicidaires ou de symptômes aigus, oriente vers un·e professionnel·le.",

  "cm.media_url_ph": "Colle une URL ou téléverse un fichier",
  "cm.media_upload": "Téléverser",
  "cm.media_uploading": "Téléversement…",
  "cm.media_uploaded": "Fichier téléversé.",
  "cm.media_upload_failed": "Le fichier n'a pas pu être téléversé.",

  "cm.preview_lbl": "Aperçu",
  "cm.preview_running": "Les clients entendent/voient exactement cet extrait avant d'acheter.",
  "cm.preview_done": "Aperçu terminé.",

  "cm.stats_methods": "Méthodes",
  "cm.stats_opens": "Ouvertures",
  "cm.stats_completions": "Terminées",
  "cm.stats_rate": "Taux",
  "cm.stats_top_completed": "Favorites",
  "cm.stats_top_opened": "Plus ouvertes",
  "cm.stats_empty": "Pas encore de données. Dès que les clients utilisent tes méthodes, tes favorites apparaissent ici.",

  "cm.templates_sub": "Techniques signature réutilisables avec de nouveaux clients. Copie-en une pour l'adapter.",
  "cm.no_templates_long": "Pas encore de modèle. Ouvre une méthode et active l'interrupteur modèle lors de l'enregistrement.",
  "cm.tpl_use": "Utiliser",
  "cm.tpl_copied": "Modèle copié — modifie maintenant la copie.",
  "cm.tpl_done": "{n}× terminée",

  // Coach · Plans (Phase 4d partie 2)
  "pl.meta_title": "Coach · Plans",
  "pl.back": "Tableau de bord coach",
  "pl.eyebrow": "Plans",
  "pl.title": "Plans",
  "pl.subtitle": "Attribue des plans quotidiens aux clients et partage des plans de respiration hebdomadaires.",
  "pl.tab_daily": "Plans quotidiens",
  "pl.tab_weekly": "Plans hebdo",

  "pl.d_sub": "Attribue aux clients des tâches avec date, heure et technique.",
  "pl.d_new": "Attribuer un plan",
  "pl.d_empty_title": "Aucun plan attribué",
  "pl.d_empty_sub": "Attribue une tâche à ton premier client.",
  "pl.d_done": "Fait",
  "pl.d_pending": "En attente",
  "pl.d_missing": "Choisis un titre et au moins un client.",
  "pl.d_assigned": "Plan attribué à {n} client(s).",
  "pl.d_title_ph": "Titre, p. ex. Respiration du soir",
  "pl.d_desc_ph": "Description (facultatif)",
  "pl.d_date": "Date",
  "pl.d_time": "Heure",
  "pl.d_reminder": "Rappel (min)",
  "pl.d_technique": "Technique de respiration (facultatif)",
  "pl.d_clients": "Clients",
  "pl.d_no_clients": "Aucun client éligible. Ajoute d'abord quelqu'un à un cercle.",

  "pl.w_mobile_note": "Tu crées et modifies les plans hebdomadaires dans l'app mobile. Ici tu vois tes plans et les partages avec des clients ou des cercles.",
  "pl.w_my_master": "Mes plans maîtres",
  "pl.w_no_plans": "Pas encore de plan hebdo. Crée ton premier ici même.",
  "pl.w_slots": "{n} blocs",
  "pl.w_flexible": "flexible",
  "pl.w_send": "Envoyer",
  "pl.w_sent": "Envoyés aux clients",
  "pl.w_sent_hint": "Les plans partagés apparaissent ici avec leur statut.",
  "pl.w_to_client": "Au client",
  "pl.w_share_target": "Partager le plan",
  "pl.w_tab_single": "Individuel",
  "pl.w_tab_multi": "Plusieurs",
  "pl.w_tab_circle": "Cercle",
  "pl.w_no_clients": "Aucun client.",
  "pl.w_no_circles": "Aucun cercle.",
  "pl.w_select_all": "Tous",
  "pl.w_deselect_all": "Aucun",
  "pl.w_circle_members": "{n} membres",
  "pl.w_overwrite": "Écraser les plans existants",
  "pl.w_msg_ph": "Message facultatif…",
  "pl.w_send_plan": "Envoyer le plan",
  "pl.w_sending": "Envoi…",
  "pl.w_sent_ok": "Plan envoyé.",
  "pl.w_multi_summary": "Envoyés : {ok} · Échoués : {fail}",
  "pl.w_circle_summary": "Envoyés : {sent} · Ignorés : {skipped} · Mis à jour : {updated}",
  "pl.w_web_note": "Crée et modifie les plans hebdomadaires ici même. Les copies déjà envoyées aux clients restent inchangées.",
  "pl.w_new": "Nouveau plan hebdo",
  "pl.w_create_plan": "Créer le plan",
  "pl.w_editor_new": "Créer un plan hebdo",
  "pl.w_editor_edit": "Modifier le plan hebdo",
  "pl.w_editor_sub": "Nomme le plan, choisis le début de semaine et ajoute des blocs par jour.",
  "pl.w_default_name": "Ma pratique hebdo",
  "pl.w_name": "Nom",
  "pl.w_name_ph": "p. ex. Ma pratique hebdo",
  "pl.w_desc": "Description",
  "pl.w_desc_ph": "Facultatif",
  "pl.w_week_start": "Début de semaine (lun)",
  "pl.w_slots_lbl": "Blocs",
  "pl.w_add_slot": "Bloc",
  "pl.w_no_slots": "Pas encore de bloc. Ajoute des exercices pour la semaine.",
  "pl.w_slot_day": "Jour",
  "pl.w_slot_time": "Heure",
  "pl.w_slot_duration": "Durée (min)",
  "pl.w_slot_category": "Catégorie",
  "pl.w_slot_technique": "Exercice",
  "pl.w_slot_reminder": "Rappel",
  "pl.w_slot_note": "Note (facultatif)",
  "pl.w_slot_save": "Enregistrer le bloc",
  "pl.w_cat_breathing": "Respiration",
  "pl.w_cat_deep_within": "Deep Within",
  "pl.w_cat_rdr": "RDR",
  "pl.w_cat_custom": "Ma respiration",
  "pl.w_cat_coach_method": "Mes méthodes",
  "pl.w_days": "Lun,Mar,Mer,Jeu,Ven,Sam,Dim",
  "pl.w_rem_start": "Au début",
  "pl.w_rem_min": "{n} min avant",
  "pl.w_rem_hour": "1 heure avant",
  "pl.w_need_name": "Saisis un nom.",
  "pl.w_need_slots": "Ajoute au moins un bloc.",
  "pl.w_need_tech": "Choisis un exercice.",
  "pl.w_created": "Plan hebdo créé.",
  "pl.w_updated": "Plan hebdo mis à jour.",
  "pl.w_save_failed": "Le plan hebdo n'a pas pu être enregistré.",
  "pl.w_delete_confirm": "Supprimer le plan hebdo « {name} » ?",
  "pl.w_deleted": "Plan hebdo supprimé.",
  "pl.w_no_custom": "Pas encore d'exercice de respiration personnel. Crées-en un dans l'onglet Méthodes.",
  "pl.w_no_methods": "Pas encore de méthodes.",

  // Coach · Techniques de respiration (amélioration)
  "bw.new": "Nouvel exercice",
  "bw.edit_existing": "Modifier l'exercice",
  "bw.name": "Nom de l'exercice",
  "bw.name_ph": "p. ex. Respiration carrée 4-4-4-4",
  "bw.rhythm": "Rythme (secondes)",
  "bw.inhale": "Insp.",
  "bw.hold_in": "Rét.",
  "bw.exhale": "Exp.",
  "bw.hold_out": "Rét.",
  "bw.length": "Longueur",
  "bw.by_reps": "Répétitions",
  "bw.by_duration": "Durée totale",
  "bw.reps": "Tours",
  "bw.duration_s": "Secondes",
  "bw.estimated": "Estimé",
  "bw.cycle": "Cycle",
  "bw.notes": "Note pour le client (facultatif)",
  "bw.notes_ph": "p. ex. Le soir avant de dormir",
  "bw.save_new": "Enregistrer l'exercice",
  "bw.saved": "Exercice enregistré.",
  "bw.save_failed": "L'exercice n'a pas pu être enregistré.",
  "bw.delete_confirm": "Supprimer l'exercice « {name} » ?",
  "bw.deleted": "Exercice supprimé.",
  "bw.saved_list": "Tes exercices",
  "bw.empty": "Aucun exercice personnel enregistré.",

  // Nav (Phase 4e)
  "nav.ads": "Publicité",
  "nav.recommendations": "Recommandations",

  // ── Analytics approfondies (Phase 4e · e1) ──
  "an.back": "Tableau de bord coach",
  "an.eyebrow": "Analytics",
  "an.title": "Analytics approfondies",
  "an.subtitle": "12 cartes : croissance, séances, WEVA, contenu, revenus, comparaisons et rapports.",
  "an.period_week": "Semaine",
  "an.period_month": "Mois",
  "an.period_quarter": "Trimestre",
  "an.period_year": "Année",
  "an.period_all": "Total",
  "an.period_sync": "La période s'applique à toutes les cartes temporelles.",
  "an.pro_locked_title": "Coach Pro débloque toute la profondeur",
  "an.pro_locked_sub": "Les analyses de revenus, de rétention et les rapports font partie de Coach Pro.",
  "an.pro_upgrade": "Passer à Coach Pro",
  "an.insights_kicker": "Plus forte évolution",
  "an.insights_vs_prev": "vs. semaine dernière",
  "an.insights_tap": "Voir les 3 plus grands changements",
  "an.insights_modal_title": "Tes plus grands changements",
  "an.insights_modal_sub": "Les plus fortes évolutions par rapport à la semaine dernière.",
  "an.insights_empty": "Pas encore assez de données pour comparer.",
  "an.tip_button": "Qu'est-ce que ça me montre ?",
  "an.tip_loading": "WEVA lit les chiffres…",
  "an.tip_error": "Impossible de charger une explication pour le moment.",
  "an.tip_source": "Explication IA basée sur tes données",
  "an.t1": "Profil en un coup d'œil",
  "an.t2": "Croissance des clients",
  "an.t3": "Séances et réservations",
  "an.t4": "Analyse de groupe WEVA",
  "an.t5": "Performance des plans hebdo",
  "an.t6": "Performance du contenu",
  "an.t7": "Inner vs. Local Circle",
  "an.t8": "Performance d'affiliation",
  "an.t9": "Engagement et communication",
  "an.t10": "Objectifs des clients",
  "an.t11": "Comparaison de périodes",
  "an.t12": "Rapports et export",
  "an.t1_clients": "Clients au total",
  "an.t1_ic": "Inner",
  "an.t1_lc": "Local",
  "an.t1_general": "Général",
  "an.t1_sessions": "Séances terminées",
  "an.t1_offerings": "Offres actives",
  "an.t1_gross": "Revenu brut",
  "an.t1_since": "Membre depuis",
  "an.t2_new": "Nouveaux",
  "an.t2_churn": "Départs",
  "an.t2_net": "Net",
  "an.t2_cumulative": "Cumulé",
  "an.t3_total": "Réservations",
  "an.t3_completed": "Terminées",
  "an.t3_cancelled": "Annulées",
  "an.t3_cancel_rate": "Taux d'annulation",
  "an.t3_avg_dur": "Durée moyenne",
  "an.t3_util": "Taux d'occupation",
  "an.t3_hours": "Heures populaires",
  "an.t3_weekdays": "Jours populaires",
  "an.t4_empty": "Pas encore de données WEVA de tes clients.",
  "an.t4_client_count": "Clients",
  "an.t4_reports": "Rapports",
  "an.t4_emotions": "Émotions principales",
  "an.t4_emo_drop": "Résolution émotionnelle · 90 derniers jours",
  "an.t4_emo_drop_hint": "Basé sur {n} séances · ≥2 par émotion",
  "an.t4_themes": "Thèmes",
  "an.t4_trend": "Tendance d'intensité",
  "an.t4_before": "Avant",
  "an.t4_after": "Après",
  "an.t5_empty": "Aucun plan hebdomadaire envoyé.",
  "an.t5_sent": "Envoyés",
  "an.t5_open_rate": "Taux d'ouverture",
  "an.t5_completion": "Taux de complétion",
  "an.t5_sessions_done": "Séances faites",
  "an.t5_top_tech": "Techniques principales",
  "an.t6_empty": "Aucun contenu publié.",
  "an.t6_posts": "Publications",
  "an.t6_views": "Vues",
  "an.t6_favorites": "Favoris",
  "an.t6_revenue": "Revenu",
  "an.t6_top": "Meilleur contenu",
  "an.t7_empty": "Pas encore de données de cercle.",
  "an.t7_ic": "Inner Circle",
  "an.t7_lc": "Local Circle",
  "an.t7_members": "Membres",
  "an.t7_revenue": "Revenu",
  "an.t7_messages": "Messages",
  "an.t7_snapshots": "Livraisons",
  "an.t8_empty": "Aucun parrainage via ton code.",
  "an.t8_referrals": "Parrainages",
  "an.t8_conversion": "Conversion",
  "an.t8_revenue": "Revenu",
  "an.t8_active_phases": "Phases actives",
  "an.t8_phase_break": "Répartition par phase",
  "an.t9_msgs": "Messages envoyés",
  "an.t9_response": "Réponse moyenne",
  "an.t9_snap_delivered": "Livraisons faites",
  "an.t9_snap_pending": "Livraisons en attente",
  "an.t9_circle_activity": "Activité des cercles",
  "an.t10_empty": "Pas encore d'objectifs clients.",
  "an.t10_client_count": "Clients",
  "an.t10_goals_total": "Objectifs au total",
  "an.t10_goals_done": "Objectifs atteints",
  "an.t10_beliefs_total": "Croyances",
  "an.t10_beliefs_trans": "Transformées",
  "an.t10_top_cats": "Catégories top",
  "an.t10_show_examples": "Afficher des exemples anonymes",
  "an.t10_hide_examples": "Masquer les exemples",
  "an.t10_examples_note": "Anonymisé — sans noms, uniquement catégorie et formulation.",
  "an.t10_goals": "Objectifs",
  "an.t10_beliefs": "Croyances",
  "an.t11_period_a": "Période A",
  "an.t11_period_b": "Période B",
  "an.t11_gross": "Revenu brut",
  "an.t11_bookings": "Réservations",
  "an.t11_msgs": "Messages",
  "an.t11_new_clients": "Nouveaux clients",
  "an.t12_hint": "Choisis des cartes et exporte un rapport personnalisé.",
  "an.t12_templates": "Modèles enregistrés",
  "an.t12_templates_none": "Aucun modèle enregistré.",
  "an.t12_template_run": "Exporter",
  "an.t12_pick": "Cartes pour le rapport",
  "an.t12_all_on": "Tout",
  "an.t12_all_off": "Aucune",
  "an.t12_tpl_name_ph": "Nom du modèle",
  "an.t12_tpl_save": "Enregistrer le modèle",
  "an.t12_tpl_saved": "Modèle enregistré.",
  "an.t12_pdf": "PDF",
  "an.t12_csv": "CSV",
  "an.t12_xlsx": "Excel",
  "an.t12_download_failed": "Échec du téléchargement. Réessaie.",

  // ── Publicité / Campagnes (Phase 4e · e2) ──
  "ads.back": "Tableau de bord coach",
  "ads.eyebrow": "Publicité",
  "ads.title": "Campagnes publicitaires",
  "ads.subtitle": "Promeus des publications et des offres avec une audience IA, un budget et des analyses.",
  "ads.wallet": "Solde publicitaire",
  "ads.wallet_hint": "Solde pour les campagnes à l'impression ou au clic.",
  "ads.topup": "Recharger",
  "ads.topup_ok": "Solde publicitaire rechargé.",
  "ads.topup_title": "Recharger le solde publicitaire",
  "ads.topup_sub": "Solde actuel : {balance}",
  "ads.topup_custom": "Montant personnalisé",
  "ads.topup_confirm": "Recharger {amount}",
  "ads.topup_note": "Paiement sécurisé via Stripe. Facture UE incluse.",
  "ads.topup_billing": "Complète d'abord tes informations de facturation (Compte).",
  "ads.new_campaign": "Nouvelle campagne",
  "ads.new_campaign_sub": "Créée en 3 étapes — avec audience IA.",
  "ads.offerings": "Gérer les offres",
  "ads.offerings_sub": "Modifie séances, forfaits et prix.",
  "ads.reco_title": "Suggestions à promouvoir",
  "ads.reco_sub": "Choisies automatiquement selon la résonance organique.",
  "ads.reco_cta": "Promouvoir maintenant",
  "ads.reco_reason_default": "Forte résonance organique.",
  "ads.reco_reason_views": "Beaucoup de vues — idéal pour passer à l'échelle.",
  "ads.reco_reason_reactions": "Beaucoup de réactions de ta communauté.",
  "ads.reco_reason_comments": "Commentaires et conversations animés.",
  "ads.reco_reason_bookmarks": "Souvent enregistré — intérêt réel.",
  "ads.reco_reason_freshness": "Frais et actuel — parfait pour un boost.",
  "ads.reco_reason_bookings": "Bons chiffres de réservation.",
  "ads.reco_reason_favorites": "Souvent mis en favori.",
  "ads.impressions": "Impressions",
  "ads.clicks": "Clics",
  "ads.ctr": "CTR",
  "ads.total_spent": "Dépensé",
  "ads.budget_left": "Budget restant",
  "ads.my_campaigns": "Mes campagnes",
  "ads.empty": "Aucune campagne. Crée la première.",
  "ads.untitled": "Sans titre",
  "ads.subject_post": "Publication",
  "ads.subject_offering": "Offre",
  "ads.billing_impression": "par impression",
  "ads.billing_click": "par clic",
  "ads.status_all": "Toutes",
  "ads.status_running": "En cours",
  "ads.status_paused": "En pause",
  "ads.status_pending_review": "En révision",
  "ads.status_approved": "Approuvée",
  "ads.status_completed": "Terminée",
  "ads.status_rejected": "Refusée",
  "ads.pause": "Mettre en pause",
  "ads.resume": "Reprendre",
  "ads.stop": "Arrêter",
  "ads.view_details": "Détails",
  "ads.spent_of": "{spent} sur {total} dépensé",
  "ads.new_title": "Nouvelle campagne",
  "ads.new_step": "Étape {n} sur 3",
  "ads.pick_subject": "Que veux-tu promouvoir ?",
  "ads.pick_subject_hint": "Choisis une de tes publications ou offres.",
  "ads.subject_offerings": "Offres",
  "ads.subject_posts": "Publications",
  "ads.no_subjects": "Aucune publication ni offre à promouvoir pour l'instant.",
  "ads.audience": "Audience",
  "ads.ai_button": "Suggestion IA",
  "ads.ai_ok": "Audience suggérée.",
  "ads.ai_why": "Pourquoi cette audience",
  "ads.field_themes": "Thèmes",
  "ads.field_regions": "Régions",
  "ads.field_education_backgrounds": "Formation",
  "ads.field_life_situations": "Situations de vie",
  "ads.field_other_traits": "Autres traits",
  "ads.budget": "Budget",
  "ads.daily_eur": "Par jour (€)",
  "ads.duration_days": "Durée (jours)",
  "ads.total": "Budget total",
  "ads.billing_mode": "Facturation",
  "ads.payment": "Paiement",
  "ads.pay_stripe": "Stripe",
  "ads.pay_credits": "Solde",
  "ads.credits_short": "Solde insuffisant — recharge s'il te plaît.",
  "ads.no_credits": "Ton solde publicitaire est insuffisant.",
  "ads.new_ok": "Campagne créée — en révision.",
  "ads.next": "Suivant",
  "ads.back_step": "Retour",
  "ads.launch": "Lancer la campagne",
  "ads.detail_title": "Campagne",
  "ads.detail_not_found": "Campagne introuvable.",
  "ads.range": "{n} jours",
  "ads.chart_title": "Impressions et clics par jour",
  "ads.range_totals": "Total · {n} jours",

  // ── Recommandations (Phase 4e · e3) ──
  "recs.back": "Tableau de bord coach",
  "recs.eyebrow": "Recommandations",
  "recs.title": "Recommandations",
  "recs.subtitle": "Impact de tes recommandations de publications et recommandations chaleureuses sur ton profil.",
  "recs.tab_posts": "Recom. de publications",
  "recs.tab_testimonials": "Recom. de profil",
  "recs.sent": "Envoyées",
  "recs.opened": "Ouvertes",
  "recs.saved": "Enregistrées",
  "recs.booked": "Réservées",
  "recs.per_post": "Par publication",
  "recs.see_clients": "Voir les clients",
  "recs.untitled": "Sans titre",
  "recs.posts_empty_title": "Aucune recommandation envoyée",
  "recs.posts_empty_sub": "Recommande des publications pertinentes à tes clients — l'impact apparaît ici.",
  "recs.detail_sub": "Par client : ouverte, enregistrée, réservée.",
  "recs.no_clients": "Aucun client pour cette publication.",
  "recs.unknown_client": "Client inconnu",
  "recs.dismissed": "Rejetée",
  "recs.pending": "En attente",
  "recs.testimonials_empty_title": "Aucune recommandation pour l'instant",
  "recs.testimonials_empty_sub": "Les clients peuvent laisser une recommandation chaleureuse après une séance.",
  "recs.testimonials_count": "{n} recommandation(s) sur ton profil",
  "recs.deleted": "Recommandation supprimée.",

  // ── Réservations en profondeur (Phase 4f) ──
  "bk.back": "Tableau de bord coach",
  "bk.eyebrow": "Réservations",
  "bk.title": "Réservations",
  "bk.subtitle": "Gère les séances, les reports et ta politique d'annulation.",
  "bk.tab_bookings": "Réservations",
  "bk.tab_reschedule": "Reports",
  "bk.tab_refund": "Politique d'annulation",
  "bk.kpi_upcoming": "À venir",
  "bk.kpi_completed": "Terminées",
  "bk.kpi_pending": "Demandes d'annulation",
  "bk.kpi_gross": "Revenu brut",
  "bk.scope_upcoming": "À venir",
  "bk.scope_cancellation_pending": "Demandes d'annulation",
  "bk.scope_completed": "Terminées",
  "bk.scope_cancelled": "Annulées",
  "bk.scope_all": "Toutes",
  "bk.status_requested": "Demandée",
  "bk.status_confirmed": "Confirmée",
  "bk.status_paid": "Payée",
  "bk.status_pending": "En attente",
  "bk.status_completed": "Terminée",
  "bk.status_pending_cancellation": "Annulation demandée",
  "bk.status_cancelled_refunded": "Annulée (remboursée)",
  "bk.status_cancelled_no_refund": "Annulée",
  "bk.status_cancelled_refund_pending": "Annulée (remboursement en attente)",
  "bk.status_declined": "Refusée",
  "bk.online": "En ligne",
  "bk.session": "Séance",
  "bk.client": "Client",
  "bk.reason": "Motif",
  "bk.refund_per_policy": "Remboursement selon la politique : {pct}%",
  "bk.approve_refund": "Approuver et rembourser",
  "bk.decline": "Refuser",
  "bk.refunded": "Remboursé : {amount} ({pct}%)",
  "bk.empty_title": "Aucune réservation",
  "bk.empty_sub": "Rien à afficher dans cette vue pour le moment.",
  "bk.load_failed": "Impossible de charger les réservations.",
  "bk.approved_toast": "Annulation approuvée et remboursement émis.",
  "bk.declined_toast": "Annulation refusée.",
  "bk.action_failed": "Échec de l'action.",
  "bk.rs_title": "Report automatique",
  "bk.rs_sub": "À quel point à l'avance les clients peuvent reprogrammer automatiquement leurs séances.",
  "bk.rs_window_label": "Fenêtre d'auto-approbation (heures avant la séance)",
  "bk.rs_window_unit": "h",
  "bk.rs_saved": "Le report automatique est maintenant à {n}h avant la séance.",
  "bk.rs_hint": "Les clients ne peuvent reprogrammer automatiquement que si la séance est au moins aussi loin dans le futur ET le nouveau créneau aussi éloigné. 0 = ton approbation requise à chaque fois.",
  "bk.rs_invalid": "Entre un nombre entre 0 et 336 heures.",
  "bk.rs_pending_title": "En attente de revue",
  "bk.rs_pending_empty": "Aucune demande en attente. 🌱",
  "bk.rs_currently": "Actuellement",
  "bk.rs_reason_too_close": "⚠️ Demandé trop proche du début de la séance",
  "bk.rs_reason_no_slot": "ℹ️ Aucun des créneaux du client n'était libre",
  "bk.rs_client_windows": "Proposé par le client",
  "bk.rs_approve": "Approuver",
  "bk.rs_reject_ph": "Message facultatif pour le client",
  "bk.rs_counter": "🕰️ Contre-proposition",
  "bk.rs_reject": "Refuser",
  "bk.rs_approved_toast": "La séance de {name} a été déplacée.",
  "bk.rs_rejected_toast": "{name} sera notifié·e.",
  "bk.cp_title": "Envoyer des contre-propositions",
  "bk.cp_sub": "Propose des horaires alternatifs à {name}.",
  "bk.cp_add_slot": "Ajouter un horaire",
  "bk.cp_message_ph": "Message facultatif",
  "bk.cp_send": "Envoyer les propositions",
  "bk.cp_sent": "Contre-propositions envoyées.",
  "bk.cp_need_one": "Choisis au moins un horaire.",
  "bk.rf_warn_bold": "La plateforme n'absorbe jamais de perte.",
  "bk.rf_warn_body": "Tout remboursement que tu acceptes sort de tes revenus. Stripe NE rembourse PAS les frais de traitement prélevés sur le paiement — ils restent chez Stripe et sont déduits de ton versement. Choisis des paliers que tu peux te permettre.",
  "bk.rf_your_tiers": "Tes paliers",
  "bk.rf_tiers_hint": "Les paliers s'appliquent par ordre décroissant d'heures avant la séance.",
  "bk.rf_hours_before": "Heures avant",
  "bk.rf_percent": "Remboursement %",
  "bk.rf_add_tier": "Ajouter un palier",
  "bk.rf_reset": "Par défaut",
  "bk.rf_estimator": "Combien ça te coûte ?",
  "bk.rf_sample_price": "Prix exemple",
  "bk.rf_at_tier": "Au palier",
  "bk.rf_refund_amount": "Montant du remboursement",
  "bk.rf_stripe_fee": "Frais Stripe perdus",
  "bk.rf_out_of_pocket": "Ton coût",
  "bk.rf_commission_kept": "Commission plateforme (toujours due)",
  "bk.rf_net_kept": "Ton net conservé",
  "bk.rf_msg_to_clients": "Message aux clients",
  "bk.rf_msg_ph": "ex. le report est gratuit avec 48h de préavis.",
  "bk.rf_save": "Enregistrer",
  "bk.rf_saved": "Ta politique d'annulation a été mise à jour.",

  // Modèles d'audience (amélioration de l'assistant)
  "ads.tpl_label": "Modèles d'audience",
  "ads.tpl_none": "Aucun modèle enregistré.",
  "ads.tpl_save": "Enregistrer",
  "ads.tpl_name_ph": "Nom du modèle",
  "ads.tpl_saved": "Audience enregistrée comme modèle.",
  "ads.tpl_applied": "Modèle « {name} » appliqué.",
  "ads.tpl_deleted": "Modèle supprimé.",
  "ads.tpl_save_hint": "Enregistre les champs d'audience actuels pour réutilisation.",
  "zoom.title": "Zoom",
  "zoom.soon": "En cours de configuration par l'équipe — bientôt disponible.",
  "zoom.connected": "Connecté",
  "zoom.hint": "Connecte ton compte Zoom pour des liens de réunion automatiques lors des réservations en ligne.",
  "zoom.connect": "Connecter Zoom",
  "zoom.disconnect": "Déconnecter",
  "zoom.t_connected": "Compte Zoom connecté.",
  "zoom.t_error": "Échec de la connexion Zoom.",
  "zoom.t_disconnected": "Zoom déconnecté.",
  "zoom.not_setup": "Zoom n'est pas encore configuré.",

  "pl.tab_programs": "Programmes de respiration",
  "bp.sub": "Crée des programmes de respiration sur plusieurs jours à partir de 3 à 5 techniques et partage-les par attribution ou code.",
  "bp.new": "Nouveau programme",
  "bp.empty_title": "Aucun programme de respiration",
  "bp.empty_sub": "Crée ton premier programme sur plusieurs jours pour tes clients.",
  "bp.techniques_n": "{n} techniques",
  "bp.days_n": "{n} jours",
  "bp.assigned_n": "{n} attribué(s)",
  "bp.share": "Partager",
  "bp.archive_confirm": "Archiver le programme « {name} » ?",
  "bp.archived": "Programme archivé.",
  "bp.editor_new_title": "Nouveau programme de respiration",
  "bp.editor_edit_title": "Modifier le programme",
  "bp.editor_desc": "Choisis 3 à 5 techniques et définis la durée et le rythme.",
  "bp.name_ph": "Nom du programme",
  "bp.desc_ph": "Brève description (optionnel)",
  "bp.days_label": "Durée (jours)",
  "bp.rhythm_label": "Rythme",
  "bp.tech_count": "Techniques ({n}/5)",
  "bp.min": "min",
  "bp.note_ph": "Note",
  "bp.need_valid": "Nom et 3 à 5 techniques requis.",
  "bp.created": "Programme créé.",
  "bp.updated": "Programme mis à jour.",
  "bp.save_failed": "Échec de l'enregistrement.",
  "bp.share_title": "Partager « {name} »",
  "bp.share_desc": "Attribue le programme directement à un client ou partage le code {code}.",
  "bp.no_clients": "Aucun client pour le moment.",
  "bp.assign_note_ph": "Message personnel (optionnel)",
  "bp.assign": "Attribuer",
  "bp.sending": "Envoi…",
  "bp.assigned_ok": "Programme attribué.",
  "bp.assign_failed": "Échec de l'attribution.",
  "bp.sched_all_daily": "Toutes chaque jour",
  "bp.sched_rotate": "Rotatif",
  "bp.tech_box": "Respiration carrée",
  "bp.tech_478": "4-7-8",
  "bp.tech_coherent": "Respiration cohérente",
  "bp.tech_physiological_sigh": "Soupir physiologique",
  "bp.tech_cooling": "Respiration rafraîchissante",
  "bp.tech_bhramari": "Bhramari",
  "bp.tech_nadi_shodhana": "Respiration alternée",
  "bp.tech_ocean": "Respiration océan",
  "bp.tech_wim_hof": "Wim Hof",
  "bp.tech_kapalabhati": "Kapalabhati",

  "cd.back": "Pouls des clients",
  "cd.no_access_title": "Pas d'accès",
  "cd.no_access_sub": "Aucune relation active avec ce client.",
  "cd.client_fallback": "Client",
  "cd.upcoming": "Séances à venir ({n})",
  "cd.no_upcoming": "Aucune séance à venir.",
  "cd.past": "Séances passées ({n})",
  "cd.no_past": "Aucune séance passée pour l'instant.",
  "cd.plans": "Plans hebdomadaires ({n})",
  "cd.no_plans": "Aucun plan hebdomadaire partagé.",
  "cd.plan_meta": "{slots} blocs · {done} faits · {week}",
  "cd.flexible": "flexible",
  "cd.session_fallback": "Séance",
  "cd.sharing_title": "Données partagées",
  "cd.no_sharing": "Ce client ne partage actuellement aucune donnée Deep Within avec toi.",
  "cd.analysis_title": "Analyse",
  "cd.digestions": "Digestions",
  "cd.transformations": "Transformations",
  "cd.journal": "Journal",
  "cd.no_emotions": "Aucune donnée d'émotion partagée sur la période.",
  "cd.weva": "Rapports WEVA ({n})",
  "cd.no_weva": "Aucun rapport WEVA pour ce client pour l'instant.",
  "cd.days_n": "{n} jours",
  "cd.snapshots_n": "{n} demande(s) de snapshot",
  "cd.attachments": "Pièces jointes partagées ({n})",
  "cd.load_failed": "Impossible de charger le client.",
  "cd.scope_share_events": "Événements",
  "cd.scope_share_hrv": "HRV",
  "cd.scope_share_plans": "Plans",
  "cd.scope_share_ai_reports": "Rapports IA",
  "cd.scope_share_feed_activity": "Activité du fil",
  "cd.scope_share_beliefs": "Croyances",
  "cd.scope_share_upper_limits": "Limites hautes",
  "cd.scope_share_goals": "Objectifs",
  "cd.scope_share_comfortzone": "Zone de confort",
  "cd.scope_share_coping": "Stratégies d'adaptation",
  "cd.scope_share_journal": "Journal",
  "cd.scope_share_weva_reports": "Rapports WEVA",
  "cd.count_beliefs": "Croyances",
  "cd.count_upper_limits": "Limites hautes",
  "cd.count_goals": "Objectifs",
  "cd.count_comfortzone": "Zone de confort",
  "cd.count_coping": "Stratégies",
  "cd.count_journal": "Entrées de journal",
  "cd.count_ai_reports": "Rapports IA",
  "cd.count_events": "Événements",

  // ── Phase A P1 ──
  // Profondeur collaboration
  "col.tab_projects": "Projets",
  "col.tab_stats": "Statistiques",
  "col.tab_ai": "Recommandations IA",
  "col.stats_title": "Bientôt disponible",
  "col.stats_body": "Réservations, revenus et fidélisation des clients par collaboration dans un tableau de bord clair.",
  "col.ai_title": "Bientôt disponible",
  "col.ai_body": "WEVA trouve des coachs compatibles pour de nouvelles collaborations selon les thèmes, publics et disponibilités communs.",
  "col.project_type_offering": "Offre",
  "col.project_type_circle": "Cercle",
  "col.project_status_active": "Actif",
  "col.project_status_archived": "Archivé",
  "col.project_empty_active": "Aucun projet actif pour l'instant",
  "col.project_empty_archived": "Aucun projet archivé",
  "col.project_empty_hint": "Les offres et cercles partagés apparaissent ici comme projets.",
  "col.project_members_n": "{n} membres",
  "col.project_tasks": "tâches",
  "col.project_revenue": "Revenu total",
  "col.project_my_share": "Ta part ({pct}%)",
  "col.project_participants": "Participants",
  "col.project_team": "Équipe de coachs",
  "col.project_documents": "Documents",
  "col.project_purchases": "Achats",
  "col.accept": "Accepter",
  "col.add_block_hint": "Ajoute au moins un bloc.",
  "col.archive": "Archiver",
  "col.back": "Tableau de bord du coach",
  "col.badge_client": "Client·e",
  "col.badge_coach": "Coach",
  "col.bill_monthly": "Mensuel",
  "col.bill_one_time": "Paiement unique",
  "col.bill_yearly": "Annuel",
  "col.billing": "Facturation",
  "col.block_title_ph": "Titre du bloc",
  "col.blocks": "Blocs",
  "col.bookings_suffix": " · {n} réservations",
  "col.chat_fallback": "Chat",
  "col.chat_offer": "Offre de chat",
  "col.chatoffer_active": "Offre de chat active",
  "col.chatoffer_desc": "Propose à tes clients un accès au chat payant avec toi.",
  "col.chatoffer_saved": "Offre de chat enregistrée.",
  "col.chatoffer_title": "Offre de chat payante",
  "col.chats_empty_text": "Démarre un chat depuis l'onglet « Connectés ».",
  "col.chats_empty_title": "Pas encore de chats",
  "col.circ_confirmed": "Cercle confirmé.",
  "col.circ_empty_text": "Fonde un cercle de co-coaching avec des coachs connectés — les revenus sont partagés.",
  "col.circ_empty_title": "Pas encore de cercles partagés",
  "col.circ_pending": "En attente d'acceptations",
  "col.circle_created": "Cercle partagé créé.",
  "col.circle_name_ph": "p. ex. Breath & Mind Collective",
  "col.circles_n": "{n} cercles",
  "col.co_coaches_connected": "Co-coachs (connectés)",
  "col.coach_fallback": "Coach",
  "col.coaches": "Coachs",
  "col.coaches_connected": "Coachs (connectés)",
  "col.confirm": "Confirmer",
  "col.confirmed_of": "{confirmed}/{total} confirmés",
  "col.conn_empty_text": "Trouve des coachs dans l'onglet « Rechercher » et envoie une demande.",
  "col.conn_empty_title": "Pas encore de connexions",
  "col.create": "Créer",
  "col.create_failed": "Impossible à créer.",
  "col.day": "Jour",
  "col.days": "Jours",
  "col.decline": "Refuser",
  "col.dialog_new_circle_desc": "Un cercle de co-coaching à adhésion partagée. Tous les coachs doivent accepter avant la mise en ligne.",
  "col.dialog_new_offering_desc": "Un pack de blocs (formation, 1:1, produit). Les revenus par bloc sont comptabilisés selon votre répartition.",
  "col.duration_min": "Durée (min)",
  "col.err_add_block": "Ajoute au moins un bloc.",
  "col.err_block_day": "Bloc {n} : au moins un jour avec date/heure.",
  "col.err_block_product": "Bloc {n} : choisis un produit.",
  "col.err_block_split": "Bloc {n} : la répartition doit totaliser 100 % (actuellement {sum} %).",
  "col.err_block_title": "Bloc {n} : titre manquant.",
  "col.err_name_min": "Nom (min. 3 caractères).",
  "col.err_override_high": "Le prix du pack ne peut pas dépasser la somme.",
  "col.err_pick_coach": "Sélectionne au moins un coach.",
  "col.err_split_100": "La répartition doit totaliser 100 % (actuellement {sum} %).",
  "col.err_title_min": "Titre (min. 3 caractères).",
  "col.err_total_zero": "Le prix total doit être supérieur à 0.",
  "col.executing_coaches": "Coachs exécutants",
  "col.extras": "Extras (séparés par des virgules)",
  "col.extras_ph": "p. ex. mémos vocaux, résumé PDF",
  "col.eyebrow": "Collaboration",
  "col.f_description": "Description",
  "col.f_name": "Nom",
  "col.f_title": "Titre",
  "col.filter_all": "Tous",
  "col.filter_coaches": "Coachs",
  "col.filter_with_client": "Avec client·e",
  "col.fully_booked": "Complet",
  "col.included_msgs": "Messages inclus",
  "col.incoming_n": "Reçues ({n})",
  "col.kind_one_on_one": "Session 1:1",
  "col.kind_product": "Produit",
  "col.kind_training": "Formation",
  "col.max_participants": "Max. participants (0 = illimité)",
  "col.message": "Message",
  "col.message_label": "Message (facultatif)",
  "col.message_ph": "Présente-toi brièvement et décris ton idée…",
  "col.msg_deleted": "Message supprimé",
  "col.msg_input_ph": "Écris un message…",
  "col.needs_confirm": "Ton acceptation manque",
  "col.new_circle": "Nouveau cercle partagé",
  "col.new_offering": "Nouvelle offre partagée",
  "col.no_coaches_text": "Essaie un autre terme de recherche.",
  "col.no_coaches_title": "Aucun coach trouvé",
  "col.no_connected_coaches": "Pas encore de coachs connectés. Connecte-toi d'abord dans l'onglet « Rechercher ».",
  "col.no_incoming": "Aucune demande reçue.",
  "col.no_messages": "Pas encore de messages. Écris le premier 👋",
  "col.no_outgoing": "Aucune demande envoyée.",
  "col.no_shared_clients_desc": "Les deux coachs ont besoin du même client avec consentement de collaboration.",
  "col.no_shared_clients_title": "Aucun client partagé",
  "col.off_accepted": "Offre acceptée.",
  "col.off_archived": "Offre archivée.",
  "col.off_declined": "Offre refusée.",
  "col.off_empty_text": "Crée un pack avec des coachs connectés — les revenus sont répartis automatiquement.",
  "col.off_empty_title": "Pas encore d'offres partagées",
  "col.off_published": "Offre publiée.",
  "col.offering_created": "Offre partagée créée.",
  "col.offering_fallback": "Offre partagée",
  "col.offering_title_ph": "p. ex. pack retraite Breath & Body",
  "col.offers_n": "{n} offres",
  "col.open_desc": "D'autres coachs peuvent te voir dans le réseau de collaboration et t'envoyer des demandes.",
  "col.open_title": "Ouvert à la collaboration",
  "col.outgoing_n": "Envoyées ({n})",
  "col.override_price": "Remplacer le prix du pack (remise)",
  "col.package_price_ph": "Prix du pack (EUR)",
  "col.pending": "En attente",
  "col.phone_included": "Appel téléphonique inclus",
  "col.phone_minutes": "Minutes de téléphone",
  "col.pick_client_desc": "Uniquement les clients ayant donné leur consentement de collaboration aux deux coachs.",
  "col.pick_client_title": "Quel client connecter ?",
  "col.pick_product_ph": "Choisis produit/méthode/plan…",
  "col.price_eur": "Prix (EUR)",
  "col.publish": "Publier",
  "col.req_accepted": "Demande acceptée.",
  "col.req_declined": "Demande refusée.",
  "col.req_empty_text": "Les demandes reçues et envoyées apparaissent ici.",
  "col.req_empty_title": "Aucune demande en cours",
  "col.request": "Demander",
  "col.request_failed": "La demande a échoué.",
  "col.request_sent": "Demande envoyée à {name}.",
  "col.request_to": "Demande à {name}",
  "col.rev_split": "Répartition des revenus (%)",
  "col.save": "Enregistrer",
  "col.search_client_ph": "Rechercher un client…",
  "col.search_coach_ph": "Rechercher un coach par nom ou spécialité…",
  "col.seats": "Places (facultatif)",
  "col.send_request": "Envoyer la demande",
  "col.sending": "Envoi…",
  "col.seo": "Coach · Collaboration",
  "col.shared_chat": "Chat partagé",
  "col.split_all": "Tous",
  "col.split_executing": "Exécutants",
  "col.split_pct": "Répartition (%)",
  "col.st_archived": "Archivé",
  "col.st_draft": "Brouillon",
  "col.st_pending": "En attente d'acceptation",
  "col.st_published": "Publié",
  "col.stat_connected": "Coachs connectés",
  "col.stat_in": "Demandes reçues",
  "col.stat_offerings": "Offres partagées",
  "col.stat_out": "Demandes envoyées",
  "col.subtitle": "Connecte-toi avec d'autres coachs, discutez ensemble et créez des offres partagées.",
  "col.sum_100": "La somme doit totaliser 100 %.",
  "col.sum_blocks": "Somme des blocs",
  "col.tab_chats": "Chats",
  "col.tab_circles": "Cercles partagés",
  "col.tab_connected": "Connectés",
  "col.tab_find": "Rechercher",
  "col.tab_offerings": "Offres partagées",
  "col.tab_requests": "Demandes",
  "col.title": "Collaboration",
  "col.topic_label": "Sujet (facultatif)",
  "col.topic_ph": "p. ex. retraite commune",
  "col.unlimited_msgs": "Messages illimités",
  "col.you": "Toi",

  // Comparaison d'instantanés WEVA
  "cd.snap_title": "Comparaison d'instantanés WEVA",
  "cd.snap_request": "Demander un instantané",
  "cd.snap_requesting": "Demande en cours…",
  "cd.snap_requested": "Demande d'instantané envoyée.",
  "cd.snap_request_failed": "Échec de la demande.",
  "cd.snap_need_more": "Pas encore assez de données pour comparer. Instantanés existants : {count}. Deux instantanés approuvés sont nécessaires.",
  "cd.snap_days_between": "{n} jours entre les instantanés",
  "cd.snap_beliefs_new": "{n} nouvelles croyances",
  "cd.snap_beliefs_dissolved": "{n} dissoutes",
  "cd.snap_beliefs_recurring": "{n} récurrentes",
  "cd.snap_pillars_shifted": "Axes de focus modifiés",
  "cd.snap_pillar_realize": "Reconnaître",
  "cd.snap_pillar_designate": "Nommer",
  "cd.snap_pillar_release": "Lâcher prise",
  "cd.snap_practice_shift": "Prochaine pratique modifiée",
  "cd.snap_previous": "Précédent",
  "cd.snap_latest": "Le plus récent",

  // Formulaires de consentement
  "cf.meta_title": "Consentements",
  "cf.back": "Tableau de bord coach",
  "cf.eyebrow": "Consentement",
  "cf.title": "Formulaires de consentement",
  "cf.subtitle": "Crée des modèles que les clients signent numériquement avant de réserver.",
  "cf.new": "Nouveau modèle",
  "cf.empty_title": "Aucun modèle pour l'instant",
  "cf.empty_sub": "Crée un formulaire de consentement à signer avant la réservation.",
  "cf.badge_required": "Requis avant réservation",
  "cf.sig_count": "{n} signatures",
  "cf.delete_confirm": "Archiver ce modèle ?",
  "cf.deleted": "Modèle archivé.",
  "cf.saved": "Modèle enregistré.",
  "cf.dialog_new": "Nouveau formulaire de consentement",
  "cf.dialog_edit": "Modifier le modèle",
  "cf.dialog_desc": "Titre et texte du formulaire. Les clients signent numériquement dans l'app.",
  "cf.f_title": "Titre",
  "cf.f_title_ph": "p. ex. Décharge de responsabilité breathwork",
  "cf.f_body": "Texte",
  "cf.f_body_ph": "Écris ici le texte complet du consentement…",
  "cf.f_required": "Requis avant réservation",
  "cf.f_required_hint": "Les clients doivent signer avant de pouvoir réserver.",
  "cf.version_note": "Les modifications de texte augmentent la version — les signatures existantes sont conservées.",
  "cf.err_title": "Saisis un titre.",
  "cf.err_body": "Saisis le texte.",
  "cf.sig_title": "Signatures",
  "cf.sig_empty": "Aucune signature pour l'instant.",
  "cf.sig_version": "Version {v}",

  // Planificateur de publications
  "ps.tab_label": "Planificateur",
  "ps.new": "Nouveau brouillon",
  "ps.saved": "Enregistré.",
  "ps.published": "Publié.",
  "ps.status_draft": "Brouillons",
  "ps.status_scheduled": "Programmés",
  "ps.status_published": "Publiés",
  "ps.next_hint": "La prochaine publication « {title} » sera publiée le {when}.",
  "ps.wd_mon": "Lun",
  "ps.wd_tue": "Mar",
  "ps.wd_wed": "Mer",
  "ps.wd_thu": "Jeu",
  "ps.wd_fri": "Ven",
  "ps.wd_sat": "Sam",
  "ps.wd_sun": "Dim",
  "ps.undated_title": "Brouillons sans date",
  "ps.undated_empty": "Aucun brouillon non programmé.",
  "ps.dialog_new": "Nouvelle publication",
  "ps.dialog_edit": "Modifier la publication",
  "ps.dialog_desc": "Crée un brouillon ou programme la publication pour plus tard.",
  "ps.f_title": "Titre",
  "ps.f_title_ph": "Titre de la publication",
  "ps.f_body": "Contenu",
  "ps.f_body_ph": "Écris ta publication…",
  "ps.f_scheduled": "Programmé pour",
  "ps.f_scheduled_hint": "Laisse vide pour un brouillon sans date. Avec une date, publication automatique.",
  "ps.f_inner_circle": "Inner Circle uniquement",
  "ps.publish_now": "Publier maintenant",
  "ps.err_title": "Saisis un titre.",

  // Offres d'affiliation
  "aff.tab_label": "Affiliation",
  "aff.intro": "Liens d'affiliation externes affichés sur ton profil public.",
  "aff.new": "Nouvelle offre d'affiliation",
  "aff.saved": "Enregistré.",
  "aff.deleted": "Supprimé.",
  "aff.delete_confirm": "Supprimer cette offre d'affiliation ?",
  "aff.locked_title": "Coach Pro uniquement",
  "aff.locked_sub": "Les offres d'affiliation sont disponibles pour les abonnés Coach Pro et les membres Founder 50/500.",
  "aff.empty_title": "Aucune offre d'affiliation pour l'instant",
  "aff.empty_sub": "Lie des produits que tu recommandes — avec une mention publicitaire automatique.",
  "aff.ad_badge": "Publicité",
  "aff.inactive": "Inactif",
  "aff.dialog_new": "Nouvelle offre d'affiliation",
  "aff.dialog_edit": "Modifier l'offre",
  "aff.dialog_desc": "Le lien s'ouvre dans le navigateur externe et est automatiquement signalé comme publicité.",
  "aff.f_title": "Titre",
  "aff.f_title_ph": "p. ex. Mon journal préféré",
  "aff.f_url": "Lien d'affiliation",
  "aff.f_desc": "Description",
  "aff.f_desc_ph": "Description courte (max 400 caractères)",
  "aff.f_category": "Catégorie",
  "aff.f_category_ph": "p. ex. Livres",
  "aff.f_price": "Prix",
  "aff.f_price_ph": "facultatif",
  "aff.f_cover": "Image de couverture",
  "aff.f_cover_hint": "Facultatif. S'affiche sur la carte d'affiliation de ton profil public.",
  "aff.compete_hint": "Note : les liens vers des apps concurrentes ou des plateformes offrant les mêmes fonctions que My Within ne sont pas autorisés.",
  "aff.ack_label": "Je suis conscient de l'obligation de divulgation et signale ce lien comme publicité.",
  "aff.ack_compete": "Je confirme que ce lien ne mène pas à une plateforme concurrente.",
  "aff.err_title": "Saisis un titre.",
  "aff.err_url": "Saisis une URL valide (http/https).",
  "aff.err_ack": "Coche les deux confirmations.",

  // Configuration coach
  "cs.meta_title": "Configuration coach",
  "cs.back": "Tableau de bord coach",
  "cs.eyebrow": "Configuration",
  "cs.title": "Configuration coach",
  "cs.subtitle": "Quatre étapes pour un profil de coach prêt — puis tu gagnes le badge Founding Coach.",
  "cs.progress_label": "{done} sur {total} étapes terminées",
  "cs.badge_title": "Badge Founding Coach actif ✨",
  "cs.badge_sub": "Tu portes le badge Founding Coach sur ton profil pendant encore {n} jours.",
  "cs.step_n": "Étape {n}",
  "cs.done": "Terminé",
  "cs.mark_done": "Marquer comme terminé",
  "cs.step_consent_title": "Créer un formulaire de consentement",
  "cs.step_consent_sub": "Crée un modèle que les clients signent avant de réserver.",
  "cs.step_consent_cta": "Aller aux consentements",
  "cs.step_story_title": "Partage ta première story",
  "cs.step_story_sub": "Montre-toi sur le mur de stories et crée la confiance.",
  "cs.step_story_cta": "Aller à Social et contenu",
  "cs.step_program_title": "Créer un programme de respiration",
  "cs.step_program_sub": "Crée un programme que tu peux attribuer aux clients.",
  "cs.step_program_cta": "Aller aux plans",
  "cs.step_invite_title": "Invite ton premier client",
  "cs.step_invite_sub": "Partage ton code d'invitation et accueille tes premiers clients.",
  "cs.step_invite_cta": "Afficher le code d'invitation",

  // ── Phase A P2 · Hub de réglages ──
  "cset.meta_title": "Réglages",
  "cset.back_dashboard": "Tableau de bord coach",
  "cset.eyebrow": "Compte",
  "cset.title": "Réglages",
  "cset.subtitle": "Compte, règles de réservation, marque, rapports et crédits au même endroit.",
  "cset.group_account": "Compte",
  "cset.group_bookings": "Réservations",
  "cset.group_brand": "Marque et rapports",
  "cset.group_billing": "Facturation",
  "cset.group_language": "Langue",
  "cset.row_profile": "Profil et marque",
  "cset.row_profile_sub": "Profil public, bio et marque.",
  "cset.row_verify": "Vérification",
  "cset.row_verify_sub": "Téléverse ta qualification et son statut.",
  "cset.row_availability": "Disponibilité",
  "cset.row_availability_sub": "Ouvre et ferme les créneaux hebdomadaires.",
  "cset.row_refund": "Annulation et remboursements",
  "cset.row_refund_sub": "Tes propres paliers de remboursement et coûts.",
  "cset.row_reschedule": "Reprogrammations",
  "cset.row_reschedule_sub": "Fenêtre d'auto-approbation et demandes en attente.",
  "cset.row_branding": "Marque personnalisée",
  "cset.row_branding_sub": "Logo, couleur de marque et pied d'email.",
  "cset.row_digest": "Aperçu du digest hebdomadaire",
  "cset.row_digest_sub": "Tes réservations collab de la semaine dernière.",
  "cset.row_credits": "Crédits · {n}",
  "cset.row_credits_sub": "Recharge des crédits pour la pub et plus.",
  "cset.row_language": "Langue de l'app",
  "cset.logout": "Se déconnecter",

  // Annulation et remboursements
  "refpol.meta_title": "Annulation et remboursements",
  "refpol.eyebrow": "Réservations",
  "refpol.title": "Annulation et remboursements",
  "refpol.subtitle": "Définis tes propres paliers de remboursement qui remplacent ceux par défaut de la plateforme.",
  "refpol.warn_bold": "La plateforme n'absorbe jamais de perte.",
  "refpol.warn_body": "Tout remboursement est prélevé sur tes revenus. Stripe ne rembourse PAS les frais de traitement — ils restent chez Stripe et sont déduits de ton versement. Choisis uniquement des paliers que tu peux assumer.",
  "refpol.your_tiers": "Tes paliers",
  "refpol.tiers_hint": "Les paliers s'appliquent par ordre décroissant d'heures avant la session.",
  "refpol.hours_before": "Heures avant",
  "refpol.refund_pct": "Remboursement %",
  "refpol.add_tier": "Ajouter un palier",
  "refpol.reset": "Réinitialiser par défaut",
  "refpol.cost_title": "Combien coûte un remboursement ?",
  "refpol.sample_price": "Prix d'exemple",
  "refpol.est_refund": "Montant du remboursement",
  "refpol.est_stripe": "Frais Stripe perdus",
  "refpol.est_oop": "Ton coût direct",
  "refpol.est_commission": "Commission plateforme (toujours due)",
  "refpol.est_net": "Ton net conservé",
  "refpol.notes": "Message aux clients",
  "refpol.notes_ph": "p. ex. La reprogrammation est gratuite jusqu'à 48h avant.",
  "refpol.save": "Enregistrer la politique",
  "refpol.saved": "Politique enregistrée.",

  // Reprogrammations
  "resch.meta_title": "Reprogrammations",
  "resch.eyebrow": "Réservations",
  "resch.title": "Réglages de reprogrammation",
  "resch.subtitle": "À quel point à l'avance les clients peuvent reprogrammer automatiquement leurs sessions.",
  "resch.window_label": "Fenêtre d'auto-approbation (heures avant la session)",
  "resch.window_hint": "Les clients ne peuvent reprogrammer automatiquement que si la session est au moins aussi loin dans le futur ET le nouveau créneau aussi. Mets 0 pour exiger ton approbation à chaque fois.",
  "resch.save": "Enregistrer",
  "resch.saved": "Enregistré.",
  "resch.invalid": "Saisis un nombre entre 0 et 336.",
  "resch.pending_title": "En attente de révision",
  "resch.pending_empty": "Aucune demande en attente. 🌱",
  "resch.currently": "Actuellement",
  "resch.reason_too_close": "⚠️ Demandé trop près du début de la session",
  "resch.reason_no_slot": "ℹ️ Aucun créneau du client n'était libre",
  "resch.client_windows": "Suggéré par le client",
  "resch.approve": "Approuver",
  "resch.approved": "Approuvé.",
  "resch.reject_ph": "Message facultatif pour le client",
  "resch.reject": "Refuser la demande",
  "resch.rejected": "Refusé.",

  // Marque personnalisée
  "cbr.meta_title": "Marque personnalisée",
  "cbr.eyebrow": "Marque",
  "cbr.title": "Marque personnalisée",
  "cbr.subtitle": "Logo, couleur de marque et pied de page pour tes emails aux clients.",
  "cbr.locked_title": "Coach Pro uniquement",
  "cbr.locked_sub": "La marque personnalisée fait partie de Coach Pro. Passe à Pro pour utiliser ton logo et tes couleurs.",
  "cbr.f_logo": "URL du logo",
  "cbr.f_logo_hint": "URL https publique de ton logo (affichée dans les emails).",
  "cbr.f_color": "Couleur de marque",
  "cbr.f_footer": "Pied d'email",
  "cbr.f_footer_ph": "p. ex. Avec amour, ton nom de coach · mentions/liens",
  "cbr.save": "Enregistrer la marque",
  "cbr.saved": "Marque enregistrée.",
  "cbr.reset": "Réinitialiser",
  "cbr.reset_confirm": "Réinitialiser la marque par défaut ?",
  "cbr.reset_done": "Réinitialisé par défaut.",
  "cbr.err_logo": "L'URL du logo doit commencer par http:// ou https://.",
  "cbr.err_color": "La couleur doit être #RRGGBB (p. ex. #6B8E6E).",

  // Aperçu du digest hebdomadaire
  "wdig.meta_title": "Digest hebdomadaire",
  "wdig.eyebrow": "Rapports",
  "wdig.title": "Aperçu du digest hebdomadaire",
  "wdig.subtitle": "Tes réservations collab de la semaine dernière — comme dans l'email.",
  "wdig.this_week": "Cette semaine",
  "wdig.bookings": "Réservations",
  "wdig.gross": "Revenu brut",
  "wdig.trend": "Tendance sur 4 semaines",
  "wdig.offerings": "Par offre",
  "wdig.offerings_empty": "Aucune réservation collab cette semaine pour l'instant.",
  "wdig.n_bookings": "{n} réservations",
  "wdig.last_sent": "Dernier envoi {when} · {n} réservations · {gross}",

  // Crédits
  "cred.meta_title": "Crédits",
  "cred.eyebrow": "Facturation",
  "cred.title": "Crédits",
  "cred.subtitle": "Recharge des crédits pour diffuser des pubs et utiliser les fonctions premium.",
  "cred.balance": "Solde actuel",
  "cred.per_credit": "{price} par crédit",
  "cred.buy": "Acheter",
  "cred.mock_granted": "{n} crédits accordés (mode test).",
  "cred.vat_note": "Prix TTC. Facturé par Inside Out Harmony e.U. (Autriche).",

  // ── Phase A P2 Partie 2 · Lignes de réglages ──
  "cset.row_professional": "Profil professionnel et certificats",
  "cset.row_professional_sub": "Profession, méthodes, qualifications et preuves.",
  "cset.row_checkin": "Modèle de check-in",
  "cset.row_checkin_sub": "Message chaleureux pour les clients silencieux.",
  "cset.group_growth": "Croissance",
  "cset.row_referral": "Parraine et gagne",
  "cset.row_referral_sub": "Ton code, tes liens et récompenses.",
  "cset.row_ic_invites": "Invitations Inner Circle",
  "cset.row_ic_invites_sub": "Invite des clients et suis les acceptations.",
  "cset.row_wins": "Réussites clients",
  "cset.row_wins_sub": "Histoires de réussite et témoignages.",
  "cset.row_collectives": "Collectifs",
  "cset.row_collectives_sub": "Alliances de coachs avec revenus partagés.",
  "cset.group_support": "Support et aide",
  "cset.row_support": "Tickets de support",
  "cset.row_support_sub": "Pose ta question à l'équipe My Within.",
  "cset.row_help": "Aide et FAQ",
  "cset.row_help_sub": "Réponses aux questions fréquentes.",
  "cset.row_tour": "Visite guidée",
  "cset.row_tour_sub": "Aperçu rapide de ton tableau de bord.",
  "cset.row_upgrade": "Coach Pro",
  "cset.row_upgrade_sub": "Passe à 10% de commission, marque et plus.",

  // Support
  "sup.meta_title": "Support", "sup.eyebrow": "Support", "sup.title": "Support et accompagnement",
  "sup.subtitle": "Pose ta question directement à l'équipe My Within — on répond personnellement.",
  "sup.new": "Nouvelle demande", "sup.new_desc": "Choisis un sujet et décris ton problème.",
  "sup.f_category": "Sujet", "sup.f_subject": "Objet (facultatif)", "sup.f_subject_ph": "Titre court",
  "sup.f_body": "Ton message", "sup.f_body_ph": "Décris ton problème le plus concrètement possible…",
  "sup.submit": "Envoyer", "sup.created": "Demande envoyée.", "sup.err_cat": "Choisis au moins un sujet.", "sup.err_body": "Décris ton problème.",
  "sup.empty_title": "Aucune demande pour l'instant", "sup.empty_sub": "Envoie ta première demande — on est là pour toi.",
  "sup.n_msg": "{n} messages",
  "sup.status_open": "Ouvert", "sup.status_in_progress": "En cours", "sup.status_answered": "Répondu", "sup.status_closed": "Fermé",
  "sup.reply_ph": "Écris une réponse…", "sup.send": "Envoyer", "sup.close": "Fermer le ticket", "sup.close_confirm": "Fermer ce ticket ?", "sup.closed": "Fermé.", "sup.is_closed": "Ce ticket est fermé. Crée une nouvelle demande pour d'autres questions.",

  // Référral
  "ref.meta_title": "Parrainer", "ref.eyebrow": "Croissance", "ref.title": "Parraine et gagne",
  "ref.subtitle": "Partage My Within et gagne des récompenses pour chaque inscription via ton code.",
  "ref.your_code": "Ton code de parrainage", "ref.share": "Partager", "ref.copied": "Lien copié.",
  "ref.links": "Tes liens", "ref.web_link": "Lien web", "ref.app_link": "Lien app",
  "ref.rewards_title": "Comment fonctionnent les récompenses",
  "ref.rule_coach_bonus": "{pct}% de bonus sur les abonnements clients que tu parraines — jusqu'à {months} mois.",
  "ref.rule_c2c": "{eur} € de crédit par personne parrainée — jusqu'à {max}×/an.",
  "ref.rule_note": "Les récompenses sont libérées après le délai de remboursement.",

  // Modèle de check-in
  "chk.meta_title": "Modèle de check-in", "chk.eyebrow": "Réservations", "chk.title": "Modèle de check-in",
  "chk.subtitle": "Ton message chaleureux par défaut pour les clients silencieux du Pouls clients.",
  "chk.default_hint": "Tu utilises le modèle par défaut. Adapte-le à ton ton.",
  "chk.f_template": "Texte du modèle", "chk.preview": "Aperçu", "chk.save": "Enregistrer le modèle", "chk.saved": "Enregistré.", "chk.err_short": "Saisis au moins 10 caractères.",

  // Upgrade
  "upg.meta_title": "Coach Pro", "upg.eyebrow": "Abonnement", "upg.title": "Passe à Coach Pro",
  "upg.subtitle": "Commission réduite, ta propre marque et tous les outils premium.",
  "upg.already_pro": "Tu es déjà Coach Pro — merci d'être là ! ✨",
  "upg.best_value": "Meilleur prix", "upg.plan_monthly": "Mensuel", "upg.plan_yearly": "Annuel", "upg.per_month": "mois", "upg.per_year": "an",
  "upg.f_commission": "Seulement 10% de commission sur les sessions", "upg.f_unlimited_weva": "Analyses WEVA illimitées", "upg.f_branding": "Marque personnalisée (logo et couleur)",
  "upg.f_analytics": "Analyses avancées", "upg.f_priority": "Traitement WEVA prioritaire", "upg.f_group_tools": "Outils de groupe et de collectif", "upg.f_bulk_export": "Export en masse de tes données",
  "upg.subscribe": "Passer à Pro", "upg.current": "Plan actuel", "upg.pay_credits": "Payer avec {n} crédits", "upg.activated": "Coach Pro activé !", "upg.vat_note": "Prix TTC (TVA autrichienne 20%). Annulable à tout moment.",

  // Aide / FAQ
  "help.meta_title": "Aide", "help.eyebrow": "Aide", "help.title": "Aide et FAQ", "help.subtitle": "Réponses rapides aux questions les plus fréquentes des coachs.",
  "help.q_getting_started": "Comment démarrer en tant que coach ?", "help.a_getting_started": "Termine la configuration coach (4 étapes) : crée un formulaire de consentement, partage ta première story, crée un programme de respiration et invite ton premier client.",
  "help.q_payouts": "Comment recevoir mes versements ?", "help.a_payouts": "Connecte ton compte Stripe dans Revenus. Les versements sont automatiques après le délai de remboursement — moins la commission de la plateforme.",
  "help.q_clients": "Comment voir les clients silencieux ?", "help.a_clients": "Le Pouls clients montre qui est inactif depuis un moment. De là, tu peux envoyer un check-in chaleureux ou rédiger un nudge IA.",
  "help.q_pro": "Qu'offre Coach Pro ?", "help.a_pro": "Coach Pro réduit ta commission à 10% et débloque la marque personnalisée, les analyses avancées, le WEVA prioritaire et les outils de groupe.",
  "help.q_branding": "Comment utiliser ma propre marque ?", "help.a_branding": "Avec Coach Pro tu peux définir ton logo, ta couleur de marque et un pied d'email dans Réglages → Marque personnalisée.",
  "help.q_refunds": "Comment fonctionnent les remboursements ?", "help.a_refunds": "Dans Réglages → Annulation et remboursements tu définis tes propres paliers. Note : les frais Stripe ne sont pas remboursés et sont déduits de ton versement.",
  "help.contact_sub": "Pas trouvé de réponse ? Écris-nous directement.", "help.contact_cta": "Contacter le support",

  // Visite guidée
  "tour.meta_title": "Visite guidée", "tour.eyebrow": "Bienvenue", "tour.title": "Ta visite coach", "tour.subtitle": "Les étapes clés de ton tableau de bord en 5 étapes.", "tour.step_n": "Étape {n}",
  "tour.clients_title": "Accompagner les clients", "tour.clients_sub": "Vérifie le pouls, repère les clients silencieux et relance chaleureusement.",
  "tour.plans_title": "Plans et programmes", "tour.plans_sub": "Attribue des plans quotidiens et partage des programmes de respiration.",
  "tour.offerings_title": "Vendre des offres", "tour.offerings_sub": "Configure sessions, forfaits et offres d'affiliation.",
  "tour.circles_title": "Construire des cercles", "tour.circles_sub": "Inner et Local Circle pour des revenus récurrents.",
  "tour.analytics_title": "Mesurer la croissance", "tour.analytics_sub": "Analyse approfondie des revenus, WEVA et rétention.",
  "tour.cta_sub": "Prêt ? Termine ta configuration.", "tour.cta": "Vers la configuration coach",

  // Invitations Inner Circle
  "ici.meta_title": "Invitations Inner Circle", "ici.back": "Inner Circle", "ici.eyebrow": "Inner Circle", "ici.title": "Gérer les invitations",
  "ici.subtitle": "Invite des clients dans ton Inner Circle et suis les acceptations.",
  "ici.stat_sent": "Envoyées", "ici.stat_accept_rate": "Taux d'acceptation", "ici.stat_active": "Abos actifs", "ici.stat_retention": "Rétention 30 jours",
  "ici.invite_title": "Inviter par email", "ici.emails_ph": "Adresses email, séparées par virgule ou ligne", "ici.note_ph": "Note personnelle (facultatif, max 200 caractères)",
  "ici.send": "Envoyer les invitations", "ici.sent": "{n} invitations envoyées.", "ici.err_email": "Indique au moins un email valide.",
  "ici.list_title": "Invitations envoyées", "ici.empty": "Aucune invitation envoyée pour l'instant.",
  "ici.status_pending": "En attente", "ici.status_accepted": "Acceptée", "ici.status_revoked": "Révoquée",

  // Collectifs
  "col2.meta_title": "Collectifs", "col2.eyebrow": "Collaboration", "col2.title": "Collectifs", "col2.subtitle": "Associe-toi à d'autres coachs dans une alliance avec revenus partagés.",
  "col2.new": "Nouveau collectif", "col2.new_desc": "Donne un nom et une description à ton collectif.",
  "col2.f_name": "Nom", "col2.f_name_ph": "p. ex. Alliance Breathwork Vienne", "col2.f_desc": "Description", "col2.f_desc_ph": "De quoi parle ce collectif ?", "col2.f_cover": "Image de couverture",
  "col2.err_name": "Saisis un nom.", "col2.created": "Collectif créé.", "col2.empty_title": "Aucun collectif pour l'instant", "col2.empty_sub": "Crée un collectif ou attends une invitation.",
  "col2.members_n": "{n} membres", "col2.owner": "Propriétaire", "col2.status_draft": "Brouillon", "col2.status_active": "Actif", "col2.status_archived": "Archivé",
  "col2.detail_meta": "Collectif", "col2.you_invited": "Tu as été invité à ce collectif.", "col2.accept": "Accepter", "col2.decline": "Refuser", "col2.resp_accepted": "Accepté.", "col2.resp_declined": "Refusé.",
  "col2.members": "Membres", "col2.invite": "Inviter", "col2.share_pct": "{pct}% des revenus", "col2.mstatus_invited": "Invité", "col2.mstatus_declined": "Refusé",
  "col2.publish": "Publier", "col2.archive": "Archiver", "col2.saved": "Enregistré.", "col2.invited": "Invité.", "col2.err_email": "Saisis un email valide.",
  "col2.invite_title": "Inviter un coach", "col2.invite_email": "Email du coach", "col2.invite_share": "% des revenus",

  // Réussites clients
  "win.meta_title": "Réussites clients", "win.eyebrow": "Social", "win.title": "Réussites clients", "win.subtitle": "Transforme les progrès réels en histoires de réussite — avec le consentement de tes clients.",
  "win.suggestions": "Suggestions IA", "win.suggestions_empty": "Aucune suggestion pour l'instant. Elles apparaissent quand les clients font des progrès mesurables.", "win.create": "Créer une réussite", "win.requested": "Créé — envoyé au client pour approbation.",
  "win.my_wins": "Tes réussites", "win.empty": "Aucune réussite créée pour l'instant.", "win.delete_confirm": "Supprimer cette réussite ?", "win.deleted": "Supprimé.",
  "win.pending": "En attente d'approbation", "win.approved": "Approuvé", "win.private": "Privé",

  // Progression du profil professionnel
  "pon.meta_title": "Profil professionnel", "pon.eyebrow": "Profil", "pon.title": "Profil professionnel et progression", "pon.subtitle": "Complète ton profil professionnel pour que les clients te fassent confiance.", "pon.progress": "{done} sur {total} sections remplies",
  "pon.step_profession": "Profession principale choisie", "pon.step_methods": "Méthodes ajoutées", "pon.step_focus": "Domaines de focus choisis", "pon.step_qualifications": "Qualifications ajoutées", "pon.step_languages": "Langues choisies", "pon.step_certificates": "Certificat téléversé",
  "pon.certificates": "Certificats", "pon.cert_add": "Téléverser", "pon.cert_empty": "Aucun certificat pour l'instant. PDF, JPG ou PNG (max 20 Mo).", "pon.cert_uploaded": "Certificat téléversé.", "pon.cert_fail": "Échec du téléversement.", "pon.cert_delete_confirm": "Supprimer ce certificat ?", "pon.cert_deleted": "Supprimé.", "pon.edit_in_profile": "Modifier le profil professionnel dans Profil",

  // Nudge EVA (détail client)
  "nudge.title": "Rédiger un nudge IA", "nudge.hint": "Laisse WEVA rédiger un message court et chaleureux basé sur la dernière réflexion de ton client. Tu le relis et l'envoies toi-même.",
  "nudge.generate": "Rédiger un nudge", "nudge.regenerate": "Rédiger à nouveau", "nudge.generating": "Rédaction…", "nudge.failed": "Impossible de rédiger un nudge pour l'instant.", "nudge.theme": "Thème", "nudge.copy": "Copier", "nudge.send_hint": "Astuce : copie le texte et envoie-le au client via tes messages.",
  "nav.coach_hub": "Coachs",
  "nav.group.book": "Réserver",
  "nav.my_bookings": "Réservations",
  "bkc.hub_title": "Coachs & réservation",
  "bkc.hub_sub": "Tes accompagnant·es et leurs offres réservables.",
  "bkc.my_coaches": "Mes coachs",
  "bkc.no_coaches": "Pas encore de coachs",
  "bkc.no_coaches_sub": "Découvre le bon accompagnement et réserve ta première séance.",
  "bkc.browse_all": "Voir tous les coachs",
  "bkc.view_profile": "Voir le profil",
  "bkc.offerings": "Offres",
  "bkc.no_products": "Aucune offre réservable.",
  "bkc.book_cta": "Réserver",
  "bkc.group": "Groupe",
  "bkc.min": "min",
  "bkc.with_coach": "avec {name}",
  "bkc.back": "Retour",
  "bkc.pick_date": "Choisis une date",
  "bkc.slots": "Créneaux disponibles",
  "bkc.no_slots": "Aucun créneau libre ce jour-là.",
  "bkc.payment": "Paiement",
  "bkc.pay_credits": "{n} crédits",
  "bkc.pay_card": "Carte",
  "bkc.confirm_credits": "Réserver avec {n} crédits",
  "bkc.confirm_card": "Réserver pour {amount}",
  "bkc.select_slot_first": "Choisis d'abord un créneau.",
  "bkc.checkout_opened": "Paiement ouvert dans un nouvel onglet …",
  "bkc.booked": "Réservation confirmée !",
  "bkc.book_failed": "La réservation a échoué.",
  "bkc.product_not_found": "Offre introuvable.",
  "bkc.bookings_title": "Mes réservations",
  "bkc.bookings_sub": "Tes séances à venir et passées.",
  "bkc.upcoming": "À venir",
  "bkc.past": "Passées",
  "bkc.none": "Pas encore de réservations",
  "bkc.none_sub": "Réserve ta première séance avec un coach.",
  "bkc.no_upcoming": "Aucune réservation à venir.",
  "bkc.no_past": "Pas encore de séances passées.",
  "bkc.open_details": "Détails",
  "bkc.join_zoom": "Rejoindre Zoom",
  "bkc.cancel": "Annuler",
  "bkc.cancel_request": "Demander l'annulation",
  "bkc.cancel_confirm": "Vraiment annuler cette réservation ?",
  "bkc.cancel_sent": "Demande d'annulation envoyée.",
  "bkc.marketplace": "Place de marché",
  "bkc.status_confirmed": "Confirmée",
  "bkc.status_paid": "Payée",
  "bkc.status_pending": "En attente",
  "bkc.status_payment_pending": "Paiement en attente",
  "bkc.status_cancelled": "Annulée",
  "bkc.status_pending_cancellation": "Annulation demandée",
  "bkc.status_cancelled_refunded": "Annulée · remboursée",
  "bkc.status_cancelled_no_refund": "Annulée · sans remboursement",
  "bkc.status_cancelled_refund_pending": "Annulée · remboursement en attente",
  "bkc.refund_title": "Conditions d'annulation",
  "bkc.refund_intro": "Voici ce que tu récupérerais en annulant maintenant :",
  "bkc.refund_tier_72": "Plus de 72 h avant · 100 %",
  "bkc.refund_tier_24": "24–72 h avant · 50 %",
  "bkc.refund_tier_now": "Moins de 24 h avant · 0 %",
  "bkc.refund_you_get": "Tu récupères",
  "bkc.refund_pct": "{pct}% de remboursement",
  "bkc.refund_amount": "≈ {amount}",
  "bkc.refund_hours_left": "il reste {hours} h avant la séance",
  "bkc.refund_note": "Ton coach confirme le remboursement final.",
  "bkc.reason_ph": "Motif (facultatif)",
  "bkc.submit_cancel": "Demander l'annulation",
  "bkc.session_title": "Séance",
  "bkc.session_not_found": "Séance introuvable.",
  "bkc.when": "Quand",
  "bkc.where": "Où",
  "bkc.your_coach": "Ton coach",
  "bkc.virtual": "Séance en ligne",
  "bkc.join_meeting": "Rejoindre la réunion",
  "bkc.link_tba": "Lien à venir.",
  "bkc.in_person": "En personne",
  "bkc.location_tba": "Lieu à venir.",
  "bkc.in_person_hint": "Ton coach te communiquera l'adresse exacte.",
  "bkc.time_tba": "Date à confirmer",
  "bkc.note_title": "Ta note pour le coach",
  "bkc.note_hint": "Partage à l'avance ce sur quoi tu veux travailler.",
  "bkc.note_ph": "De quoi parlera cette séance ?",
  "bkc.note_saved_at": "Enregistré le {when}",
  "bkc.save": "Enregistrer",
  "bkc.clear": "Effacer",
  "bkc.saved": "Enregistré.",
  "bkc.cancel_policy": "Annulation : actuellement {pct}% de remboursement.",
  "bkc.duration_min": "{n} min",
  "bkc.email": "E-mail",
  "bkc.phone": "Appeler",

  // Session booking (sb)
  "sb.title": "Réservez votre séance",
  "sb.back": "Retour",
  "sb.not_found": "Coach introuvable.",
  "sb.pick_offering": "Choisissez une offre",
  "sb.no_offerings": "Ce coach n'a aucune offre réservable pour le moment.",
  "sb.minutes": "{n} min",
  "sb.credits_label": "crédits",
  "sb.payment": "Mode de paiement",
  "sb.pay_credits": "Payer avec des crédits",
  "sb.pay_card": "Payer par carte",
  "sb.credits_balance": "Solde : {balance} crédits",
  "sb.credits_insufficient": "Il manque {need} crédits (vous en avez {have}).",
  "sb.add_credits": "Ajouter des crédits",
  "sb.preferred_time": "Horaire souhaité",
  "sb.available_times": "Créneaux disponibles",
  "sb.no_slots_day": "Aucun créneau libre ce jour — essayez une autre date.",
  "sb.note_title": "Une note courte (facultatif)",
  "sb.note_ph": "De quoi aimeriez-vous parler ?",
  "sb.legal": "Vérification de paiement unique. Le coach confirme dès que le paiement est validé.",
  "sb.confirm_credits": "Réserver pour {credits} crédits",
  "sb.confirm_card": "Réserver pour {amount}",
  "sb.confirm_insufficient": "Crédits insuffisants",
  "sb.booked": "Votre séance est réservée 💛",
  "sb.book_failed": "Échec de la réservation.",

  // Collab packages (cov)
  "cov.packages_title": "Packs collaboratifs",
  "cov.packages_sub": "Des packs conçus ensemble par plusieurs coachs.",
  "cov.none": "Aucun pack collaboratif disponible pour le moment.",
  "cov.not_found": "Pack introuvable.",
  "cov.coaches": "Coachs",
  "cov.included": "Inclus",
  "cov.kind_training": "Formation",
  "cov.kind_one_on_one": "Séance 1:1",
  "cov.kind_product": "Produit",
  "cov.min": "min",
  "cov.capacity": "{n} sur {total} disponibles",
  "cov.total": "Total",
  "cov.payment": "Paiement",
  "cov.balance": "Solde : {balance}",
  "cov.insufficient": "Il manque {need} (vous en avez {have}).",
  "cov.add_credits": "Ajouter des crédits",
  "cov.book_credits": "Réserver pour {credits} crédits",
  "cov.book_card": "Réserver pour {amount}",
  "cov.full": "Complet",
  "cov.book_failed": "Échec de la réservation.",
  "cov.booked_title": "Pack réservé",
  "cov.booked_sub": "Tout est prêt. Vos coachs ont été prévenus.",
  "cov.booked_blocks": "Votre pack",
  "cov.booked_ready": "Prêt",
  "cov.booked_slot": "Planifié : {when}",
  "cov.booked_slot_pending": "Créneau à définir",
  "cov.booked_home": "Voir mes réservations",
  "cov.slot_title": "Choisissez vos créneaux",
  "cov.slot_sub": "Définissez un horaire pour chaque séance 1:1.",
  "cov.slot_all_done": "Tous les créneaux définis",
  "cov.slot_pending": "{n} créneau(x) à définir",
  "cov.slot_pick_coach": "Choisissez un coach",
  "cov.slot_pick_slot": "Choisissez un créneau",
  "cov.slot_none": "Aucun créneau libre.",
  "cov.slot_save": "Enregistrer le créneau",
  "cov.slot_saved": "Créneaux enregistrés",
  "cov.slot_skip": "Plus tard",
  "cov.slot_done": "Terminé",

  // Deep Within + Journal + Practices (Welle 1)
  "nav.deep_within": "Deep Within",
  "nav.journal": "Journal",
  "dw.title": "Deep Within",
  "dw.subtitle": "Ton espace pour reconnaître, nommer et lâcher ce que tu portes.",
  "dw.in_progress": "en travail doux",
  "dw.transformed": "transformé",
  "dw.hero_practices_title": "Reconnaître · Nommer · Lâcher",
  "dw.hero_practices_sub": "Des pratiques guidées pour transformer ce que tu ressens.",
  "dw.hero_journal_title": "Journaling",
  "dw.hero_journal_sub": "Écris-toi libre, jour après jour.",
  "dw.soon": "Bientôt disponible",
  "dw.buckets_heading": "Tes domaines",
  "dw.entries": "{n} entrées",
  "dw.not_found": "Domaine introuvable.",
  "dw.add": "Ajouter",
  "dw.edit": "Modifier",
  "dw.delete": "Supprimer",
  "dw.save": "Enregistrer",
  "dw.cancel": "Annuler",
  "dw.saved": "Enregistré.",
  "dw.save_failed": "Échec de l'enregistrement.",
  "dw.deleted": "Supprimé.",
  "dw.delete_failed": "Échec de la suppression.",
  "dw.delete_confirm": "Supprimer cette entrée ?",
  "dw.primary_required": "Remplis le champ principal.",
  "dw.tab_own": "Les miennes",
  "dw.tab_weva": "WEVA",
  "dw.tab_all": "Toutes",
  "dw.tab_progress": "En travail doux",
  "dw.tab_transformed": "Transformées",
  "dw.empty_title": "Rien pour l'instant",
  "dw.empty_sub": "Ajoute ta première entrée quand tu es prêt.",
  "dw.status_label": "Statut",
  "dw.status_open": "Ouvert",
  "dw.status_in_progress": "En cours",
  "dw.status_transformed": "Transformé",
  "dw.weva_toggle": "Inclure dans la réflexion WEVA",
  "dw.readonly_weva": "Reconnu par WEVA — seuls le statut et l'interrupteur WEVA sont modifiables.",
  "dw.show_details": "Plus de détails",
  "dw.hide_details": "Masquer les détails",
  "dw.f.reframe": "Nouvelle formulation renforçante",
  "dw.f.reframe_ph": "Comment aimerais-tu le voir à la place ?",
  "dw.f.frequency": "Fréquence",
  "dw.f.origin": "Origine",
  "dw.f.body_location": "Zone du corps",
  "dw.f.physical_pain": "Sensation physique",
  "dw.f.applied_practice": "Pratique appliquée",
  "dw.ul.title": "Upper limit",
  "dw.ul.title_ph": "Comment te freines-tu quand tout va bien ?",
  "dw.ul.life_area": "Domaine de vie",
  "dw.ul.symptoms": "Symptômes",
  "dw.ul.symptoms_ph": "p. ex. inquiétude, conflit (séparés par des virgules)",
  "dw.ul.trigger": "Déclencheur",
  "dw.ul.core_false_belief": "Croyance erronée sous-jacente",
  "dw.ul.zone_of_genius_impact": "Impact sur ta zone de génie",
  "dw.beliefs.title": "Croyances",
  "dw.beliefs.sub": "Les convictions qui te façonnent",
  "dw.beliefs.field": "Croyance",
  "dw.beliefs.ph": "Que crois-tu sur toi ou le monde ?",
  "dw.fears.title": "Peurs",
  "dw.fears.sub": "Ce qui te retient",
  "dw.fears.field": "Peur",
  "dw.fears.ph": "De quoi as-tu peur ?",
  "dw.surroundings.title": "Entourage",
  "dw.surroundings.sub": "Les personnes et lieux autour de toi",
  "dw.surroundings.field": "Entourage",
  "dw.surroundings.ph": "Quelle partie de ton entourage t'occupe ?",
  "dw.dreams.title": "Rêves",
  "dw.dreams.sub": "Là où tu aspires à aller",
  "dw.dreams.field": "Rêve",
  "dw.dreams.ph": "De quoi rêves-tu ?",
  "dw.values.title": "Valeurs",
  "dw.values.sub": "Ce qui compte pour toi",
  "dw.values.field": "Valeur",
  "dw.values.ph": "Quelle valeur te guide ?",
  "dw.strengths.title": "Forces",
  "dw.strengths.sub": "Ce sur quoi tu peux t'appuyer",
  "dw.strengths.field": "Force",
  "dw.strengths.ph": "Quelle force vit en toi ?",
  "dw.habits.title": "Habitudes",
  "dw.habits.sub": "Tes schémas quotidiens",
  "dw.habits.field": "Habitude",
  "dw.habits.ph": "Quelle habitude veux-tu observer ?",
  "dw.boundaries.title": "Limites",
  "dw.boundaries.sub": "Ce que tu protèges",
  "dw.boundaries.field": "Limite",
  "dw.boundaries.ph": "Quelle limite veux-tu poser ?",
  "dw.upper-limits.title": "Upper limits",
  "dw.upper-limits.sub": "Là où tu te freines toi-même",
  "jr.title": "Journal",
  "jr.subtitle": "Un lieu calme pour tes pensées.",
  "jr.new_ph": "Qu'est-ce qui t'habite en ce moment ?",
  "jr.mood": "Humeur",
  "jr.weva": "Inclure dans WEVA",
  "jr.save": "Enregistrer l'entrée",
  "jr.saved": "Entrée enregistrée.",
  "jr.save_failed": "Échec de l'enregistrement.",
  "jr.empty_err": "Écris d'abord quelque chose.",
  "jr.empty_title": "Aucune entrée",
  "jr.empty_sub": "Ta première entrée t'attend.",
  "jr.delete": "Supprimer",
  "jr.delete_confirm": "Supprimer cette entrée ?",
  "jr.deleted": "Entrée supprimée.",
  "pr.title": "Reconnaître · Nommer · Lâcher",
  "pr.subtitle": "Des pratiques guidées et fondées sur des preuves pour transformer ce que tu ressens en sécurité. Arrive dans l'une des prochaines vagues.",
  "pr.soon": "Bientôt disponible",
  "pr.pillar_realize": "Reconnaître",
  "pr.pillar_designate": "Nommer",
  "pr.pillar_release": "Lâcher",

  // Practices (Erkennen·Benennen·Loslassen) — ported from mobile
  "back": "Retour",
  "body_arms": "Bras",
  "body_belly": "Ventre",
  "body_chest": "Poitrine",
  "body_face": "Visage",
  "body_feet": "Pieds",
  "body_head": "Tête",
  "body_heart": "Cœur",
  "body_hips": "Hanches",
  "body_legs": "Jambes",
  "body_lower_back": "Bas du dos",
  "body_mark_neutral": "Neutre",
  "body_mark_open": "Ouvert",
  "body_mark_tense": "Tendu",
  "body_pelvis": "Bassin",
  "body_shoulders": "Épaules",
  "body_solar_plexus": "Plexus solaire",
  "body_throat": "Gorge",
  "body_upper_back": "Haut du dos",
  "bodymap_hint": "Touche une zone : tendu → neutre → ouvert.",
  "emdr_hint": "Ramène le souvenir ou l'émotion en tête, puis suis le point.",
  "emdr_rounds": "Rondes",
  "emdr_min_rounds": "Au moins 10 tours pour continuer ({n}/10)",
  "emdr_speed": "Vitesse",
  "emdr_speed_fast": "Rapide",
  "emdr_speed_med": "Moyen",
  "emdr_speed_slow": "Lent",
  "emo_abandoned": "abandonné",
  "emo_accomplished": "accompli",
  "emo_aching": "endolori",
  "emo_amazed": "émerveillé",
  "emo_anger": "colère",
  "emo_annoyed": "agacé",
  "emo_anxious": "anxieux",
  "emo_ashamed": "honteux",
  "emo_betrayed": "trahi",
  "emo_bitter": "amer",
  "emo_cherished": "chéri",
  "emo_confident": "confiant",
  "emo_confused": "confus",
  "emo_connected": "connecté",
  "emo_contemptuous": "méprisant",
  "emo_content": "content",
  "emo_critical": "critique",
  "emo_curious": "curieux",
  "emo_defeated": "vaincu",
  "emo_disappointed": "déçu",
  "emo_disgust": "dégoût",
  "emo_disoriented": "désorienté",
  "emo_disrespected": "méprisé",
  "emo_eager": "impatient",
  "emo_embarrassed": "embarrassé",
  "emo_empty": "vide",
  "emo_energized": "énergisé",
  "emo_enraged": "enragé",
  "emo_excited": "excité",
  "emo_exposed": "exposé",
  "emo_fear": "peur",
  "emo_frozen": "figé",
  "emo_frustrated": "frustré",
  "emo_furious": "furieux",
  "emo_grateful": "reconnaissant",
  "emo_grief": "en deuil",
  "emo_guilty": "coupable",
  "emo_hateful": "haineux",
  "emo_heartbroken": "le cœur brisé",
  "emo_helpless": "impuissant",
  "emo_hopeless": "sans espoir",
  "emo_hostile": "hostile",
  "emo_hurt": "blessé",
  "emo_impatient": "impatient",
  "emo_inadequate": "inadéquat",
  "emo_insecure": "insécure",
  "emo_intrigued": "intrigué",
  "emo_irritated": "irrité",
  "emo_isolated": "isolé",
  "emo_jealous": "jaloux",
  "emo_jolted": "secoué",
  "emo_joy": "joie",
  "emo_judgmental": "critique",
  "emo_lonely": "seul",
  "emo_lost": "perdu",
  "emo_loving": "aimant",
  "emo_mourning": "en deuil",
  "emo_nauseated": "nauséeux",
  "emo_open": "ouvert",
  "emo_overwhelmed": "submergé",
  "emo_paralyzed": "paralysé",
  "emo_peaceful": "paisible",
  "emo_perplexed": "perplexe",
  "emo_powerless": "sans pouvoir",
  "emo_primary": "Primaire",
  "emo_proud": "fier",
  "emo_repulsed": "repoussé",
  "emo_resentful": "rancunier",
  "emo_restless": "agité",
  "emo_revolted": "révolté",
  "emo_sadness": "tristesse",
  "emo_scared": "effrayé",
  "emo_secondary": "Secondaire",
  "emo_seen": "vu",
  "emo_shocked": "choqué",
  "emo_small": "petit",
  "emo_specific": "Spécifique",
  "emo_startled": "sursauté",
  "emo_superior": "supérieur",
  "emo_surprise": "surprise",
  "emo_tearful": "en larmes",
  "emo_tender": "tendre",
  "emo_terrified": "terrifié",
  "emo_threatened": "menacé",
  "emo_thrilled": "ravi",
  "emo_trapped": "piégé",
  "emo_unfair": "injuste",
  "emo_unseen": "invisible",
  "emo_unworthy": "indigne",
  "emo_violent": "violent",
  "emo_warm": "chaleureux",
  "emo_worried": "inquiet",
  "favorite": "Favori",
  "p_abc_a_label": "A — Que s'est-il passé ? (faits uniquement)",
  "p_abc_a_ph": "Mon patron a dit…",
  "p_abc_b_label": "B — Qu'ai-je fait de cela ?",
  "p_abc_b_ph": "Que je ne suis pas compétente…",
  "p_abc_c_label": "C — Comment me suis-je senti et ai-je agi ?",
  "p_abc_c_ph": "J'ai figé, évité…",
  "p_abc_dispute_label": "B est-il objectivement vrai ? Quelle autre lecture ?",
  "p_abc_dispute_ph": "Peut-être qu'ils étaient stressés aussi…",
  "p_abc_intro_body": "A (événement déclencheur) → B (croyance / évaluation) → C (conséquence). La magie est en B.",
  "p_abc_intro_title": "Vois la séquence",
  "p_abc_model": "Modèle ABC",
  "p_abc_model_desc": "Déclencheur → Évaluation → Conséquence. Vois la séquence.",
  "p_abc_newc_label": "Avec la nouvelle croyance — à quoi ressemblerait C ?",
  "p_abc_title": "Modèle ABC",
  "p_body_scan": "Scan Corporel",
  "p_body_scan_bodymap_hint": "Touche chaque zone pour marquer son état.",
  "p_body_scan_bodymap_label": "Où le ressens-tu ?",
  "p_body_scan_desc": "Sens ton corps de la tête aux pieds et marque ce qui appelle l'attention.",
  "p_body_scan_intro_body": "Déplace ton attention lentement du sommet de la tête à la plante des pieds. Marque ce qui est tendu, neutre, ouvert.",
  "p_body_scan_intro_title": "Ressens de la tête aux pieds",
  "p_body_scan_invite_breath": "Être respiré",
  "p_body_scan_invite_label": "Que veut cet endroit ?",
  "p_body_scan_invite_movement": "Du mouvement",
  "p_body_scan_invite_stillness": "Juste de la présence",
  "p_body_scan_invite_touch": "Une main bienveillante",
  "p_body_scan_invite_words": "Des mots doux",
  "p_body_scan_mood_after": "Après",
  "p_body_scan_mood_before": "Avant",
  "p_body_scan_sensation_label": "Quelle est la sensation la plus vive ?",
  "p_body_scan_sensation_ph": "Un anneau serré autour de ma gorge…",
  "p_body_scan_title": "Scan du corps",
  "p_cb_after": "Après",
  "p_cb_before": "Avant",
  "p_cb_dur_20": "20 min",
  "p_cb_dur_30": "30 min",
  "p_cb_dur_40": "40 min",
  "p_cb_dur_starter": "10 min (au début)",
  "p_cb_duration_label": "Durée de la séance",
  "p_cb_exp_calm": "Calme profond",
  "p_cb_exp_heat": "Chaud / froid",
  "p_cb_exp_images": "Images vives",
  "p_cb_exp_movement": "Le corps voulait bouger",
  "p_cb_exp_nothing": "Rien de dramatique",
  "p_cb_exp_tears": "Larmes",
  "p_cb_exp_tetany": "Picotements / tétanie",
  "p_cb_experience_label": "Qu'est-ce qui a émergé pendant la respiration ? (à cocher après)",
  "p_cb_intention_label": "Ton intention pour cette séance",
  "p_cb_intention_ph": "Laisser le deuil bouger…",
  "p_cb_intro_body": "Inspiration-expiration continue sans pause. Idéal accompagné par un facilitateur ou une piste guidée. 20 à 40 minutes.",
  "p_cb_intro_title": "Respiration circulaire",
  "p_cb_posture_bed": "Sur un lit / tapis",
  "p_cb_posture_chair": "Assis sur une chaise",
  "p_cb_posture_floor": "Sol",
  "p_cb_posture_label": "Où vas-tu t'allonger ou t'asseoir ?",
  "p_cb_reflection_label": "Réflexion",
  "p_cb_title": "Respiration circulaire",
  "p_cognitive_restructuring": "Restructuration Cognitive",
  "p_cognitive_restructuring_desc": "Teste une pensée lourde, puis choisis-en une plus légère et vraie.",
  "p_connected_breath": "Respiration Connectée",
  "p_connected_breath_desc": "Respiration circulaire pour mobiliser l'énergie émotionnelle bloquée.",
  "p_core_deeper1_label": "Si elle l'obtenait pleinement, qu'est-ce que cela lui donnerait ?",
  "p_core_deeper1_ph": "De la sécurité, peut-être.",
  "p_core_deeper2_label": "Et si elle l'obtenait PLEINEMENT ?",
  "p_core_integration_label": "Comment la réaction initiale change-t-elle quand tu as déjà cela ?",
  "p_core_intro_body": "Demande à chaque réaction « si tu obtenais tout ce que tu veux, qu'est-ce que cela me donnerait ? » — jusqu'à atteindre un état essentiel (Paix, Amour, Être).",
  "p_core_intro_title": "Suis-le jusqu'à la maison",
  "p_core_state_being": "Être / paix intérieure",
  "p_core_state_label": "Quel état essentiel semble le plus proche ?",
  "p_core_state_love": "Amour",
  "p_core_state_oneness": "Unité",
  "p_core_state_peace": "Paix",
  "p_core_transformation": "Core Transformation",
  "p_core_transformation_desc": "Suivre une réaction jusqu'à son intention positive la plus profonde.",
  "p_core_transformation_title": "Transformation essentielle",
  "p_core_trigger_label": "Sur quelle réaction travailles-tu ?",
  "p_core_trigger_ph": "Quand mon/ma partenaire ignore mes messages, je suis en colère…",
  "p_core_want_label": "Que veut cette part ?",
  "p_core_want_ph": "Je veux être vue.",
  "p_cr_balanced_label": "Une pensée plus équilibrée",
  "p_cr_balanced_ph": "Parfois je galère ET j'ai déjà grandi à travers des choses dures.",
  "p_cr_belief_after": "Comment sonne cette pensée équilibrée maintenant ?",
  "p_cr_belief_before": "Comment sonne-t-elle vraie ? (1 bas – 10 haut)",
  "p_cr_dist_all_or_nothing": "Tout-ou-rien",
  "p_cr_dist_catastrophizing": "Catastrophisme",
  "p_cr_dist_label": "Quelles distorsions cognitives sont en jeu ?",
  "p_cr_dist_labeling": "Étiquetage",
  "p_cr_dist_mind_reading": "Lecture des pensées",
  "p_cr_dist_personalizing": "Personnalisation",
  "p_cr_dist_should": "Injonctions « je devrais »",
  "p_cr_evidence_against": "Preuves CONTRE la pensée",
  "p_cr_evidence_for": "Preuves POUR la pensée",
  "p_cr_heavy_label": "Écris la pensée lourde",
  "p_cr_heavy_ph": "Je ne serai jamais assez bien…",
  "p_cr_intro_body": "Une pensée lourde n'est pas un fait. Pèse-la, puis choisis-en une plus vraie.",
  "p_cr_intro_title": "Teste la pensée",
  "p_cr_title": "Restructuration cognitive",
  "p_dream_log": "Carnet de Rêves",
  "p_dream_log_desc": "Capture les rêves à chaud - symboles, sensations, seuils.",
  "p_dream_log_intro_body": "Les rêves s'estompent en quelques minutes. Écris ce dont tu te souviens — même les fragments ont du sens.",
  "p_dream_log_intro_title": "Attrape le fil",
  "p_dream_log_narrative_label": "Raconte-le — au présent si tu peux.",
  "p_dream_log_narrative_ph": "Je marche à travers…",
  "p_dream_log_question_label": "Quelle question ce rêve pose-t-il ?",
  "p_dream_log_question_ph": "…",
  "p_dream_log_sym_animal": "Animal",
  "p_dream_log_sym_fire": "Feu",
  "p_dream_log_sym_house": "Maison / pièce",
  "p_dream_log_sym_light": "Lumière / obscurité",
  "p_dream_log_sym_person": "Personne",
  "p_dream_log_sym_threshold": "Seuil / porte",
  "p_dream_log_sym_vehicle": "Véhicule",
  "p_dream_log_sym_water": "Eau",
  "p_dream_log_symbols_hint": "Choisis autant que nécessaire.",
  "p_dream_log_symbols_label": "Symboles marquants",
  "p_dream_log_title": "Journal des rêves",
  "p_dream_log_title_label": "Un titre court pour ce rêve",
  "p_dream_log_title_ph": "L'escalier sans fin",
  "p_dream_log_tone_grieving": "En deuil",
  "p_dream_log_tone_joyful": "Joyeux",
  "p_dream_log_tone_label": "L'ambiance générale était…",
  "p_dream_log_tone_mystery": "Mystérieux",
  "p_dream_log_tone_peaceful": "Paisible",
  "p_dream_log_tone_tense": "Tendu",
  "p_emdr": "EMDR (auto-usage)",
  "p_emdr_desc": "Stimulation bilatérale avec un souvenir ou une émotion.",
  "p_emdr_intro_body": "Ceci est une adaptation en auto-usage de l'EMDR — pour un stress doux du quotidien, pas pour un trauma profond. Pour ce dernier, consulte un thérapeute agréé.",
  "p_emdr_intro_title": "Stimulation bilatérale",
  "p_emdr_session_hint": "Fais 1 à 3 séries de 20 à 30 aller-retours. Entre les séries, respire et laisse flotter les images.",
  "p_emdr_session_label": "Regarde le point en gardant la cible en tête",
  "p_emdr_shift_label": "Qu'est-ce qui a bougé dans l'image, le corps ou la pensée ?",
  "p_emdr_suds_after": "SUDS maintenant (0 – 10)",
  "p_emdr_suds_before": "SUDS — détresse maintenant (0 calme – 10 max)",
  "p_emdr_target_label": "Cible : ramène un souvenir ou une émotion en tête",
  "p_emdr_target_ph": "Le moment hier où…",
  "p_emdr_title": "EMDR (auto-usage)",
  "p_emotion_wheel": "Roue des Émotions",
  "p_emotion_wheel_after": "Après l'avoir nommée — comment vas-tu ?",
  "p_emotion_wheel_before": "Avant",
  "p_emotion_wheel_desc": "Précise ce que tu ressens - du général au spécifique.",
  "p_emotion_wheel_intro_body": "Quand on peut la nommer, on peut la rencontrer. Va du large au fin.",
  "p_emotion_wheel_intro_title": "La précision change tout",
  "p_emotion_wheel_title": "Roue des émotions",
  "p_emotion_wheel_trigger_label": "Qu'est-ce qui a déclenché cela ?",
  "p_emotion_wheel_trigger_ph": "Une phrase courte…",
  "p_emotion_wheel_wheel_label": "Va vers l'extérieur — général → spécifique",
  "p_inner_critic": "Le Critique Intérieur",
  "p_inner_critic_desc": "Rencontre la voix intérieure - et écoute ce qu'elle protège.",
  "p_inner_critic_intro_body": "Le critique intérieur n'est pas toi — c'est une part de toi qui essaie de te protéger à l'ancienne. Rencontre-le, écoute-le, remercie-le.",
  "p_inner_critic_intro_title": "Rencontre la voix",
  "p_inner_critic_mood_after": "Et maintenant ?",
  "p_inner_critic_mood_before": "Comment vas-tu avant de commencer ?",
  "p_inner_critic_mood_before_hint": "1 = lourd, 10 = léger",
  "p_inner_critic_protect_hint": "Regarde sous la dureté. Quelle peur y vit ?",
  "p_inner_critic_protect_label": "De quoi essaie-t-il de te protéger ?",
  "p_inner_critic_response_label": "Que pourrais-tu lui répondre — avec bienveillance ?",
  "p_inner_critic_response_ph": "Merci d'essayer de me protéger. Je t'entends, et je gère.",
  "p_inner_critic_title": "Le critique intérieur",
  "p_inner_critic_tone_label": "Sur quel ton parle-t-il ?",
  "p_inner_critic_tone_opt_anxious": "Anxieux & catastrophiste",
  "p_inner_critic_tone_opt_cold": "Froid & méprisant",
  "p_inner_critic_tone_opt_harsh": "Dur & tranchant",
  "p_inner_critic_tone_opt_pushy": "Insistant & exigeant",
  "p_inner_critic_voice_label": "Que te dit ton critique aujourd'hui ?",
  "p_inner_critic_voice_ph": "Tu ne vas jamais…",
  "p_parts_age_label": "Quel âge a-t-elle ?",
  "p_parts_age_ph": "7, 42, ou sans âge",
  "p_parts_intro_body": "Tu as de nombreuses parts intérieures. Choisis-en une active aujourd'hui — donne-lui un nom, un âge, et écoute.",
  "p_parts_intro_title": "Rencontre les parts",
  "p_parts_message_label": "Que veut-elle que tu saches ?",
  "p_parts_name_label": "Donne un nom à cette part",
  "p_parts_name_ph": "La sur-performante",
  "p_parts_role_exile": "Exilé (porte la douleur)",
  "p_parts_role_firefighter": "Pompière",
  "p_parts_role_label": "Quel est son rôle ?",
  "p_parts_role_manager": "Gérante / planificatrice",
  "p_parts_role_protector": "Protectrice",
  "p_parts_role_witness": "Témoin intérieur",
  "p_parts_self_label": "Que répond ton Soi calme ?",
  "p_parts_self_ph": "Je t'entends. Merci de porter cela.",
  "p_parts_work": "Travail des Parties",
  "p_parts_work_desc": "Rencontre tes états intérieurs comme des personnages avec des rôles.",
  "p_parts_work_title": "Travail des parts",
  "p_the_work": "Le Travail (Byron Katie)",
  "p_the_work_belief_label": "Écris la pensée stressante",
  "p_the_work_belief_ph": "Ils devraient m'aimer comme je le veux.",
  "p_the_work_desc": "Quatre questions et un retournement pour une croyance stressante.",
  "p_the_work_intro_body": "Apporte une croyance stressante. Pose-lui quatre questions. Puis retourne-la.",
  "p_the_work_intro_title": "Quatre questions et une inversion",
  "p_the_work_q1_label": "1. Est-ce vrai ?",
  "p_the_work_q2_label": "2. Peux-tu absolument savoir que c'est vrai ?",
  "p_the_work_q3_label": "3. Comment réagis-tu — que se passe-t-il — quand tu crois cette pensée ?",
  "p_the_work_q4_label": "4. Qui serais-tu sans cette pensée ?",
  "p_the_work_title": "The Work (Byron Katie)",
  "p_the_work_turnaround_label": "Retourne-la — écris une inversion aussi vraie, ou plus vraie.",
  "p_the_work_turnaround_ph": "Je devrais m'aimer comme je veux qu'ils m'aiment.",
  "p_tre": "TRE",
  "p_tre_after": "Après",
  "p_tre_before": "Avant",
  "p_tre_desc": "Exercices libérateurs de trauma - laisse le corps trembler.",
  "p_tre_intro_body": "TRE fatigue le psoas et libère le réflexe de tremblement. Fais-le sur une surface molle. Arrête à tout moment. Pas pour un trauma avancé sans accompagnement.",
  "p_tre_intro_title": "Laisse le corps trembler",
  "p_tre_reflection_label": "Qu'as-tu remarqué ?",
  "p_tre_session_hint": "Suis chaque phase. Le tremblement est sûr quand il coule librement.",
  "p_tre_session_label": "Séance guidée",
  "p_tre_title": "TRE",
  "p_yesno_no": "Non",
  "p_yesno_unsure": "Pas sûr",
  "p_yesno_yes": "Oui",
  "pillar_designate": "Nommer",
  "pillar_designate_desc": "Nommer et structurer ce que tu vois.",
  "pillar_realize": "Reconnaître",
  "pillar_realize_desc": "Voir ce qui est vraiment là.",
  "pillar_release": "Libérer",
  "pillar_release_desc": "Laisse ça traverser ton corps.",
  "practices_hub_subtitle": "Douze pratiques guidées à travers les trois piliers.",
  "practices_hub_title": "Reconnaître - Nommer - Relâcher",
  "saving": "Enregistrement…",
  "tre_hint": "Suis les 4 phases. Arrête à tout moment si tu te sens en insécurité.",
  "tre_intensity_lbl": "Intensité du tremblement (0 – 10)",
  "tre_phase_fatigue": "2. Chaise contre le mur",
  "tre_phase_rest": "4. Repos d'intégration",
  "tre_phase_tremor": "3. Phase de tremblement (allongé)",
  "tre_phase_warmup": "1. Échauffement (pieds, mollets)",
  "ui_continue": "Continuer",
  "ui_could_not_save": "Enregistrement impossible",
  "ui_please_try_again": "Réessaie s'il te plaît.",
  "ui_save_finish": "Enregistrer & terminer",
  "unfavorite": "Retirer des favoris",
  "widget_pause": "Pause",
  "widget_resume": "Reprendre",
  "widget_start": "Démarrer",
  // Deep Within tabs, insights, workings + view switcher (iter250)
  "nav.switch_to_client": "Mon espace perso",
  "nav.switch_to_coach": "Espace coach",
  "dw.tab_practice": "Pratique",
  "dw.tab_insights": "Insights",
  "dw.tab_history": "Historique",
  "dw.insights_total": "Entrées au total",
  "dw.insights_streak_current": "Série actuelle",
  "dw.insights_streak_longest": "Plus longue série",
  "dw.insights_mood_delta": "Évolution moy.",
  "dw.insights_7d": "7 derniers jours",
  "dw.insights_by_pillar": "Par pilier",
  "dw.insights_mood": "Humeur",
  "dw.insights_mood_before": "avant",
  "dw.insights_mood_after": "après",
  "dw.insights_sources": "Sources",
  "dw.insights_top": "Pratique préférée",
  "dw.insights_empty_title": "Pas encore de données",
  "dw.insights_empty_sub": "Termine une pratique ou ajoute une entrée — tes insights apparaîtront ici.",
  "dw.src_practices": "Pratiques",
  "dw.src_goals": "Objectifs",
  "dw.src_comfortzone": "Zone de confort",
  "dw.src_coping": "Coping",
  "dw.src_journal": "Journal",
  "dw.history_full_log": "Historique complet",
  "dw.history_empty_title": "Pas encore de pratiques",
  "dw.history_empty_sub": "Tes pratiques terminées apparaîtront ici.",
  "dw.workings": "Journey",
  "dw.workings_add": "Étape",
  "dw.workings_none": "Pas encore d'étapes dans cette journey.",
  "dw.working_saved": "Étape enregistrée.",
  "dw.working_title": "Étape de la journey",
  "dw.working_sub": "Note ce qui a changé en travaillant dessus.",
  "dw.working_intensity": "Intensité",
  "dw.working_success": "Sentiment de réussite",
  "dw.working_reflection": "Qu'est-ce qui a changé ?",
  "dw.working_still": "J'y travaille encore",
  "dw.working_hint_progress": "Reste en travail doux.",
  "dw.working_hint_done": "Marqué comme transformé.",
  "practices_history_title": "Historique des pratiques",
  "practices_history_sub": "Toutes tes pratiques terminées.",
  "practices_history_empty_title": "Pas encore de pratiques",
  "practices_history_empty_sub": "Démarre une pratique depuis le hub Pratiques.",
  "practices_delete_confirm": "Supprimer cette entrée ?",

  // --- WEVA / EVA (Phase B Epic C+B · Welle 2) ---
  "weva": "WEVA",
  "weva_full_name": "Wellbeing Emotional Vitality Assistant",
  "weva_freemium_notice": "WEVA est une fonctionnalité IA — Plus (5,97 €/mois) ou supérieur déverrouille les conversations, rapports, analyse des croyances et insights.",
  "weva_tab_insight": "Aperçu",
  "weva_action_insight_sub": "Statistiques de pratique + dernière réflexion.",
  "weva_action_chat": "Discuter avec WEVA",
  "weva_action_chat_sub": "WEVA n'écoute que lorsque vous l'invitez.",
  "weva_action_reports": "Générer un rapport",
  "weva_action_reports_sub": "Choisissez les périodes et les sources pour votre rapport.",
  "weva_action_beliefs": "Tes croyances",
  "weva_action_beliefs_sub": "Votre tableau + les observations de WEVA, côte à côte.",
  "weva_tab_history": "Historique IA",
  "weva_report_fallback_title": "Rapport",
  "ui_latest_reflection": "Dernière réflexion WEVA",
  "ui_open_full_report": "Ouvrir le rapport complet",
  "ui_no_report_yet": "Aucun rapport WEVA. Génère-en un depuis l'onglet WEVA.",
  "weva_generate_report_cta": "Générer un rapport",
  "eva_chat": "Discuter avec WEVA",
  "eva_chat_sub": "Demande à WEVA à propos de tes schémas, émotions ou prochaines étapes.",
  "eva_chat_tab_chat": "Chat",
  "eva_chat_tab_past": "Passé",
  "eva_chat_tab_reports": "Rapports",
  "eva_chat_empty": "Dis bonjour à WEVA - elle se souvient de ce que tu as partagé.",
  "eva_chat_send_hint": "WEVA répond en fonction de ton journal récent, tes sessions et ton dernier bilan.",
  "eva_chat_thinking": "WEVA réfléchit…",
  "eva_chat_placeholder": "Qu'est-ce qui te préoccupe ?",
  "eva_chat_used": "{n}/{q} messages aujourd'hui",
  "eva_chat_limit_hit": "Limite de conversation WEVA atteinte - passe à la version supérieure pour continuer.",
  "eva_chat_clear": "Effacer la conversation",
  "eva_chat_clear_confirm": "Supprimer toute ta conversation avec WEVA ?",
  "eva_chat_new_session": "Démarrer une nouvelle conversation",
  "eva_chat_past_empty": "Vos conversations passées apparaissent ici une fois que vous terminez une conversation.",
  "eva_chat_current_pill": "Actuel",
  "eva_chat_msgs_short": "msgs",
  "eva_chat_empty_session": "session vide",
  "eva_chat_reflecting": "Réflexion en cours…",
  "eva_chat_view_report": "Voir le rapport",
  "eva_chat_make_report": "Créer un rapport",
  "eva_chat_reports_empty": "Après une conversation, appuyez sur \\\"Créer un rapport\\\" dans l'onglet Passé. Les résumés sont ici.",
  "eva_chat_report_fallback": "Rapport de conversation",
  "insights_2": "Aperçus",
  "delete_report": "Supprimer le rapport",
  "eva_chat_voice_locked": "La saisie vocale nécessite Plus, Pro ou Illimité.",
  "journal_upgrade_cta": "Passe à la version supérieure pour déverrouiller",
  "cancel": "Annuler",
  "delete": "Supprimer",
  "popup_report_failed": "Échec du rapport",
  "popup_not_enough_credits": "Crédits insuffisants",
  "popup_signup_required": "Inscription requise",
  "popup_signup_to_report": "Termine ton inscription pour générer ce rapport.",
  "weekly_digest": "Résumé hebdo",
  "what_weva_noticed": "Ce que WEVA a remarqué",
  "a_gentle_next_step": "Une prochaine étape en douceur",
  "weva_didn_t_leave_a_summary_for_this": "WEVA n'a pas laissé de résumé pour cette semaine.",
  "talk_with_weva_about_this": "Parler de cela avec WEVA",
  "retry": "Réessayer",
  "weva_report": "Rapport WEVA",
  "report_not_found": "Rapport introuvable.",
  "expand_all": "Tout développer",
  "collapse_all": "Tout réduire",
  "since_your_last_report": "Depuis votre dernier rapport",
  "this_is_your_first_weva_report": "Ceci est votre premier rapport WEVA",
  "welcome_to_the_journey_come_back_after": "Bienvenue dans cette aventure. Revenez après votre prochaine fenêtre de pratique — la carte \\\"avant vs après\\\" commencera à suivre votre progression dès maintenant.",
  "tap_to_open_previous_report": "Appuyez pour ouvrir le rapport précédent ›",
  "try_this_first": "Essayez ceci en premier",
  "try_this_next": "Essayez ceci ensuite",
  "open_the_practice": "Ouvrir la pratique ›",
  "open_the_beliefs_table": "Ouvrir le tableau des Croyances ›",
  "weva_reports_title": "Nouveau rapport WEVA",
  "weva_reports_sub": "Choisis ce que WEVA prend en compte.",
  "weva_reports_scope_all": "Toutes les données",
  "one_timeframe_applied_to_all_sources": "Une période appliquée à toutes les sources.",
  "weva_reports_include_realize": "Inclure données Reconnaître",
  "weva_reports_include_designate": "Inclure données Nommer",
  "weva_reports_include_release": "Inclure données Libérer",
  "weva_reports_include_breakouts": "Inclure sessions Breathwork",
  "weva_reports_include_goals": "Inclure Mes Objectifs",
  "weva_reports_include_comfortzone": "Inclure Ma Zone de Confort",
  "weva_reports_include_coping": "Inclure Mes Ressources",
  "weva_reports_include_journal": "Inclure Mon Journal",
  "my_beliefs_section_title": "Mes croyances",
  "upper_limits_section_title": "Mes limites supérieures",
  "weva_reports_include_prior": "Inclure rapports WEVA antérieurs",
  "weva_reports_generate": "Générer le rapport",
  "weva_reports_history": "Rapports précédents",
  "your_reports_will_live_here": "Vos rapports vivront ici.",
  "no_reports_match_your_filters": "Aucun rapport ne correspond à vos filtres.",
  "search_reports": "Rechercher des rapports…",
  "weva_lang_picker_label": "Langue du rapport",
  "weva_lang_picker_hint": "Le rapport WEVA sera écrit dans cette langue.",
  "get_a_weva_report": "Obtenir un rapport WEVA",
  "reports_left": "rapports restants",
  "every_report_distils_your_recent": "Chaque rapport distille vos récentes séances de respiration, journaux, objectifs et travail sur votre zone de confort en une réflexion claire de WEVA.",
  "confirm_delete_weva_report_title": "Supprimer ce rapport WEVA ?",
  "confirm_delete_weva_report_body": "Cette action ne peut pas être annulée.",
  "confirm_delete": "Supprimer",
  "popup_delete_failed": "Impossible de supprimer",
  "nav.weva": "WEVA",
  "weva_subtitle": "Ton compagnon de vitalité par IA.",
  "weva_action_digests": "Réflexions hebdomadaires",
  "weva_action_digests_sub": "Les résumés hebdomadaires de WEVA de ton travail intérieur.",
  "weva_digests_title": "Réflexions hebdomadaires",
  "weva_digests_sub": "Les résumés hebdomadaires de WEVA de ton travail intérieur.",
  "weva_digests_empty": "Pas encore de réflexions hebdomadaires. Elles apparaissent au fil de ta pratique régulière.",
  "weva_reflects_title": "WEVA réfléchit",
  "weva_reflects_sub": "Le cœur de ce rapport",
  "weva_recommended_title": "Des pratiques pour maintenant",
  "weva_recommended_sub": "Appuie pour ouvrir",
  "weva_beliefs_noticed_title": "Croyances remarquées par WEVA",
  "weva_comp_new_entries": "Nouvelles entrées",
  "weva_comp_practice_days": "Jours de pratique",
  "weva_comp_mood_delta": "Δ humeur moy.",
  "weva_comp_beliefs": "Croyances",
  "weva_generating": "WEVA réfléchit…",
  "weva_no_data": "Aucune donnée sur la période choisie. Pratique d'abord, puis réessaie.",
  "weva_credits_needed": "Ce rapport nécessite 15 crédits (ou un abonnement Plus/Pro). Recharger des crédits ?",
  "weva_scope_sources": "Sources et périodes",
  "weva_reports_left": "rapports restants",
  "weva_report_language": "Langue du rapport",
  "weva_tts_play": "Lire à voix haute",
  "weva_tts_stop": "Arrêter",


  // --- Collaboration (Teilen mit Coach) ---
  "collaboration_2": "Collaboration",
  "decide_who_sees_what_only_coaches_whose": "Décidez qui voit quoi. Seuls les coaches dont vous avez rejoint le cercle peuvent recevoir vos données.",
  "you_re_not_connected_to_any_coach_yet": "Vous n'êtes encore connecté à aucun coach.",
  "inner_circle_2": "Cercle intime",
  "collab_join": "Rejoindre",
  "allow_to_collaborate_with": "Autoriser la collaboration avec :",
  "even_in_a_3_way_chat_each_coach_only": "Même dans une conversation à 3, chaque coach ne voit que les données que vous avez partagées avec LUI. Personne ne voit l'autre côté.",
  "nav.collaboration": "Collaboration",
  "collab_share_events": "Épisodes + émotions",
  "collab_share_hrv": "VFC + signal de fréquence cardiaque",
  "collab_share_plans": "Plans de pratique + calendrier",
  "collab_share_ai_reports": "Rapports d'analyse IA",
  "collab_share_feed": "Activité du fil",
  "collab_not_in_circle": "Hors du cercle restreint",
  "collab_active": "Cercle restreint · actif",
  "collab_join_first": "Rejoins d'abord le cercle restreint de ce coach.",
  "collab_saved": "Partage mis à jour",


  // --- Epic E (Journal depth) + Epic F (Goals) ---
  "goals_action_archive": "Archiver",
  "goals_action_complete": "Marquer comme terminé",
  "goals_actions_body": "Choisis une action pour cet objectif.",
  "goals_actions_title": "Actions de l'objectif",
  "goals_add": "Ajouter",
  "goals_add_first": "Ajouter ton premier objectif",
  "goals_empty_body": "Un objectif aide WEVA et toi-même à voir où tu vas. Ajoute le premier - cela prend 3 minutes.",
  "goals_empty_title": "Aucun objectif pour l'instant",
  "goals_framework_recap": "Ton cadre",
  "goals_last_scale": "Dernier bilan : {n}/10",
  "goals_log_note_ph": "Optionnel : une note sur aujourd'hui (privée)",
  "goals_log_progress": "Enregistrer un progrès",
  "goals_log_prompt": "Où en es-tu aujourd'hui sur cet objectif, de 1 (loin) à 10 (pleinement vécu) ?",
  "goals_more_hint": "Ouvre tous tes objectifs",
  "goals_no_progress_yet": "Aucun progrès enregistré",
  "goals_progress_card": "Progrès",
  "goals_progress_last_n": "Derniers {n} bilans",
  "goals_q1_hint": "Quel sentiment cherches-tu vraiment ? Paix, connexion, confiance en soi, liberté. Écris librement, avec tes mots.",
  "goals_q1_num": "ÉTAPE 1 · INTROSPECTION",
  "goals_q1_placeholder": "Je sens que je cherche…",
  "goals_q1_short": "Besoin émotionnel",
  "goals_q1_title": "Reconnais ton véritable besoin émotionnel.",
  "goals_q2_hint": "Passe du flou au précis. ex. « Je veux répondre avec plus de compassion en cas de conflit » plutôt que « Je veux être plus gentil ».",
  "goals_q2_num": "ÉTAPE 2 · SPÉCIFICITÉ",
  "goals_q2_placeholder": "Concrètement, je veux…",
  "goals_q2_short": "Objectif concret",
  "goals_q2_title": "Rends ton objectif concret.",
  "goals_q3_high": "Pleinement vécu",
  "goals_q3_hint": "C'est ton point de départ - sans jugement. Tu enregistreras des bilans sur la même échelle.",
  "goals_q3_low": "Loin",
  "goals_q3_num": "ÉTAPE 3 · MESURABILITÉ",
  "goals_q3_scale_hint": "1 = loin   ·   10 = pleinement vécu",
  "goals_q3_short": "Point de départ",
  "goals_q3_title": "Où en es-tu aujourd'hui sur cet objectif, de 1 à 10 ?",
  "goals_q4_hint": "Pourquoi ce sentiment compte-t-il pour toi ? Que devient-il possible quand tu le vis ?",
  "goals_q4_num": "ÉTAPE 4 · ATTRAIT",
  "goals_q4_placeholder": "C'est important pour moi parce que…",
  "goals_q4_short": "Ton pourquoi",
  "goals_q4_title": "Relie l'objectif à un pourquoi émotionnel profond.",
  "goals_q5_hint": "Ajuste pour que l'objectif porte sur tes réponses, pas sur ce que les autres doivent faire. Garde-le atteignable.",
  "goals_q5_num": "ÉTAPE 5 · PERTINENCE",
  "goals_q5_placeholder": "C'est sous mon contrôle parce que…",
  "goals_q5_short": "Réalisme",
  "goals_q5_title": "Cet objectif est-il sous ton propre contrôle et réaliste ?",
  "goals_q6_hint": "ex. « Dans les quatre prochaines semaines », « D'ici la fin de l'été ».",
  "goals_q6_num": "ÉTAPE 6 · CADRE TEMPOREL",
  "goals_q6_placeholder": "Dans les prochains…",
  "goals_q6_short": "Cadre temporel",
  "goals_q6_title": "Dans quel cadre temporel veux-tu vivre cela ?",
  "goals_q7_hint": "Dis-le-toi d'abord, puis écris-le ici. C'est ta promesse écrite - bienveillante et honnête.",
  "goals_q7_num": "ÉTAPE 7 · ENGAGEMENT ÉCRIT",
  "goals_q7_placeholder": "Je m'engage à…",
  "goals_q7_short": "Engagement",
  "goals_q7_title": "Écris ton engagement avec tes propres mots.",
  "goals_section_subtitle": "Définis les objectifs qui guident ta pratique.",
  "goals_section_title": "Mes Objectifs",
  "goals_see_all": "Voir les {n} objectifs",
  "goals_status_active": "Actif",
  "goals_status_archived": "Archivé",
  "goals_status_completed": "Terminé",
  "goals_status_paused": "En pause",
  "goals_title_placeholder": "ex. Répondre avec compassion en cas de conflit",
  "goals_view_all": "Voir tous les objectifs",
  "goals_weva_analyze": "Analyser avec WEVA",
  "goals_weva_card_title": "Réflexion de WEVA",
  "goals_weva_challenges": "Invitations douces",
  "goals_weva_enable_body": "WEVA lit tes sept réponses et bilans, puis offre une réflexion bienveillante - forces, invitations douces et un prochain pas doux. Tu peux désactiver à tout moment.",
  "goals_weva_enable_first_body": "Active WEVA pour cet objectif ci-dessus, puis lance l'analyse.",
  "goals_weva_enable_first_title": "Active d'abord la réflexion de WEVA",
  "goals_weva_enable_title": "Laisse WEVA réfléchir sur cet objectif",
  "goals_weva_next_step": "Un prochain pas doux",
  "goals_weva_no_analysis_yet": "Pas encore de réflexion. Touche Analyser pour inviter WEVA.",
  "goals_weva_regenerate": "Réfléchir à nouveau",
  "goals_weva_strengths": "Ce que tu portes déjà",
  "goals_wizard_discard_body": "Tu as déjà commencé. Quitter sans enregistrer ?",
  "goals_wizard_discard_confirm": "Abandonner",
  "goals_wizard_discard_title": "Abandonner cet objectif ?",
  "goals_wizard_final_h": "Presque fini - un dernier choix",
  "goals_wizard_final_hint": "Optionnel : laisse WEVA réfléchir sur cet objectif en privé.",
  "goals_wizard_final_num": "PRESQUE FINI",
  "goals_wizard_recap": "Ton engagement en bref",
  "goals_wizard_recap_title": "Titre",
  "goals_wizard_save": "Enregistrer l'objectif",
  "goals_wizard_step_of": "Étape {n} sur {total}",
  "goals_wizard_title_h": "Donne un nom court à ton objectif",
  "goals_wizard_title_hint": "Une ligne que tu reconnais. Tu peux la changer à tout moment.",
  "goals_wizard_title_num": "TITRE DE L'OBJECTIF",
  "journal_tab_entries": "Entrées du journal",
  "journal_tab_weva": "Insight WEVA",
  "journal_recording": "Enregistrement… appuie pour arrêter",
  "journal_transcribing": "Transcription…",
  "journal_transcription_ready": "Transcription prête. Modifie ou sauvegarde.",
  "journal_tap_to_record": "Appuie pour enregistrer",
  "journal_permission_denied": "Autorisation micro refusée - active-la dans les Réglages système.",
  "journal_locked_voice": "Le journal vocal est une fonctionnalité Plus.",
  "journal_monthly_used": "{n}/{q} entrées utilisées ce mois-ci",
  "journal_saved": "Entrée sauvegardée. Inclus-la dans un rapport WEVA à tout moment pour réfléchir.",
  "journal_empty": "Aucune entrée pour le moment. Ta première réflexion est à une respiration de là.",
  "journal_subtitle": "Ton espace de réflexion privé - écris ou parle.",
  "journal_prompt": "Comment te sens-tu aujourd'hui ? Quelles émotions, situations ou croyances sont présentes en ce moment ?",
  "journal_placeholder": "ex. Ressenti une tension dans ma poitrine avant la réunion. Je croyais que j'allais me figer...",
  "journal_mood": "Humeur",
  "journal_save": "Sauvegarder l'entrée",
  "journal_new_entry": "Nouvelle entrée",
  "journal_tap_to_open": "Touche pour ouvrir",
  "journal_entry_detail_title": "Entrée du journal",
  "journal_take_this_further": "Va plus loin",
  "journal_work_alone_title": "Travaille seul là-dessus",
  "journal_work_alone_sub": "Génère un insight WEVA centré uniquement sur cette entrée pour voir les schémas qu'elle révèle.",
  "journal_work_coach_title": "Travaille avec un coach",
  "journal_work_coach_sub": "Réserve une session — ton entrée sera jointe pour que le coach puisse se préparer.",
  "journal_delete_confirm": "Supprimer cette entrée ? Cette action est irréversible.",
  "journal_weva_included": "Tu as {n} {reportWord} inclus dans ton forfait {plan}.",
  "journal_weva_credits_hint": "Un insight WEVA = 15 crédits. Ou passe à un forfait qui inclut des rapports mensuels.",
  "journal_weva_report_singular": "rapport",
  "journal_weva_report_plural": "rapports",
  "journal_pick_prompt": "Coche 1+ entrées pour concentrer un rapport — ou laisse vide pour les 30 derniers jours.",
  "journal_pick_selected_singular": "{n} entrée sélectionnée",
  "journal_pick_selected_plural": "{n} entrées sélectionnées",
  "journal_pick_clear": "Effacer",
  "journal_pick_empty": "Écris ta première entrée de journal — puis reviens la cocher pour un rapport.",
  "journal_weva_btn_picked": "Générer le rapport WEVA ({n} entrées)",
  "journal_weva_btn_30d": "Générer le rapport WEVA (30 derniers jours)",
  "journal_weva_btn_picked_credits": "Générer le rapport WEVA ({n} entrées) · 15 crédits",
  "journal_weva_btn_30d_credits": "Générer le rapport WEVA (30 derniers jours) · 15 crédits",
  "journal_weva_hint_picked": "WEVA se concentrera sur les entrées cochées et révélera les émotions, croyances et schémas récurrents.",
  "journal_weva_hint_30d": "Combine tes entrées récentes en une histoire cohérente d'émotions, de croyances et de schémas.",
  "journal_weva_history_empty": "Pas encore de rapports WEVA — génère le premier pour voir les schémas dans tes entrées.",
  "journal_weva_report_fallback": "Rapport généré.",
  "journal_journey_title": "Chemine avec un coach",
  "journal_journey_sub": "Quelqu'un qui peut te guider à travers ce que tes entrées révèlent.",
  "journal_new_entry_a11y": "Nouvelle entrée du journal",
  "eva": "WEVA",
  "eva_full_name": "Assistant de Vitalité Émotionnelle et Bien-être",
  "eva_latest_insight": "Dernière analyse WEVA",
  "eva_tag_emotions": "Émotions",
  "eva_tag_beliefs": "Croyances",
  "eva_tag_behaviors": "Comportements",
  "eva_tag_body": "Signaux corporels",
  "eva_tag_situations": "Situations",
  "eva_tag_themes": "Thèmes",
  "eva_reflection": "WEVA réfléchit",
  "picked": "SÉLECTIONNÉ",
  "goal_voice_hint": "Dis-le simplement — nous tapons pour toi.",
  "continue": "Continuer",
  "more": "more",
  "error": "Erreur",
  "done": "Terminé",
  "close": "Fermer",
  "save": "Enregistrer",
  "nav.goals": "Objectifs",
  "jr_voice_hint": "Parle simplement — on l'écrit pour toi.",
  "jr_voice_start": "Enregistrer la voix",
  "jr_voice_stop": "Arrêter l'enregistrement",
  "jr_voice_mic_denied": "Accès au micro refusé. Autorise-le dans le navigateur.",
  "jr_tab_entries": "Entrées",
  "jr_tab_weva": "Aperçu WEVA",

  "goals_coach_cta_title": "Travaille là-dessus avec un coach",
  "goals_coach_cta_sub": "Trouve un coach et réserve pour travailler ensemble sur cet objectif.",


  // --- Epic D (Breathwork client) ---
  "best_for": "Idéal pour",
  "breathwork": "Breathwork",
  "breathwork_insights_sub": "Temps de pratique, réalisations et motifs de tes séances.",
  "breathwork_insights_title": "Aperçus",
  "breathwork_plan_examples": "Plans d'exemple",
  "breathwork_plan_from_coach": "Plan de ton coach",
  "breathwork_plan_sub": "Définis des ancres respiratoires : matin, midi, soir.",
  "breathwork_plan_title": "Ton plan hebdomadaire",
  "breathwork_start_sub": "Choisis une émotion, partage le contexte, respire.",
  "breathwork_start_title": "Démarrer une session",
  "breathwork_subtitle": "Déplace l'émotion dans le corps par le souffle.",
  "breathwork_techniques_sub": "Explore chaque technique avant de commencer.",
  "breathwork_techniques_title": "Bibliothèque de techniques",
  "confirm_decline": "Décliner",
  "confirm_decline_plan_body": "Tu peux toujours créer ta propre version.",
  "confirm_decline_plan_title": "Décliner le plan ?",
  "confirm_delete_plan_body": "Cette action ne peut pas être annulée.",
  "confirm_delete_plan_title": "Supprimer ce plan ?",
  "duration_2": "Durée",
  "explanation_how_it_works": "Comment ça marche",
  "how_to": "Comment faire",
  "intensity_2": "Intensité",
  "intensity_gentle": "doux",
  "intensity_intense": "intense",
  "intensity_medium": "modéré",
  "lib_session_back_btn": "Retour à la bibliothèque",
  "lib_session_note_ph": "Qu'as-tu remarqué ?",
  "lib_session_note_sub": "Une petite note pour toi — facultatif.",
  "lib_session_note_title": "Comment s'est passée ta session ?",
  "lib_session_start_btn": "Démarrer la session",
  "lib_session_wellbeing_sub": "1 = épuisé, 10 = rayonnant",
  "lib_session_wellbeing_title": "Comment te sens-tu maintenant ?",
  "lib_tech_478_body": "La respiration 4-7-8, popularisée par le Dr Andrew Weil, agit comme un tranquillisant naturel pour le système nerveux. L'expiration longue active le nerf vague et prépare le corps au sommeil ou à un calme profond.",
  "lib_tech_478_step1": "Expire complètement par la bouche avec un son doux.",
  "lib_tech_478_step2": "Ferme la bouche, inspire par le nez pendant 4 secondes.",
  "lib_tech_478_step3": "Retiens le souffle pendant 7 secondes.",
  "lib_tech_478_step4": "Expire lentement par la bouche pendant 8 secondes.",
  "lib_tech_478_step5": "Fais 4 cycles, puis observe le calme.",
  "lib_tech_bhramari_body": "Bhramari — la respiration de l'abeille — utilise une expiration bourdonnante douce qui fait vibrer le nerf vague. Apaisement profond, idéal pour l'anxiété, l'insomnie et l'endormissement.",
  "lib_tech_bhramari_step1": "Assieds-toi droit et ferme les yeux.",
  "lib_tech_bhramari_step2": "Inspire lentement par le nez.",
  "lib_tech_bhramari_step3": "À l'expiration, fais un bourdonnement doux d'abeille.",
  "lib_tech_bhramari_step4": "Laisse la vibration remplir ton visage et ta poitrine.",
  "lib_tech_bhramari_step5": "Continue pendant 6 à 10 cycles.",
  "lib_tech_box_body": "La respiration carrée est un rythme simple en 4 temps qui stabilise le système nerveux en quelques minutes. Les forces spéciales l'utilisent avant les décisions difficiles — discrète, portable, efficace partout.",
  "lib_tech_box_step1": "Inspire par le nez pendant 4 secondes.",
  "lib_tech_box_step2": "Retiens l'air en douceur pendant 4 secondes.",
  "lib_tech_box_step3": "Expire par la bouche pendant 4 secondes.",
  "lib_tech_box_step4": "Reste 4 secondes poumons vides.",
  "lib_tech_box_step5": "Répète le carré pendant 3 à 10 minutes.",
  "lib_tech_coherent_body": "La respiration cohérente (5-5) met le souffle et le rythme cardiaque en résonance et augmente la variabilité cardiaque. 5 minutes suffisent pour passer du stress à un état calme et concentré — les cardiologues la recommandent quotidiennement.",
  "lib_tech_coherent_step1": "Inspire doucement par le nez pendant 5 secondes.",
  "lib_tech_coherent_step2": "Expire doucement par le nez pendant 5 secondes.",
  "lib_tech_coherent_step3": "Reste léger — sans forcer, sans tension.",
  "lib_tech_coherent_step4": "Continue pendant 5 à 20 minutes.",
  "lib_tech_cooling_body": "Sitali — le souffle rafraîchissant — refroidit littéralement le corps et l'esprit. Idéal pour les moments chauds : colère, agitation, chaleur corporelle ou bouffées de la ménopause. Un classique du yoga estival.",
  "lib_tech_cooling_step1": "Enroule la langue en tube (ou pince doucement les lèvres).",
  "lib_tech_cooling_step2": "Inspire lentement par la bouche sur la langue fraîche.",
  "lib_tech_cooling_step3": "Ferme la bouche et expire doucement par le nez.",
  "lib_tech_cooling_step4": "Continue pendant 3 à 8 minutes.",
  "lib_tech_kapalabhati_body": "Kapalabhati — le souffle qui illumine le crâne — utilise des expirations vives et des inspirations passives pour énergiser corps et esprit. Idéal le matin. À éviter en cas de vertige ou de grossesse.",
  "lib_tech_kapalabhati_step1": "Inspirations passives, expirations vives par le nez.",
  "lib_tech_kapalabhati_step2": "Le ventre se rétracte à chaque expiration.",
  "lib_tech_kapalabhati_step3": "Commence par 30 impulsions — repos — répète 2 à 3 cycles.",
  "lib_tech_kapalabhati_step4": "Arrête immédiatement en cas de vertige.",
  "lib_tech_nadi_shodhana_body": "La respiration alternée (Nadi Shodhana) équilibre les hémisphères gauche et droit et dissipe le brouillard mental. Technique yogique traditionnelle — 5 minutes pour retrouver la clarté.",
  "lib_tech_nadi_shodhana_step1": "Ferme la narine droite avec le pouce et inspire à gauche.",
  "lib_tech_nadi_shodhana_step2": "Ferme la narine gauche avec l'annulaire et expire à droite.",
  "lib_tech_nadi_shodhana_step3": "Inspire à droite.",
  "lib_tech_nadi_shodhana_step4": "Ferme la narine droite et expire à gauche.",
  "lib_tech_nadi_shodhana_step5": "Ceci est un cycle — fais-en 5 à 10.",
  "lib_tech_ocean_body": "Ujjayi — la respiration de l'océan — crée un doux murmure dans la gorge qui ancre l'attention comme les vagues sur la plage. La respiration classique de méditation et de yoga.",
  "lib_tech_ocean_step1": "Resserre légèrement le fond de la gorge.",
  "lib_tech_ocean_step2": "Respire avec un murmure océanique doux et audible.",
  "lib_tech_ocean_step3": "Seul toi devrais l'entendre.",
  "lib_tech_ocean_step4": "Laisse-le devenir l'ancre de ton attention.",
  "lib_tech_physiological_sigh_body": "Le soupir physiologique est le moyen le plus rapide de relâcher un stress aigu — une double inspiration suivie d'une longue expiration, découvert par le neuroscientifique Dr Andrew Huberman de Stanford. Effet en moins d'une minute.",
  "lib_tech_physiological_sigh_step1": "Prends une longue inspiration lente par le nez.",
  "lib_tech_physiological_sigh_step2": "Ajoute une deuxième inspiration plus courte par-dessus.",
  "lib_tech_physiological_sigh_step3": "Relâche tout avec une longue expiration lente par la bouche.",
  "lib_tech_physiological_sigh_step4": "Répète 1 à 3 fois — sens le changement.",
  "lib_tech_wim_hof_body": "La méthode Wim Hof combine 30 respirations profondes rapides avec une rétention. Elle sature le système en oxygène et construit la résilience. Intense — ne pratique jamais au volant ou dans l'eau.",
  "lib_tech_wim_hof_step1": "Fais 30 respirations profondes — inspiration pleine, expiration relâchée (sans forcer).",
  "lib_tech_wim_hof_step2": "Après la 30ème, expire et retiens tant que c'est confortable.",
  "lib_tech_wim_hof_step3": "Quand tu en as besoin, inspire profondément et retiens 15 secondes.",
  "lib_tech_wim_hof_step4": "Répète 3 à 4 cycles.",
  "lib_tech_wim_hof_step5": "Arrête immédiatement si tu te sens mal — jamais au volant ou dans l'eau.",
  "phase_exhale": "Expire",
  "phase_hold_in": "Retiens",
  "phase_hold_out": "Repose",
  "phase_inhale": "Inspire",
  "popup_adopted": "Adopté ✓",
  "popup_plan_under_myplans": "Le plan est maintenant dans « Mes plans ». Ouvre-le pour l’adapter ou le replanifier.",
  "posture_lying": "Allongé sur le dos, à plat",
  "posture_reclined": "Semi-allongé, soutenu par un bolster",
  "posture_seated_chair": "Assis sur une chaise, pieds à plat",
  "posture_seated_cross": "Assis en tailleur, dos droit",
  "posture_standing": "Debout, bras détendus",
  "recommended_posture": "Posture recommandée",
  "session_done_btn": "Terminé",
  "session_success_body": "Cette respiration en valait la peine. Reste dans cette sensation.",
  "session_success_title": "Bien joué !",
  "tech_478": "Respiration 4-7-8",
  "tech_478_bestfor": "sommeil, anxiété",
  "tech_478_desc": "Inspire 4, retiens 7, expire 8. Calme le système nerveux.",
  "tech_478_step1": "Expirez complètement par la bouche.",
  "tech_478_step2": "Inspirez par le nez pendant 4 secondes.",
  "tech_478_step3": "Retenez 7 secondes.",
  "tech_478_step4": "Expirez par la bouche pendant 8 secondes.",
  "tech_478_step5": "Faites 4 cycles - puis reposez-vous.",
  "tech_bhramari": "Bhramari (souffle d'abeille)",
  "tech_bhramari_bestfor": "tonus vagal, calme",
  "tech_bhramari_desc": "Bourdonne à l'expiration - apaisement vagal.",
  "tech_bhramari_step1": "Asseyez-vous droit, fermez les yeux.",
  "tech_bhramari_step2": "Inspirez par le nez.",
  "tech_bhramari_step3": "En expirant, fredonnez comme une abeille.",
  "tech_bhramari_step4": "Ressentez la vibration au visage et à la poitrine.",
  "tech_bhramari_step5": "Continuez pendant 6–10 rounds.",
  "tech_box": "Respiration Carrée (4-4-4-4)",
  "tech_box_bestfor": "stress, concentration",
  "tech_box_desc": "Égal dedans / retenir / dehors / retenir. Reset rapide.",
  "tech_box_step1": "Inspirez par le nez pendant 4 secondes.",
  "tech_box_step2": "Retenez 4 secondes.",
  "tech_box_step3": "Expirez par la bouche pendant 4 secondes.",
  "tech_box_step4": "Restez à vide 4 secondes.",
  "tech_box_step5": "Répétez pendant 3–10 minutes.",
  "tech_coherent": "Cohérence Cardiaque (5-5)",
  "tech_coherent_bestfor": "ancrage, VFC",
  "tech_coherent_desc": "5s dedans, 5s dehors. Ancre la VRC.",
  "tech_coherent_step1": "Inspirez doucement pendant 5 secondes.",
  "tech_coherent_step2": "Expirez doucement pendant 5 secondes.",
  "tech_coherent_step3": "Restez doux - sans forcer.",
  "tech_coherent_step4": "Continuez pendant 5–20 minutes.",
  "tech_connected": "Respiration Connectée",
  "tech_connected_bestfor": "libération émotionnelle",
  "tech_connected_desc": "Circulaire, sans pause. Libération émotionnelle ; à faire accompagné.",
  "tech_connected_learn_more": "En savoir plus",
  "tech_connected_step1": "Inspiration + expiration continues sans pause.",
  "tech_connected_step2": "Respirez par la bouche ou le nez.",
  "tech_connected_step3": "Ne le faites qu'avec un facilitateur formé ou dans un espace bien tenu.",
  "tech_connected_step4": "Des émotions peuvent surgir — c'est le but.",
  "tech_cooling": "Souffle rafraîchissant (Sitali)",
  "tech_cooling_bestfor": "chaleur, colère, agitation",
  "tech_cooling_desc": "Inspire lentement sur la langue enroulée - libère la chaleur et l'agitation.",
  "tech_cooling_step1": "Roulez la langue en tube (ou pincez les lèvres).",
  "tech_cooling_step2": "Inspirez lentement par la bouche sur la langue fraîche.",
  "tech_cooling_step3": "Fermez la bouche, expirez doucement par le nez.",
  "tech_cooling_step4": "Répétez pendant 3–8 minutes.",
  "tech_kapalabhati": "Kapalabhati (crâne brillant)",
  "tech_kapalabhati_bestfor": "éveil",
  "tech_kapalabhati_desc": "Expirations vives, inspirations passives. Activatrice.",
  "tech_kapalabhati_step1": "Inspirations passives, expirations vives par le nez.",
  "tech_kapalabhati_step2": "Le ventre se rétracte à chaque expiration.",
  "tech_kapalabhati_step3": "Commencez avec 30 pulsations - repos - répétez 2–3 rounds.",
  "tech_kapalabhati_step4": "Arrêtez si vous vous sentez étourdi.",
  "tech_nadi_shodhana": "Nadi Shodhana (narines alternées)",
  "tech_nadi_shodhana_bestfor": "équilibre, concentration",
  "tech_nadi_shodhana_desc": "Équilibre hémisphères gauche/droit.",
  "tech_nadi_shodhana_step1": "Fermez la narine droite, inspirez par la gauche.",
  "tech_nadi_shodhana_step2": "Fermez la gauche, expirez par la droite.",
  "tech_nadi_shodhana_step3": "Inspirez par la droite.",
  "tech_nadi_shodhana_step4": "Fermez la droite, expirez par la gauche.",
  "tech_nadi_shodhana_step5": "C'est un round - faites-en 5–10.",
  "tech_ocean": "Respiration Océan (Ujjayi)",
  "tech_ocean_bestfor": "ancre de méditation",
  "tech_ocean_desc": "Serre légèrement la gorge - ancrage méditatif.",
  "tech_ocean_step1": "Contractez légèrement l'arrière de la gorge.",
  "tech_ocean_step2": "Respirez avec un doux chuchotement océanique.",
  "tech_ocean_step3": "Restez audible uniquement pour vous-même.",
  "tech_ocean_step4": "Laissez-le devenir l'ancre de votre attention.",
  "tech_physiological_sigh": "Soupir Physiologique",
  "tech_physiological_sigh_bestfor": "stress aigu",
  "tech_physiological_sigh_desc": "Double inspiration + expiration longue - baisse rapide du stress.",
  "tech_physiological_sigh_step1": "Prenez une longue inspiration par le nez.",
  "tech_physiological_sigh_step2": "Puis une seconde inspiration plus petite par-dessus.",
  "tech_physiological_sigh_step3": "Expiration longue et lente par la bouche.",
  "tech_physiological_sigh_step4": "Répétez 1–3 fois.",
  "tech_practice_guide_only": "Pratique guidée",
  "tech_practice_guide_only_body": "Cette technique est une pratique guidée - suis les étapes ci-dessus. Un lecteur in-app arrive bientôt.",
  "tech_wim_hof": "Wim Hof",
  "tech_wim_hof_bestfor": "énergie, résilience",
  "tech_wim_hof_desc": "30 respirations profondes → rétention → récupération.",
  "tech_wim_hof_step1": "30 respirations profondes - à fond, laissez sortir (ne forcez pas).",
  "tech_wim_hof_step2": "Après la 30e, expirez et retenez aussi longtemps que confortable.",
  "tech_wim_hof_step3": "Inspirez profondément et retenez 15 secondes.",
  "tech_wim_hof_step4": "Répétez 3–4 rounds.",
  "tech_wim_hof_step5": "Ne jamais faire en conduisant ou dans l'eau.",
  "technique_not_found": "Technique introuvable",
  "ui_accept_activate": "Accepter & activer",
  "ui_adopt": "Adopter ce plan",
  "ui_create_plan": "Créer un plan",
  "ui_days": "jours",
  "ui_decline": "Refuser",
  "ui_min": "min",
  "ui_my_plans": "Mes plans",
  "ui_no_coach_plans_sub": "Quand un coach partage un plan, il apparaît ici.",
  "ui_no_coach_plans_title": "Aucun plan de coach en attente",
  "ui_no_plans_sub": "Crées-en un ou adopte un modèle.",
  "ui_no_plans_title": "Aucun plan pour le moment",
  "ui_pending_action": "en attente de ta réponse",
  "ui_sessions": "sessions",
  "ui_slots": "créneaux",
  "ui_templates_empty_sub": "Actualise ou vérifie ta connexion.",
  "ui_templates_empty_title": "Impossible de charger les exemples",

  "nav.breathwork": "Respiration",
  "nav.breakout": "Breakout",


  // --- Epic G+H (Feed + Messages client) ---
  "feed": "Fil",
  "feed_tab_global": "Global",
  "feed_tab_regional": "Régional",
  "feed_tab_interest": "Centres d'intérêt",
  "feed_search_placeholder": "Cherche un titre, un coach ou un hashtag…",
  "no_posts_yet": "Aucune publication pour le moment.",
  "loading": "Chargement…",
  "coach": "Coach",
  "post_paid_chip": "PAYANT",
  "post_sponsored_chip": "Sponsorisé",
  "unlock_credits": "Débloquer · {n} crédits",
  "paid_locked": "Aperçu payant",
  "post_book_now": "Réserver",
  "post_action_react": "Réagir",
  "post_action_comment": "Commenter",
  "post_action_save": "Enregistrer",
  "post_action_share": "Partager",
  "report_post_title": "Signaler cette publication",
  "report_reason_spam": "Spam ou trompeur",
  "report_reason_inappropriate": "Contenu inapproprié",
  "report_reason_medical_claim": "Allégation médicale non vérifiée",
  "report_reason_other": "Autre",
  "reported": "Signalé. Merci.",
  "description": "Description",
  "submit": "Envoyer",
  "reaction_heart": "Cœur",
  "reaction_inspired": "Inspiré",
  "reaction_moved": "Touché",
  "reaction_strong": "Fort",
  "block_user_cta": "Bloquer cet utilisateur",
  "chats": "Messages",
  "chats_tab_all": "Tous",
  "chats_tab_circles": "Cercles",
  "chats_tab_direct": "Direct",
  "chats_tab_shared": "Partagés",
  "no_conversations": "Aucune conversation pour le moment.",
  "my_circles": "Mes cercles",
  "shared_chats": "Conversations de coaching partagées",
  "direct_messages": "Messages privés",
  "three_way_care": "Accompagnement à 3",
  "members": "membres",
  "message_deleted": "Message supprimé",
  "message": "Message",
  "no_messages_hint": "Envoie un message pour démarrer la conversation.",
  "write_a_message": "Écris un message...",
  "delete_message_title": "Supprimer le message ?",
  "delete_message_confirm": "Ce message sera remplacé par un marqueur « supprimé » pour tout le monde dans le chat.",
  "something_went_wrong": "Quelque chose s'est mal passé. Réessaie.",
  "nav.feed": "Fil",
  "nav.messages": "Messages",
  "feed_comments_title": "Commentaires",
  "feed_no_comments": "Pas encore de commentaires. Sois la première voix bienveillante.",
  "feed_write_comment": "Écris un commentaire…",
  "feed_add_comment": "Publier",
  "feed_unlocked": "Débloqué",
  "feed_open_post": "Ouvrir le post",
  "feed_credits_needed": "Ce post coûte {n} crédits. Recharger maintenant ?",
  "msg_support": "Support",
  "msg_new_chat": "Nouveau message",

  "messages": "Messages",
  "chats_support_btn": "Support",
  "join_by_code": "Un code d'invitation ?",
  "chats_join_placeholder": "Saisir le code",
  "join": "Rejoindre",
  "chats_invalid_code": "Code invalide",
  "circles_empty_sub": "Lorsqu'un coach vous invite à un cercle, il apparaîtra ici.",
  "new_chat_fab_a11y": "Démarrer une nouvelle conversation",
  "shared_coaching_chat": "Chat de coaching partagé",
  "shared_chat_banner": "Tous les membres peuvent voir les messages de ce chat partagé.",
  "shared_chat_no_access_title": "Ce chat est privé",
  "shared_chat_no_access_body": "Seuls les membres de ce chat de coaching partagé peuvent voir les messages.",
  "shared_chat_empty": "Aucun message pour l'instant. Lancez la conversation.",
  "shared_chat_placeholder": "Écrire à tous …",
  "new_chat_title": "Nouveau chat",
  "new_chat": "Nouveau chat",
  "new_chat_pick_coach": "Choisir un coach",
  "new_chat_pick_second": "Choisir un second coach",
  "new_chat_shared_toggle": "Démarrer un chat partagé avec deux coachs",
  "new_chat_search_placeholder": "Rechercher des coachs …",
  "new_chat_no_results": "Aucun coach trouvé.",
  "new_chat_cancel": "Annuler",
  "new_chat_start_btn": "Démarrer le chat",
  "new_chat_start_shared_btn": "Démarrer le chat partagé",
  "new_chat_error_same_coach": "Veuillez choisir deux coachs différents.",
  "post_details": "Publication",
  "post_not_found": "Publication introuvable.",
  "comment_sheet_title": "Commentaires ({n})",
  "comment_empty": "Aucun commentaire. Soyez le premier.",
  "comment_input_placeholder": "Écrire un commentaire …",
  "series_progress": "{viewed}/{total} vus",
  "panic_attack_btn": "Attaque de panique",
  "panic_attack_btn_sub": "Aide respiratoire guidée",
  "panic_picker_title": "Où en es-tu maintenant ?",
  "panic_picker_sub": "Choisis la phase qui correspond — nous te guidons vers la bonne respiration.",
  "panic_stage_early_title": "Premiers signes",
  "panic_stage_early_sub": "Agitation intérieure, l'anxiété monte",
  "panic_stage_acute_title": "Urgence aiguë",
  "panic_stage_acute_sub": "Attaque de panique complète, essoufflement",
  "panic_stage_subside_title": "Phase d'apaisement",
  "panic_stage_subside_sub": "Le corps tremble, le pouls redescend lentement",
  "panic_stage_prevent_title": "Prévention",
  "panic_stage_prevent_sub": "Au quotidien, sans anxiété aiguë",
  "panic_tech_2_4": "Respiration 2-4",
  "panic_tech_pursed": "Souffle sur les lèvres · posture du gardien",
  "panic_tech_478": "Respiration 4-7-8",
  "panic_tech_diaphragm": "Respiration diaphragmatique",
  "panic_technique_label": "Technique",
  "panic_intro_early_title": "Apaise la vague qui monte",
  "panic_intro_early_body": "Cette technique empêche l'hyperventilation. L'expiration prolongée signale la sécurité à ton cerveau très tôt.",
  "panic_intro_acute_title": "Soulagement immédiat pour les poumons",
  "panic_intro_acute_body": "Effet immédiat : la résistance des lèvres pousse l'air usé hors des poumons et stoppe l'essoufflement aigu.",
  "panic_intro_subside_title": "Un sédatif naturel",
  "panic_intro_subside_body": "Agit comme un sédatif naturel. La longue rétention et l'expiration forcent le système cardio-vasculaire dans une relaxation profonde.",
  "panic_intro_prevent_title": "Entraîne ton diaphragme chaque jour",
  "panic_intro_prevent_body": "Entraîne le diaphragme et abaisse durablement le niveau de stress, pour que le corps réagisse moins fort en crise.",
  "panic_body_hint_early": "Assieds-toi ou tiens-toi droit. Respire doucement par le nez.",
  "panic_body_hint_acute": "Posture du gardien : penche-toi légèrement vers l'avant, mains sur les genoux, lèvres pincées comme pour souffler une bougie.",
  "panic_body_hint_subside": "Assieds-toi bien droit. Pointe de la langue derrière les dents du haut. Expire avec un doux « whoosh ».",
  "panic_body_hint_prevent": "Pose une main sur ton ventre. Il se soulève à l'inspiration, s'abaisse à l'expiration.",
  "panic_intensity_recap_title": "À quel point ta panique était-elle intense ?",
  "panic_intensity_scale_hint": "1 = calme, 10 = maximum",
  "panic_intensity_continue": "Continuer",
  "panic_analytics_title": "Analyses d'attaques de panique",
  "panic_analytics_sub": "Ta réponse à la panique dans le temps.",
  "breathe_easy_btn": "Respirer Facilement",
  "breathe_easy_btn_sub": "Pour BPCO et essoufflement",
  "copd_picker_title": "Quelle situation correspond ?",
  "copd_picker_sub": "Choisis une technique — nous te guidons pas à pas.",
  "copd_stage_pursed_title": "Souffle sur les lèvres",
  "copd_stage_pursed_sub": "Essoufflement aigu, après l'effort",
  "copd_stage_belly_title": "Respiration abdominale",
  "copd_stage_belly_sub": "Phases de repos, relaxation",
  "copd_stage_contact_title": "Respiration par contact",
  "copd_stage_contact_sub": "Stress, ventilation profonde ciblée",
  "copd_stage_huff_title": "Huffing",
  "copd_stage_huff_sub": "Mucus tenace dans les voies respiratoires",
  "copd_stage_acbt_title": "Cycle actif de respiration",
  "copd_stage_acbt_sub": "Nettoyage quotidien des poumons",
  "copd_intro_pursed_title": "Stabilise tes voies respiratoires",
  "copd_intro_pursed_body": "Stabilise tes voies respiratoires et empêche leur collapsus — soulagement immédiat en cas d'essoufflement.",
  "copd_intro_belly_title": "Plus de volume, moins d'effort",
  "copd_intro_belly_body": "Utilise le diaphragme au lieu d'une respiration thoracique superficielle. Plus de volume, moins d'effort.",
  "copd_intro_contact_title": "Les mains guident le souffle",
  "copd_intro_contact_body": "Tes mains dirigent l'attention vers des zones spécifiques des poumons et approfondissent la respiration.",
  "copd_intro_huff_title": "Déplacer le mucus sans forcer",
  "copd_intro_huff_body": "Fait remonter le mucus tenace sans stresser les voies respiratoires.",
  "copd_intro_acbt_title": "Détends · Ventile · Nettoie",
  "copd_intro_acbt_body": "Une routine quotidienne en trois phases : détendre, ventiler, nettoyer.",
  "copd_pursed_step1": "Inspire doucement par le nez.",
  "copd_pursed_step2": "Pose les lèvres légèrement l'une contre l'autre — comme pour siffler.",
  "copd_pursed_step3": "Expire lentement contre la résistance des lèvres. Deux fois plus long que l'inspiration.",
  "copd_belly_step1": "Assieds-toi ou allonge-toi confortablement.",
  "copd_belly_step2": "Pose une main sur ton ventre.",
  "copd_belly_step3": "Inspire — sens ta main se soulever.",
  "copd_belly_step4": "Expire — idéalement lèvres pincées.",
  "copd_contact_step1": "Pose les mains à plat sur les côtes ou le bas-ventre.",
  "copd_contact_step2": "En expirant, aide doucement avec les mains.",
  "copd_contact_step3": "En inspirant, pousse contre les mains.",
  "copd_huff_step1": "Inspire profondément.",
  "copd_huff_step2": "Ouvre grand la bouche — comme pour embuer un miroir.",
  "copd_huff_step3": "Expire l'air par bouffées fortes et courtes — son « haff ».",
  "copd_acbt_p1_body": "Respire normalement et détendu pendant quelques minutes.",
  "copd_acbt_p2_body": "3–4 respirations profondes, chacune tenue 3 secondes.",
  "copd_acbt_p3_body": "Fais remonter le mucus dégagé, puis tousse doucement.",
  "copd_step_next": "Continuer",
  "copd_intensity_title": "Comment était ta respiration ?",
  "copd_intensity_scale_hint": "1 = facile, 10 = très difficile",
  "copd_intensity_before_short": "Avant",
  "copd_intensity_after_short": "Maintenant",
  "copd_intensity_continue": "Continuer",
  "copd_analytics_title": "Analyses respiratoires",
  "copd_analytics_sub": "Tes schémas respiratoires dans le temps.",
  "posture_coach_title": "Position du cocher",
  "posture_coach_sub": "Bord de la chaise, jambes écartées, coudes sur les cuisses, tête relâchée vers l'avant.",
  "posture_goalkeeper_title": "Position du gardien",
  "posture_goalkeeper_sub": "Genoux légèrement pliés, penche-toi en avant, mains sur les cuisses.",
  "posture_wall_title": "Position contre le mur",
  "posture_wall_sub": "Appuie ton dos ou ton côté contre un mur.",
  "posture_lay_title": "Allongé à plat",
  "posture_lay_sub": "Sur le dos, genoux légèrement fléchis, tête posée sur le côté.",
  "posture_upright_title": "Assis droit",
  "posture_upright_sub": "Bord de la chaise, pieds à plat, dos long, épaules détendues.",
  "posture_recommended_title": "Ta posture",
  "posture_recommended_sub": "Choisis celle qui te convient le mieux.",
  "explanation_ready_btn": "Je suis prêt",
  "analytics_sect_trend": "Tendance hebdo.",
  "analytics_sect_situations": "Situations",
  "analytics_sect_techniques": "Techniques",
  "analytics_sect_postures": "Postures",
  "analytics_sect_timeline": "Historique",
  "analytics_no_sessions": "Aucune séance pour l'instant.",
  "analytics_no_sessions_sub": "Termine ta première respiration guidée pour voir les stats ici.",
  "analytics_no_data": "Aucune donnée",
  "analytics_kpi_sessions": "Séances",
  "analytics_kpi_avg_before": "Moy. avant",
  "analytics_kpi_avg_after": "Moy. après",
  "analytics_kpi_reduction": "Réduction moy.",
  "analytics_before_short": "Avant",
  "analytics_sec": "s",
  "analytics_stage_early": "Premiers signes",
  "analytics_stage_acute": "Urgence aiguë",
  "analytics_stage_subside": "En diminution",
  "analytics_stage_prevent": "Prévention",
  "analytics_tech_pursed_lip": "Lèvres pincées",
  "analytics_tech_4_7_8": "Respiration 4-7-8",
  "analytics_tech_diaphragmatic": "Diaphragmatique",
  "analytics_tech_belly": "Respiration ventrale",
  "analytics_tech_contact": "Respiration de contact",
  "analytics_tech_huff": "Huffing",
  "analytics_tech_acbt": "Cycle actif (ACBT)",
  "analytics_posture_coach": "Position du cocher",
  "analytics_posture_goalkeeper": "Gardien de but",
  "analytics_posture_wall": "Contre le mur",
  "analytics_posture_lay": "Allongé",
  "analytics_posture_upright": "Assis droit",
  "analytics_posture_none": "Sans posture",
  "analytics_tech_2_4_breathing": "Respiration 2-4",
  "analytics_tech_pursed": "Lèvres pincées",
  "settings": "Réglages",
  "language": "Langue",
  "event_display_pref": "Afficher les événements comme",
  "by_technique": "Technique",
  "by_emotion": "Émotion",
  "by_base_situation": "Situation de base",
  "privacy_and_data": "Confidentialité et données",
  "upgrade_plan": "Changer de formule",
  "upgrade_to_coach": "Passer au compte coach",
  "mode": "Mode",
  "switch_to_coach_view": "Passer à la vue coach",
  "sign_out": "Se déconnecter",
  "disclaimer": "Cette app soutient l'autorégulation émotionnelle et ne remplace pas les soins médicaux, psychologiques ou d'urgence.",
  "download_my_data": "Télécharger mes données",
  "gdpr_art20": "Obtenir une copie de tout (RGPD Art. 20)",
  "terms_of_service": "Conditions d'utilisation",
  "privacy_policy": "Politique de confidentialité",
  "refund_policy": "Politique de remboursement",
  "blocked_users_title": "Utilisateurs bloqués",
  "blocked_users_empty": "Vous n'avez encore bloqué personne.",
  "delete_my_account": "Supprimer mon compte",
  "delete_my_account_sub": "Permanent · suppression totale des données",
  "delete_account_confirm_title": "Supprimer définitivement le compte ?",
  "delete_account_confirm_body": "Cette action est irréversible. Toutes les données de journal, de chat et de pratique seront effacées.",
  "delete_account_confirm_cta": "Supprimer",
  "need_help_now": "Besoin d'aide maintenant ?",
  "crisis_helplines": "Lignes d'urgence · numéros d'assistance",
  "data_sharing": "Partage de données",
  "data_sharing_sub": "Choisis ce que chaque coach peut voir",
  "data_sharing_ic_badge": "Inner Circle",
  "data_sharing_n_shared": "{count} partagés",
  "data_sharing_none_shared": "Rien partagé",
  "data_sharing_intro": "Choisis précisément ce que {coachName} peut voir. Tu peux modifier à tout moment.",
  "data_sharing_save": "Enregistrer",
  "data_sharing_updated": "Mis à jour {when}",
  "data_sharing_none_available_body": "Tu n'es connecté à aucun coach pour le moment. Réserve une séance ou rejoins un Inner Circle.",
  "profile": "Profil",
  "profile_subtitle": "Ton compte, coachs et lien de parrainage.",
  "edit_name": "Modifier le nom",
  "email": "Email",
  "phone": "Numéro de téléphone",
  "country": "Pays",
  "country_pick_hint": "Veuillez sélectionner votre pays",
  "contraindications": "Contre-indications",
  "contraindications_hint": "Nous éviterons les techniques qui pourraient ne pas être sûres pour toi.",
  "weekly_report_title": "E-mail hebdomadaire de pratique",
  "weekly_report_hint": "Un résumé doux de ta semaine chaque dimanche soir.",
  "saved": "Enregistré ✓",
  "invite_friends_earn": "Invite des personnes amies · gagne 5 € chacun",
  "invite_friends_sub": "Vous êtes tous les deux récompensés après sa première séance",
  "account": "Compte",
  "edit_profile": "Modifier le profil",
  "account_more": "Plus",
  "account_manage": "Gérer le compte",
  "consent_forms_title": "Consentements",
  "consent_forms_sub": "Vos formulaires de consentement signés.",
  "consent_forms_empty": "Aucun formulaire signé pour l'instant.",
  "consent_signed_on": "Signé le {when}",
  "consent_version": "Version {v}",
  "unblock": "Débloquer",
  "bio_label": "À propos de vous",
  "export_started": "Votre export de données est en cours de téléchargement.",
  "delete_code_prompt": "Saisissez le code {code} pour confirmer la suppression définitive :",
  "delete_code_mismatch": "Le code ne correspond pas. Le compte n'a PAS été supprimé.",
  "profile_account_section": "Détails du compte",
  "profile_health_section": "Santé",
  "add": "Ajouter",
  "create_account_cta": "Créer un compte",
  "safety": "Sécurité",
  "you_re_not_alone": "Vous n'êtes pas seul(e)",
  "if_you_are_in_immediate_danger_call": "Si vous êtes en danger immédiat, appelez votre numéro d'urgence local maintenant.",
  "your_country": "Votre pays",
  "safety_other": "Autre…",
  "choose_country": "Choisir le pays",
  "search_country": "Rechercher un pays…",
  "no_match_try_a_different_name": "Aucun résultat. Essayez un autre nom.",
  "my_within_is_not_a_medical_device_or_a": "My Within n'est pas un dispositif médical ni un substitut aux soins professionnels. Si vous travaillez avec un thérapeute ou un médecin, veuillez continuer à suivre leurs conseils.",
  "help_faq": "Aide et FAQ",
  "search_all_help_articles": "Rechercher dans tous les articles d'aide…",
  "new_support_request": "Nouvelle demande d'assistance",
  "start_a_new_support_chat": "Démarrer une nouvelle discussion d'assistance",
  "your_email": "Votre e-mail",
  "you_email_com": "vous@email.com",
  "describe_your_issue": "Décrivez votre problème…",
  "suppor_send": "Envoyer",
  "suppor_reply": "Répondre…",
  "my_within_ai": "My Within AI",
  "status": "Statut",
  "my_within_team": "💬 Équipe My Within",
  "forwarded_to_a_human_reply_arriving_by": "↳ Transféré à une personne - réponse par e-mail à venir.",
  "popup_email_required": "E-mail requis",
  "popup_email_for_reply": "Indique ton e-mail pour que nous puissions te répondre.",
  "this_week": "Cette semaine",
  "sessions": "séances",
  "streak_days": "Série",
  "avg_drop": "Ø baisse",
  "digest_unique_days": "Jours de pratique",
  "digest_avg_duration": "Durée moyenne",
  "digest_biggest_drop": "Plus gros changement",
  "digest_top_emotion": "Émotion dominante",
  "digest_top_technique": "Technique favorite",
  "digest_empty_client": "Pas de session cette semaine — une respiration compte.",
  "digest_email_me": "Me l'envoyer par mail",
  "digest_hint_client": "Ton digest arrive chaque dimanche soir par mail.",
  "digest_sent_title": "Envoyé dans ta boîte",
  "digest_sent_body": "Vérifie ton email pour le digest complet.",
  "digest_trend_4w": "4 dernières semaines",
  "friendly_error_title": "Un instant",
  "coach_earnings_cashable": "Revenus coach (disponibles)",
  "coach_earnings_held": "Revenus coach (en attente)",
  "credits_2": "Crédits",
  "no_transactions_yet": "Aucune transaction pour le moment.",
  "purchases_refunds_and_coach_earnings": "Les achats, remboursements et revenus de coaching apparaîtront ici.",
  "transaction_history": "Historique des transactions",
  "abbrechen_und_neu_starten": "Annuler et recommencer",
  "bevor_dein_vorteil_aktiviert_wird": "Avant l'activation de votre avantage, nous vérifierons un moyen de paiement via Stripe. Aucune somme ne sera débitée — juste une carte sécurisée enregistrée.",
  "case_insensitive_format_mw_gefolgt_von": "Non sensible à la casse · Format : MW- suivi d'une courte combinaison de lettres et de chiffres.",
  "dein_code": "Votre code",
  "dein_vorteil_wurde_deinem_account": "Votre avantage a été crédité sur votre compte.",
  "hast_du_unsere_crowdfunding_kampagne": "Avez-vous soutenu notre campagne de crowdfunding ? Entrez votre code de soutien et votre avantage sera activé immédiatement après une vérification rapide du paiement.",
  "kein_code_erhalten": "Vous n'avez pas reçu de code ?",
  "mw_xxx_xxxx": "MW-XXX-XXXX",
  "pledge_code_einlo_sen": "Échanger un code de soutien",
  "support_my_within_com": "support@my-within.com",
  "warte_auf_deine_ru_ckkehr": "En attente de votre retour...",
  "weiter_zur_zahlungsverifizierung": "Continuer vers la vérification du paiement",
  "willkommen_bei_my_within": "Willkommen bei My Within",
  "zuru_ck_zur_startseite": "Retour à l'accueil",
  "ai_verdict": "Verdict IA",
  "become_coach_complete_steps": "Termine les deux étapes ci-dessous pour débloquer les cercles, les publications, les produits et les abonnements payants.",
  "become_coach_full_access": "Tu as un accès complet aux fonctionnalités de monétisation coach.",
  "become_coach_rejected": "Téléverse un certificat plus lisible ou écris à renew@insideoutharmony.com.",
  "become_coach_title": "Devenir coach",
  "dpa_accept": "Accepter l'accord",
  "dpa_accept_button": "Accepter l'accord de responsabilité conjointe",
  "dpa_body": "En tant que coach, toi et Inside Out Harmony e.U. êtes {joint} des données de vos clients selon l'art. 26 du RGPD. Tu t'engages à ne traiter les données des clients que sur la plateforme, à ne jamais les exporter ni les copier à l'extérieur et à signaler tout incident sous 24 heures.",
  "dpa_joint_controllers": "coresponsables",
  "dpa_read_full": "Lire l'accord complet →",
  "dpa_title": "Accord de responsabilité conjointe (DPA)",
  "not_yet_verified": "Pas encore vérifié",
  "once_verified": "Une fois vérifié, tu pourras :",
  "popup_approved_check": "Approuvé ✅",
  "popup_couldnt_read_image": "Impossible de lire l'image",
  "popup_error_title": "Un problème est survenu",
  "popup_submitted": "Envoyé",
  "qual_cert_areas": "Domaines acceptés : respiration, méditation, pleine conscience, yoga thérapeutique, coaching, psychologie, thérapie, expérience somatique et titres de bien-être associés.",
  "qual_cert_before_verified": "Les parrainages fonctionnent même avant la vérification.",
  "qual_cert_hint": "Téléverse une photo/scan clair de ta certification de coaching, thérapie, respiration ou bien-être. L'IA la vérifie en quelques secondes. Si nous ne pouvons pas la valider automatiquement, un admin la relit sous 48 h.",
  "qual_cert_reupload": "Téléverser à nouveau le certificat",
  "qual_cert_title": "Certificat de qualification",
  "qual_cert_upload": "Téléverser le certificat",
  "qual_cert_upload_short": "Téléverser le certificat",
  "account_help": "Aide",
  "account_support": "Support",
  "account_purchases": "Historique d'achats",
  "account_redeem": "Utiliser un code",
  "help_search_empty": "Aucun résultat pour « {q} ». Essayez d'autres mots ou ouvrez le Support.",
  "purchases_balance": "Solde",
  "weekly_digest_email_toggle": "Résumé hebdomadaire par e-mail",
  "redeem_needs_payment": "Vérification de paiement requise. Terminez-la dans l'application mobile.",
  "redeem_invalid": "Code invalide ou déjà utilisé.",
  "support_resolved": "Résolu",
  "ok": "OK",
  "guest_cta_title": "Créez un compte",
  "guest_cta_body": "Inscrivez-vous d'abord pour lancer la vérification en tant que coach.",

  // Breakout (Wave 1 · client parity)
  "breakout": "Breakout",
  "breakout_tab_sub": "Un chemin guidé du ressenti au soulagement.",
  "breakout_start_session": "Démarrer une session",
  "breakout_start_sub": "Choisis une émotion, partage le contexte, respire.",
  "breakout_how_it_works": "Comment ça marche",
  "breakout_step1": "Nomme l'émotion",
  "breakout_step2": "Partage la situation",
  "breakout_step3": "Évalue l'intensité 1–10",
  "breakout_step4": "Reçois une technique adaptée",
  "breakout_step5": "Respire avec le guide",
  "breakout_step6": "Évalue l'intensité à nouveau",
  "breakout_step7": "Enregistrer et revoir",
  "what_feeling": "Que ressens-tu ?",
  "base_situation": "Quelle est la situation de base ?",
  "base_situation_hint": "Où se situe ce ressenti ?",
  "bs_work": "Travail",
  "bs_private": "Privé",
  "bs_public": "Public",
  "bs_togetherness": "Ensemble",
  "bs_family": "Famille",
  "bs_health": "Santé",
  "bs_financial": "Financier",
  "bs_learning": "Apprentissage",
  "bs_other": "Autre",
  "how_intense": "Quelle est son intensité ?",
  "intensity_scale_hint": "1 = à peine là · 10 = submergé",
  "situation_belief_after_hint": "Nous te poserons des questions sur la situation et ta croyance après la respiration pour que tu puisses commencer tout de suite.",
  "try_technique": "Essayer {name}",
  "how_it_works_row": "Comment ça marche",
  "expected": "Attendu",
  "duration": "Durée",
  "caution": "Attention",
  "min": "min",
  "begin_breathing": "Commencer à respirer",
  "step_of": "Étape {n} sur {total}",

  // Share Cards (Wave 1 · client parity)
  "share_cards_title": "Cartes à partager",
  "sc_tab_all": "Toutes les cartes",
  "sc_tab_sent": "Envoyées",
  "sc_filter_all": "Toutes",
  "sc_filter_client": "Cartes client",
  "sc_filter_coach": "Cartes coach",
  "sc_empty_filter": "Aucune carte dans ce filtre.",
  "sc_empty_sent_head": "Aucune carte partagée",
  "sc_empty_sent_body": "Dès que vous partagez une carte, elle apparaît ici.",
  "sc_browse": "Voir les cartes",
  "sc_share_moment": "Partagez votre moment",
  "sc_share_details": "Partager plus de détails (émotion, intensité)",
  "sc_your_link": "Votre lien personnel",
  "sc_copy": "Copier",
  "sc_copied": "Lien copié",
  "sc_step1": "Cliquez sur « Copier le lien »",
  "sc_step2": "Partagez la carte sur votre canal",
  "sc_step3": "Collez le lien copié dans la légende",
  "sc_steps_note": "Ce n'est qu'avec votre lien que vous gagnez dans le programme d'affiliation.",
  "sc_download": "Télécharger",
  "sc_share": "Partager",
  "sc_fine": "Quand on clique sur votre lien, on arrive automatiquement sur la landing de la phase active.",
  "nav.share_cards": "Cartes",

  // Story Wall (Wave 1 · client parity)
  "story_wall_coach_title": "Story Wall",
  "story_wall_coach_sub": "Partage des moments du chemin de tes client·e·s — avec double consentement uniquement.",
  "story_wall_coach_empty": "Pas encore de moment.",
  "story_wall_coach_empty_cta": "Capturer mon premier moment",
  "story_wall_create_title": "Capturer un moment",
  "story_wall_client_lbl": "Client·e",
  "story_wall_kind_lbl": "Type",
  "story_wall_kind_reflection": "Réflexion",
  "story_wall_kind_wellbeing_shift": "Bien-être",
  "story_wall_kind_streak": "Série",
  "story_wall_kind_quote": "Citation",
  "story_wall_kind_milestone": "Jalon",
  "story_wall_title_lbl": "Titre",
  "story_wall_title_ph": "Titre court — p. ex. « De 8 à 3 »",
  "story_wall_body_lbl": "Description",
  "story_wall_body_ph": "Que s'est-il passé ? Chaleureux, précis et respectueux.",
  "story_wall_metric_lbl": "Métrique (facultatif)",
  "story_wall_metric_ph": "p. ex. « 8 → 3 » ou « 30 jours »",
  "story_wall_color_lbl": "Accent de couleur",
  "story_wall_double_consent_note": "Après l'enregistrement, ta cliente ou ton client doit confirmer le texte exact. Alors seulement tu peux publier.",
  "story_wall_missing_fields": "Choisis un·e client·e et écris titre + description.",
  "story_wall_draft_save": "Enregistrer le brouillon",
  "story_wall_publish": "Publier",
  "story_wall_unpublish": "Retirer du mur",
  "story_wall_archive": "Supprimer",
  "story_wall_archive_confirm_title": "Supprimer ce moment ?",
  "story_wall_archive_confirm_body": "L'enregistrement est archivé et n'apparaît plus sur le Story Wall.",
  "story_wall_status_draft": "Brouillon",
  "story_wall_status_published": "En ligne",
  "story_wall_status_unlisted": "Non listé",
  "story_wall_review": "Modifier",
  "story_wall_review_and_agree": "Donner mon consentement",
  "story_wall_coach_consent_lbl": "Ton consentement",
  "story_wall_client_consent_lbl": "Consentement du/de la client·e",
  "story_wall_consent_pending": "En attente",
  "story_wall_consent_granted": "Accordé",
  "story_wall_consent_waiting_client": "En attente du/de la client·e",
  "story_wall_consent_grant": "Oui, publier",
  "story_wall_consent_revoke": "Révoquer",
  "story_wall_coach_consent_title": "Ton consentement",
  "story_wall_coach_consent_body": "Confirme que ce texte peut apparaître publiquement. Tu peux révoquer à tout moment.",
  "story_wall_show_name_lbl": "Afficher mon nom",
  "story_wall_show_name_coach_sub": "Par défaut : ton nom reste privé.",
  "story_wall_show_name_client_sub": "Par défaut : seule ton initiale est affichée.",
  "story_wall_publish_needs_consents": "Attends que les deux parties aient accepté.",
  "story_wall_client_title": "Moments en attente",
  "story_wall_client_sub": "Ton coach souhaite partager ces moments. Ils ne sont publiés qu'avec ton accord.",
  "story_wall_client_empty": "Aucun moment en attente.",
  "story_wall_client_consent_title": "Es-tu d'accord ?",
  "story_wall_client_consent_sub": "Vérifie le texte exact ci-dessous. Rien n'est public sans ton accord.",
  "story_wall_client_consent_thanks_title": "Merci 🌿",
  "story_wall_client_consent_thanks_body": "Ton coach est notifié·e et peut publier.",
  "story_wall_privacy_note": "Nous ne stockons que ce qui est écrit ci-dessus. Tu peux révoquer à tout moment — le moment disparaît immédiatement.",
  "story_wall_grant": "J'accepte",
  "story_wall_decline": "Refuser",
  "story_wall_by_coach": "par {name}",
  "story_wall_by_coach_anonymous": "par un·e coach",
  "story_wall_browse_public": "Voir le mur public",
  "story_wall_public_title": "Story Wall",
  "story_wall_public_sub": "Moments réels de la communauté my-within — partagés avec le consentement de tous.",
  "story_wall_public_empty": "Pas encore de moments publics.",
  "story_wall_filter_all": "Tous",
  "story_wall_moment_title": "Moment",
  "story_wall_moment_missing_title": "Moment introuvable",
  "story_wall_moment_missing_body": "Ce moment n'est plus public ou a été révoqué.",
  "story_wall_share_title": "Partager ce moment",
  "story_wall_share_body": "Je viens de découvrir ce moment sur my-within : {title}",
  "story_wall_share_copied": "Lien copié",
  "story_wall_share_copied_body": "Le lien est dans ton presse-papiers.",
  "story_wall_share_cta": "Partager",
  "story_wall_share_open_card": "Ouvrir la fact-card",

  // Story Mode (Wave 1 · client parity)
  "nav.story_wall": "Mur d'histoires",
  "nav.story_mode": "Mode récit",
  "sm_title": "Mode récit",
  "sm_cover_eyebrow": "Un mémoire privé de vos mois ici",
  "sm_cover_title": "Les chapitres que vous avez gardés.",
  "sm_cover_meta": "{entries} entrées sur {days} jours · {chapters} chapitres",
  "sm_cover_body": "C'est l'espace où vivent vos mots. Rien ici n'est partagé avec votre coach — cette chronologie n'est que pour vous. Faites défiler lentement. Lisez-vous comme un livre.",
  "sm_empty_title": "Rien à raconter pour l'instant.",
  "sm_empty_body": "Quelques entrées de journal, une ou deux pratiques — et le premier chapitre s'écrit tout seul. Revenez dans une semaine ou deux.",
  "sm_chapter": "Chapitre {n}",
  "sm_kind_journal": "Journal",
  "sm_kind_practice": "Pratique",
  "sm_kind_breakout": "Breakout",
  "sm_kind_booking": "Séance",
  "sm_mood": "humeur {a} → {b}",
  "sm_intensity": "intensité {a} → {b}",
  "sm_download_pdf": "Télécharger en PDF",
  "sm_footer_note": "Votre histoire reste avec vous. Le PDF est privé, téléchargé sur cet appareil.",

  // Welle 2 · Client-Extras (Collections · Focus-Timer · Connected-Breath · Method-Player · Unlocked)
  "collections_title": "Mes collections",
  "collections_empty_title": "Aucune collection",
  "collections_empty_sub": "Appuie sur l'icône de marque-page d'un post pour commencer.",
  "collections_n_posts": "{n} posts",
  "collections_public": "Public",
  "collections_private": "Privé",
  "collections_not_found": "Cette collection n'existe plus.",
  "collections_now_private": "De nouveau privée",
  "collections_now_private_body": "Le lien ne fonctionne plus.",
  "collections_now_public": "Collection publique",
  "collections_now_public_body": "Toute personne avec le lien peut voir.",
  "collections_share_msg": "Regarde ma collection « {name} » sur My Within : {url}",
  "collections_share_again": "Partager le lien",
  "collections_edit_title": "Modifier la collection",
  "collections_field_name": "Nom",
  "collections_field_description": "Description",
  "collections_field_description_ph": "De quoi parle cette collection ?",
  "collections_field_emoji": "Emoji",
  "collections_field_color": "Couleur",
  "collections_empty_folder": "Cette collection est vide — enregistre des posts pour la remplir.",
  "collections_paid_tag": "Payant",
  "action_failed": "Action échouée",
  "post_untitled": "Sans titre",
  "focus_timer_title": "Minuteur Deep Work",
  "focus_timer_preset_classic": "Classique",
  "focus_timer_preset_sprint": "Sprint",
  "focus_timer_preset_extended": "Étendu",
  "focus_timer_phase_focus": "Focus",
  "focus_timer_phase_breathing": "Respire",
  "focus_timer_phase_break": "Pause",
  "focus_timer_phase_done": "Terminé",
  "focus_timer_phase_ready": "Prêt",
  "focus_timer_hint_breathing": "Respiration carrée 4-4-4-4 · réinitialise ton système nerveux.",
  "focus_timer_hint_break": "Lève-toi, regarde au loin, bois de l'eau.",
  "focus_timer_hint_focus": "Focus profond — coupe les notifications et vas-y.",
  "focus_timer_hint_done": "Bien joué — {n} sprint(s) terminé(s).",
  "focus_timer_hint_ready": "Choisis un préréglage et commence — une pause respiratoire suit chaque sprint.",
  "focus_timer_completed_sprints": "{n} sprint(s) terminé(s)",
  "focus_timer_start": "Commencer",
  "focus_timer_start_next": "Sprint suivant",
  "focus_timer_finish": "Terminer",
  "focus_timer_pause": "Pause",
  "focus_timer_resume": "Reprendre",
  "focus_timer_reset": "Réinitialiser",
  "focus_timer_tip": "Astuce : pose ton téléphone écran vers le bas. L'écran reste allumé pour suivre le rythme pendant la pause respiratoire.",
  "breath_inhale": "Inspire",
  "breath_exhale": "Expire",
  "breath_hold_in": "Retiens",
  "breath_hold_out": "Repose",
  "connected_intro_title": "Respiration connectée",
  "connected_intro_body": "Une pratique de libération profonde — lis ceci entièrement avant de la tenter.",
  "connected_what_it_is": "Ce que c'est",
  "connected_what_body": "Une respiration continue et circulaire — sans pause entre l'inspiration et l'expiration — maintenue pendant 30 à 60 minutes. Souvent par la bouche, en position allongée.",
  "connected_how_works": "Comment ça agit",
  "connected_how_body": "Le rythme soutenu modifie la chimie sanguine et abaisse la garde du mental. Des émotions, souvenirs et états corporels retenus peuvent remonter.",
  "connected_benefits": "Ce qu'elle peut offrir",
  "connected_benefits_body": "Libération émotionnelle, aperçus, un sentiment d'intégration, parfois un état très élargi. C'est une grande pratique — traite-la avec respect.",
  "connected_safety": "Uniquement avec un facilitateur",
  "connected_safety_body": "Ce n'est pas une pratique en solo. À ne pas tenter seul — ni au volant, ni dans l'eau, ni sous médicaments agissant sur le système nerveux, ni pendant la grossesse, ni avec des conditions cardiaques ou pulmonaires graves, ni avec des traumatismes non traités. Toujours pratiquer avec un facilitateur formé qui tient l'espace, repère la dysrégulation et accompagne l'intégration.",
  "connected_facilitator_only": "Aucun lecteur intégré — c'est voulu.",
  "connected_close": "Compris",
  "mp_load_failed": "Échec du chargement",
  "mp_by": "par",
  "mp_auto_chain": "Avance automatique",
  "mp_start": "Commencer",
  "mp_pause": "Pause",
  "mp_next_in": "Suivant dans",
  "mp_next_step": "Bloc suivant",
  "mp_finish": "Terminé · laisser un commentaire",
  "mp_chain_cancel": "Arrêter l'avance automatique",
  "mp_disclaimer": "Cet exercice est une offre d'accompagnement et ne remplace pas un diagnostic médical ou une psychothérapie. En cas de détresse aiguë, veuillez consulter un professionnel.",
  "mp_fb_title": "Comment s'est passée la séance ?",
  "mp_fb_sub": "Votre coach verra votre retour rapide.",
  "mp_fb_note_ph": "Facultatif : qu'est-ce qui vous a particulièrement plu ?",
  "mp_fb_skip": "Passer",
  "mp_fb_send": "Envoyer",
  "cm_q_required": "Obligatoire",
  "unlocked_title": "Déverrouillé",
  "unlocked_sub": "Vos méthodes achetées et offertes",
  "unlocked_empty": "Rien de déverrouillé pour l'instant. Lorsque votre coach vous offre une méthode ou que vous en achetez une, elle apparaît ici.",
  "unlock_src_gift": "Offrir",
  "unlock_src_paid": "Acheté",
  "unlock_src_public": "Public",
  "unlocked_posts_title": "Mes publications déverrouillées",
  "unlocked_posts_sub": "Publications payantes de vos coachs",
  "unlocked_posts_empty_title": "Aucune publication déverrouillée pour le moment",
  "unlocked_posts_empty_body": "Lorsque vous déverrouillerez une publication payante dans le fil d'actualité, elle apparaîtra ici.",
  "unlocked_posts_go_feed": "Ouvrir le fil d'actualité",
  "nav.collections": "Collections",
  "nav.focus_timer": "Minuteur focus",
  "nav.connected_breath": "Respiration connectée",
  "nav.unlocked_methods": "Débloquées",
  "nav.unlocked_posts": "Publications débloquées",

  // Welle 2 · Methoden-Kind-Labels (Method-Player / Unlocked)
  "method_kind_audio": "Audio",
  "method_kind_video": "Vidéo",
  "method_kind_breathwork": "Respiration",
  "method_kind_questions": "Questions",
  "method_kind_combo": "Combo",
  "method_kind_body_scan": "Scan corporel",
  "method_kind_gratitude": "Gratitude",
  "method_kind_visualization": "Visualisation",
  "method_kind_movement": "Mouvement",
  "method_kind_check_in": "Check-In",
  "method_kind_journal": "Journal",

  // Welle 3 · Collab-Marketplace + Snapshot-Anfragen + Blockierte Nutzer
  "client_collab_title": "Espace Collab",
  "client_collab_subtitle": "Tout ce qui concerne tes collaborations coachs",
  "client_collab_tile_chats_title": "Mes Chats Collab",
  "client_collab_tile_chats_sub": "Tous les chats coachs en cours",
  "client_collab_tile_offerings_title": "Acheter des offres Collab",
  "client_collab_tile_offerings_sub": "Découvre des duos et groupes de coachs à réserver",
  "client_collab_tile_projects_title": "Mes projets actifs",
  "client_collab_tile_projects_sub": "Offres et cercles auxquels tu participes",
  "client_collab_tile_discover_title": "Découvrir des coachs Collab",
  "client_collab_tile_discover_sub": "Paires de coachs avec offres communes",
  "client_collab_tile_reviews_title": "Mes évaluations",
  "client_collab_tile_reviews_sub": "Noter les projets terminés",
  "client_collab_discover_title": "Découvrir des coachs Collab",
  "client_collab_discover_sub": "Paires et groupes avec offres communes",
  "client_collab_discover_empty": "Aucune paire de coachs avec offres Collab.",
  "client_collab_discover_offerings": "Offres communes",
  "client_collab_discover_circles": "Cercles Collab",
  "starter_card_eyebrow": "Première fois ? Essaie",
  "starter_card_eyebrow_matched": "Correspond à ton émotion dominante · {emotion}",
  "starter_card_a11y": "Essayer un pack collab découverte",
  "client_collab_offerings_title": "Acheter des offres Collab",
  "client_collab_offerings_sub": "Duos et groupes de coachs disponibles",
  "client_collab_offerings_empty": "Aucune offre Collab disponible.",
  "client_collab_included_unlimited": "Illimité",
  "client_collab_included_msgs": "msgs",
  "client_collab_included_calls": "Appels",
  "client_collab_included_live": "Live",
  "client_collab_already_bought": "Acheté",
  "client_collab_buy_cta": "Acheter",
  "client_collab_purchase_confirm_title": "Confirmer l'achat",
  "client_collab_purchase_confirm_body": "{title} pour {price} ?",
  "client_collab_pay_credits": "Payer avec {n} crédits",
  "client_collab_purchase_success_title": "Acheté !",
  "client_collab_purchase_success_body": "Tu peux maintenant discuter avec {coaches}.",
  "client_collab_purchase_fail_body": "Achat échoué.",
  "client_collab_purchase_credits_short": "Il te faut {need} crédits, tu as {have}.",
  "client_collab_projects_title": "Mes projets actifs",
  "client_collab_projects_sub": "Offres et cercles auxquels tu participes",
  "client_collab_projects_empty": "Aucun projet Collab actif.",
  "client_collab_kind_circle": "Cercle",
  "client_collab_kind_offering": "Offre",
  "client_collab_kind_shared": "Multi",
  "client_collab_reviews_title": "Mes évaluations Collab",
  "client_collab_reviews_sub": "Une évaluation par coach par projet",
  "client_collab_reviews_empty": "Aucun projet terminé à évaluer.",
  "client_collab_review_add": "Évaluer",
  "client_collab_review_saved": "Évaluation enregistrée",
  "client_collab_review_editor_title": "Évaluer {coach}",
  "client_collab_review_comment_ph": "Un mot (optionnel)…",
  "client_collab_review_submit": "Enregistrer",
  "client_collab_chats_title": "Mes Chats Collab",
  "client_collab_chats_sub": "Tous les chats avec tes coachs",
  "client_collab_chats_empty": "Aucun chat Collab. Achète une offre Collab pour commencer.",
  "client_collab_no_messages": "Aucun message",
  "client_collab_project_not_found": "Projet introuvable",
  "client_collab_project_coaches": "Tes coachs",
  "client_collab_project_about": "À propos",
  "client_collab_project_chat": "Chat",
  "client_collab_project_open_chat": "Ouvrir le chat avec tes coachs",
  "client_collab_project_chat_soon": "Chat disponible après la première activité.",
  "client_collab_project_sessions": "Sessions",
  "client_collab_project_sessions_empty": "Aucune session prévue.",
  "client_collab_project_documents": "Ressources",
  "client_collab_project_documents_empty": "Aucune ressource partagée.",
  "client_collab_project_tasks": "Tâches",
  "client_collab_project_tasks_empty": "Aucune tâche en attente.",
  "session": "Séance",
  "week": "semaine",
  "month": "mois",
  "total": "total",
  "document": "Document",
  "open_report": "Ouvrir le rapport",
  "snapshot_requests_inbox": "Demandes de snapshot",
  "snapshot_requests_none": "Aucune demande pour le moment.",
  "snapshot_requests_from": "De {coach}",
  "snapshot_requests_period": "{days} derniers jours",
  "snapshot_requests_approve": "Approuver & partager",
  "snapshot_requests_decline": "Refuser",
  "snapshot_requests_help": "En approuvant, un nouveau rapport WEVA des {days} derniers jours est généré et partagé uniquement avec ce coach.",
  "snapshot_requests_status_pending": "En attente",
  "snapshot_requests_status_approved": "Partagé",
  "snapshot_requests_status_approved_no_data": "Approuvé (aucune donnée)",
  "snapshot_requests_status_declined": "Refusé",
  "snapshot_approved_toast": "Snapshot partagé avec ton coach ✨",
  "snapshot_declined_toast": "Refusé — rien n'a été partagé.",
  "snapshot_no_data_msg": "Aucune donnée sur la période choisie. Pratique d'abord puis approuve à nouveau.",
  "popup_approve_failed": "Échec de la validation",
  "blocked_at": "Bloqué le",
  "unblock_cta": "Débloquer",
  "nav.snapshot_requests": "Demandes de snapshot",
  "nav.blocked_users": "Utilisateurs bloqués",
  "circle_news_just_now": "à l'instant",
  "nav.collab_area": "Espace collab",
  "discover_strip_title": "Explorer",
  "discover_strip_sub": "Nouveaux extras pour toi",
  "discover_strip_new": "Nouveau",

  "nav.assistant": "Assistant de Pratique IA",
  "support": "Assistance",
  "aipa.title": "Assistant de Pratique IA",
  "aipa.subtitle": "Ton assistant proactif pour le quotidien.",
  "aipa.upsell_headline": "Plus de temps pour tes client·es",
  "aipa.upsell_sub": "Ton assistant IA prépare un briefing chaque matin, priorise les tâches, rédige des messages et automatise les routines — tu gardes le contrôle.",
  "aipa.feature_briefing": "Briefing quotidien",
  "aipa.feature_briefing_desc": "Chaque matin, une vue claire des client·es, rendez-vous et priorités.",
  "aipa.feature_tasks": "Gestion des tâches",
  "aipa.feature_tasks_desc": "Priorise, délègue à l'IA et garde un œil sur l'historique.",
  "aipa.feature_chat": "Chat de l'assistant",
  "aipa.feature_chat_desc": "Pose des questions sur ta pratique et obtiens des réponses concrètes.",
  "aipa.feature_workflows": "Workflows automatiques",
  "aipa.feature_workflows_desc": "L'assistant gère les routines récurrentes — avec ton accord.",
  "aipa.price_line": "{price} € / mois",
  "aipa.trial_note": "7 jours gratuits · annulable à tout moment",
  "aipa.start_trial": "Démarrer l'essai de 7 jours",
  "aipa.start_sub": "S'abonner maintenant",
  "aipa.starting": "Redirection vers le paiement…",
  "aipa.consent_hint": "Puis 20 €/mois, renouvellement automatique jusqu'à l'annulation.",
  "aipa.checkout_error": "Impossible de démarrer pour le moment. Réessaie.",
  "aipa.status_trial": "Essai",
  "aipa.status_active": "Actif",
  "aipa.status_canceled": "Annulé",
  "auth.cb_success": "Connexion réussie !",
  "auth.cb_failed": "Échec de la connexion Google. Réessaie.",
  "auth.cb_completing": "Finalisation de la connexion …",
  "nf.meta": "Page introuvable",
  "nf.title": "Cette page n'existe pas.",
  "nf.body": "Tu trouveras peut-être ce que tu cherches sur notre marketplace.",
  "nf.home": "Accueil",
  "aipa.card_ready": "Ton assistant est prêt. Ouvre-le pour le briefing du jour.",
  "aipa.card_open_tasks": "Tâches ouvertes",
  "aipa.card_needs_attention": "Nécessite ton attention",
  "aipa.card_to_approve": "À approuver",
  "aipa.card_setup_step": "Encore une étape : configure ton assistant pour qu'il prépare chaque matin pour toi.",
  "aipa.card_pitch": "Ton assistant proactif : briefing quotidien, tâches, suivis automatiques et rappels — tu gardes le contrôle.",
  "aipa.card_try_free": "Essaie 7 jours gratuits",
  "notif.seo": "Notifications",
  "ads.seo": "Coach · Publicité",
  "an.seo": "Coach · Analytique",
  "bk.seo": "Coach · Réservations",
  "cd.seo": "Coach · Client·e",
  "win.seo": "Coach · Réussites clients",
  "cc.seo": "Coach · Cercles",
  "cs.seo": "Coach · Configuration",
  "col2.seo": "Coach · Collectifs",
  "cf.seo": "Coach · Consentements",
  "soc.seo": "Coach · Social",
  "help.seo": "Coach · Aide",
  "ici.seo": "Coach · Invitations Inner Circle",
  "cm.seo": "Coach · Méthodes",
  "off.seo": "Coach · Offres",
  "pl.seo": "Coach · Plans",
  "pon.seo": "Coach · Profil professionnel",
  "prof.seo": "Coach · Profil",
  "recs.seo": "Coach · Recommandations",
  "ref.seo": "Coach · Parrainage",
  "cset.seo": "Coach · Paramètres",
  "sup.seo": "Coach · Assistance",
  "tour.seo": "Coach · Visite guidée",
  "upg.seo": "Coach · Mise à niveau",
  "verify.seo": "Coach · Vérification",
  "aipa.seo": "Coach · Assistant de pratique IA",
  "cbr.seo": "Coach · Identité visuelle",
  "chk.seo": "Coach · Modèle de check-in",
  "cred.seo": "Coach · Crédits",
  "refpol.seo": "Coach · Annulation et remboursement",
  "resch.seo": "Coach · Reports",
  "wdig.seo": "Coach · Résumé hebdomadaire",
  "common.copied": "Copié",
  "open": "Ouvrir",
  "ads.topup_custom_ph": "p. ex. 75",
  "ads.ph_themes": "breathwork, limites…",
  "ads.ph_regions": "EU, DE-Berlin…",
  "ads.ph_education_backgrounds": "Formation de coach…",
  "ads.ph_life_situations": "Indépendants, jeunes parents…",
  "ads.ph_other_traits": "Lève-tôt, TDAH…",
  "aipa.renews_on": "Renouvellement le {date}",
  "aipa.trial_until": "Essai jusqu'au {date}",
  "aipa.canceled_until": "Actif jusqu'au {date}",
  "aipa.wizard_title": "Configurer l'assistant",
  "aipa.wizard_intro": "En quelques étapes, ton assistant est prêt.",
  "aipa.step_label": "Étape {n} sur {total}",
  "aipa.step_language": "Langue",
  "aipa.step_language_desc": "Dans quelle langue l'assistant doit-il écrire ?",
  "aipa.lang_label": "Langue de l'assistant",
  "aipa.step_briefing": "Briefing quotidien",
  "aipa.step_briefing_desc": "Quand ton briefing doit-il être prêt ?",
  "aipa.briefing_time": "Heure du briefing",
  "aipa.show_on_login": "Afficher le briefing à la connexion",
  "aipa.step_autonomy": "Autonomie",
  "aipa.step_autonomy_desc": "Définis ce que l'assistant peut faire seul et ce que tu confirmes.",
  "aipa.step_workflows": "Workflows",
  "aipa.step_workflows_desc": "Active les routines qui doivent t'aider.",
  "aipa.step_outlook": "Outlook",
  "aipa.step_outlook_desc": "Connecte le calendrier et les mails (optionnel).",
  "aipa.outlook_calendar": "Calendrier Outlook",
  "aipa.outlook_mail": "Mails Outlook",
  "aipa.outlook_not_connected": "Pas encore connecté — l'assistant utilise les données de ton app en attendant.",
  "aipa.step_groups": "Filtre de groupes",
  "aipa.step_groups_desc": "Sur quels cercles l'assistant doit-il se concentrer ? Vide = tous.",
  "aipa.groups_all": "Tous les cercles",
  "aipa.groups_empty": "Pas encore de cercles.",
  "aipa.back": "Retour",
  "aipa.next": "Suivant",
  "aipa.finish_setup": "Terminer la configuration",
  "aipa.saving": "Enregistrement…",
  "aipa.setup_done_toast": "Ton assistant est prêt !",
  "aipa.lvl_confirm": "Confirmer",
  "aipa.lvl_auto": "Automatique",
  "aipa.lvl_never": "Jamais",
  "aipa.auto.message_clients": "Écrire aux client·es",
  "aipa.auto.appointment_reminders": "Rappels de rendez-vous",
  "aipa.auto.outlook_events": "Créer des événements Outlook",
  "aipa.auto.weekly_plan_reminders": "Rappels du plan hebdomadaire",
  "aipa.auto.post_drafts": "Brouillons de publications",
  "aipa.auto.mail_replies": "Réponses aux mails",
  "aipa.auto.auto_tasks": "Créer des tâches automatiquement",
  "aipa.wf.daily_briefing": "Briefing quotidien",
  "aipa.wf.weekly_summary": "Résumé hebdomadaire",
  "aipa.wf.weekly_plan_reminder": "Rappel du plan hebdomadaire",
  "aipa.wf.birthday_greetings": "Vœux d'anniversaire",
  "aipa.wf.session_followup": "Suivi de séance",
  "aipa.wf.inactive_clients": "Client·es inactif·ves",
  "aipa.wf.post_draft_on_theme": "Brouillon de publication par thème",
  "aipa.wf.appointment_confirmations": "Confirmations de rendez-vous",
  "aipa.wf.mail_reply_drafts": "Brouillons de réponse aux mails",
  "aipa.tab_briefing": "Briefing",
  "aipa.tab_tasks": "Tâches",
  "aipa.tab_agenda": "Agenda",
  "aipa.tab_chat": "Chat",
  "aipa.tab_settings": "Réglages",
  "aipa.briefing_title": "Ton briefing quotidien",
  "aipa.briefing_generate": "Créer le briefing",
  "aipa.briefing_generating": "Création du briefing…",
  "aipa.briefing_regenerate": "Recréer",
  "aipa.briefing_empty": "Pas encore de briefing pour aujourd'hui. Crée le premier maintenant.",
  "aipa.briefing_clients": "Client·es",
  "aipa.briefing_attention": "Nécessite attention",
  "aipa.briefing_calendar": "Calendrier",
  "aipa.briefing_tasks": "Tâches",
  "aipa.briefing_comm": "Suggestions de communication",
  "aipa.briefing_posts": "Idées de publications",
  "aipa.briefing_add_task": "En tâche",
  "aipa.copy": "Copier",
  "aipa.copied": "Copié",
  "aipa.generated_at": "Créé {date}",
  "aipa.tasks_title": "Tâches",
  "aipa.tasks_empty": "Aucune tâche ouverte. Bravo !",
  "aipa.task_title_ph": "Nouvelle tâche…",
  "aipa.task_desc_ph": "Description (optionnel)",
  "aipa.task_priority": "Priorité",
  "aipa.task_add": "Ajouter",
  "aipa.task_adding": "Ajout…",
  "aipa.prio.urgent": "Urgent",
  "aipa.prio.important": "Important",
  "aipa.prio.normal": "Normal",
  "aipa.prio.later": "Plus tard",
  "aipa.task_done": "Terminé",
  "aipa.task_delegate": "Déléguer à l'IA",
  "aipa.task_delegating": "Délégation…",
  "aipa.task_delete": "Supprimer",
  "aipa.task_ai_result": "Résultat de l'IA",
  "aipa.task_history": "Afficher l'historique",
  "aipa.task_history_hide": "Masquer l'historique",
  "aipa.task_export": "Export CSV",
  "aipa.agenda_title": "Agenda du jour",
  "aipa.agenda_events": "Rendez-vous",
  "aipa.agenda_no_events": "Aucun rendez-vous aujourd'hui.",
  "aipa.agenda_recurring": "Récurrent",
  "aipa.agenda_recurring_empty": "Pas encore d'entrées récurrentes.",
  "aipa.agenda_outlook_on": "Outlook connecté",
  "aipa.agenda_outlook_off": "Outlook non connecté",
  "aipa.recurring_add": "Ajouter une entrée",
  "aipa.recurring_title_ph": "Titre (p. ex. appel d'équipe)",
  "aipa.recurring_time": "Heure",
  "aipa.recurring_save": "Enregistrer",
  "aipa.wd.0": "Lun",
  "aipa.wd.1": "Mar",
  "aipa.wd.2": "Mer",
  "aipa.wd.3": "Jeu",
  "aipa.wd.4": "Ven",
  "aipa.wd.5": "Sam",
  "aipa.wd.6": "Dim",
  "aipa.chat_title": "Chat de l'assistant",
  "aipa.chat_ph": "Pose une question à ton assistant…",
  "aipa.chat_send": "Envoyer",
  "aipa.chat_empty": "Pose une question sur ta pratique.",
  "aipa.chat_clear": "Effacer l'historique",
  "aipa.chat_thinking": "Réflexion…",
  "aipa.settings_title": "Réglages",
  "aipa.settings_saved": "Réglages enregistrés.",
  "aipa.save": "Enregistrer",
  "aipa.cancel_package": "Annuler le forfait",
  "aipa.cancel_confirm": "Annuler vraiment le forfait ? Tu gardes l'accès jusqu'à la fin de la période.",
  "aipa.canceling": "Annulation…",
  "aipa.cancel_done": "Forfait annulé.",
  "aipa.tab_automation": "Automatisation",
  "aipa.automation_title": "Workflows autonomes",
  "aipa.automation_desc": "L’assistant exécute vos routines activées. Les actions réglées sur « Automatique » s’exécutent sans demander ; « Confirmer » crée une tâche à valider.",
  "aipa.run_now": "Lancer maintenant",
  "aipa.running": "Exécution…",
  "aipa.run_done": "{auto} automatiques · {pending} à valider",
  "aipa.activity_title": "Activité récente",
  "aipa.activity_empty": "Pas encore d’activité. Activez des workflows dans les réglages et lancez-les ici.",
  "aipa.mode_auto": "Automatique",
  "aipa.mode_pending": "À valider",
  "guide.ui.step": "Étape {x} sur {y}",
  "guide.ui.next": "Suivant",
  "guide.ui.done": "Terminé",
  "guide.ui.later": "Plus tard",
  "guide.ui.not_now": "Pas maintenant",
  "guide.ui.close": "Fermer",
  "guide.bar.title": "Vos débuts en tant que coach",
  "guide.bar.subtitle": "Quelques étapes en douceur et tout est prêt.",
  "guide.bar.progress": "{done} sur {total} terminé",
  "guide.bar.hide": "Masquer pour l'instant",
  "guide.bar.reopen": "Guide de configuration",
  "guide.status.done": "Terminé",
  "guide.status.skipped": "Ignoré",
  "guide.status.open": "À faire",
  "guide.complete.title": "Tout est prêt — merveilleux !",
  "guide.complete.body": "Vous avez terminé votre parcours de départ. Votre espace est prêt à accueillir et accompagner les personnes sur leur chemin. Ravi(e) de vous compter parmi nous.",
  "guide.complete.cta": "C'est parti",
  "guide.theme.profile.label": "Profil",
  "guide.theme.offering.label": "Offre",
  "guide.theme.circle.label": "Cercle",
  "guide.theme.availability.label": "Disponibilités",
  "guide.theme.payments.label": "Paiements",
  "guide.theme.post.label": "Publication",
  "guide.theme.method.label": "Méthode",
  "guide.theme.weekly_plan.label": "Plan hebdo",
  "guide.theme.calendar.label": "Calendrier",
  "guide.theme.discover.label": "Découvrir",
  "guide.theme.profile.title": "Montrez-vous — votre profil",
  "guide.theme.profile.cta": "Aller au profil",
  "guide.theme.profile.step1": "Commençons par vous. Voici votre profil personnel — la première impression pour les personnes qui vous trouvent.",
  "guide.theme.profile.step2": "Ajoutez une photo chaleureuse de vous. Un vrai visage crée tout de suite la confiance.",
  "guide.theme.profile.step3": "Indiquez votre nom — celui par lequel vous aimez être appelé(e).",
  "guide.theme.profile.step4": "Racontez en quelques phrases qui vous êtes et ce qui vous tient à cœur. Sans jargon.",
  "guide.theme.profile.step5": "Enregistrez votre profil — terminé ! Vous pourrez le modifier à tout moment.",
  "guide.theme.offering.title": "Votre première offre",
  "guide.theme.offering.cta": "Voir les offres",
  "guide.theme.offering.step1": "Ici, vous définissez comment vous accompagnez les personnes — par exemple une séance individuelle ou un petit forfait.",
  "guide.theme.offering.step2": "Créez une offre qui vous ressemble. Une fois enregistrée, nous validons cette étape pour vous.",
  "guide.theme.circle.title": "Votre propre cercle",
  "guide.theme.circle.cta": "Voir les cercles",
  "guide.theme.circle.step1": "Un cercle est votre espace de communauté — là où se réunissent les personnes que vous accompagnez.",
  "guide.theme.circle.step2": "Créez votre premier cercle. Vous décidez s'il est ouvert ou protégé.",
  "guide.theme.availability.title": "Vos horaires",
  "guide.theme.availability.cta": "Voir les disponibilités",
  "guide.theme.availability.step1": "Pour que les personnes puissent réserver, indiquez ici vos horaires.",
  "guide.theme.availability.step2": "Indiquez quand vous êtes disponible pour des séances. Une fois enregistré, cette étape est terminée.",
  "guide.theme.payments.title": "Configurer les paiements",
  "guide.theme.payments.cta": "Connecter Stripe",
  "guide.theme.payments.step1": "Pour que vos honoraires vous parviennent en toute sécurité, nous connectons votre compte à notre partenaire de paiement.",
  "guide.theme.payments.step2": "Connectez-vous à Stripe en toute sécurité. Cela ne prend que quelques minutes — nous vous guidons pas à pas.",
  "guide.theme.post.title": "Votre première publication",
  "guide.theme.post.cta": "Aller au fil",
  "guide.theme.post.step1": "Une publication montre ce qui vous anime — une pensée, une invitation, une étincelle.",
  "guide.theme.post.step2": "Partagez votre première publication. Une fois publiée, nous validons cette étape.",
  "guide.theme.method.title": "Votre méthode",
  "guide.theme.method.cta": "Voir les méthodes",
  "guide.theme.method.step1": "Une méthode est un petit exercice ou guide que vous partagez avec les personnes.",
  "guide.theme.method.step2": "Créez votre première méthode. Elle est validée automatiquement une fois enregistrée.",
  "guide.theme.weekly_plan.title": "Un plan hebdomadaire",
  "guide.theme.weekly_plan.cta": "Voir les plans hebdo",
  "guide.theme.weekly_plan.step1": "Avec un plan hebdomadaire, vous accompagnez les personnes jour après jour — avec douceur et structure.",
  "guide.theme.weekly_plan.step2": "Créez un plan et attribuez-le à quelqu'un. Cette étape sera alors terminée.",
  "guide.theme.calendar.title": "Votre calendrier",
  "guide.theme.calendar.cta": "Connecter le calendrier",
  "guide.theme.calendar.step1": "Connectez votre calendrier Outlook pour que les rendez-vous s'accordent automatiquement. Pas obligatoire — vous pouvez le faire plus tard.",
  "guide.theme.discover.title": "Découvrez votre espace",
  "guide.theme.discover.cta": "Aller au tableau de bord",
  "guide.theme.discover.step1": "Pour finir, une petite visite. Voici votre tableau de bord — votre maison dans l'app.",
  "guide.theme.discover.step2": "Ici, vous voyez le pouls de vos personnes — comment elles vont en ce moment.",
  "guide.theme.discover.step3": "Dans les messages, vous gardez un contact personnel et direct.",
  "guide.theme.discover.step4": "Dans vos cercles, la communauté et les échanges prennent vie.",
  "guide.theme.discover.step5": "Et ici, vous trouvez votre compte et tous les réglages. C'est tout — profitez bien !",
  // === iter273 i18n · wave 1 (CoachHome, CoachCircles) ===
  "ch.welcome": "Bon retour",
  "ch.default_name": "Coach",
  "ch.setup_title": "Configuration coach · {done}/{total} terminé",
  "ch.setup_sub": "Terminez les 4 étapes et obtenez votre badge de Coach Fondateur.",
  "ch.stat_circles": "Cercles",
  "ch.stat_upcoming": "Réservations à venir",
  "ch.wq_upcoming": "Sessions à venir",
  "ch.wq_unread": "Messages non lus",
  "ch.wq_pending": "À traiter",
  "ch.wq_next_sessions": "Tes prochaines sessions",
  "ch.wq_no_sessions": "Aucune session à venir.",
  "ch.wq_view_all": "Tout voir",
  "ch.wq_session": "Session",
  "ch.stat_credits": "Crédits",
  "ch.aff_title": "Votre lien d'affiliation",
  "ch.aff_hint": "Partagez-le — vous gagnez sur chaque parrainage.",
  "ch.aff_copied": "Lien d'affiliation copié",
  "ch.area_title": "Votre espace coach",
  "ch.areas_count": "{n} espaces",
  "ch.gross_title": "Chiffre d'affaires total (toutes réservations)",
  "ch.g_start": "Démarrer",
  "ch.g_circles": "Cercles",
  "ch.g_sell": "Vendre",
  "ch.g_grow": "Croissance",
  "ch.g_account": "Compte",
  "ch.g_affiliate": "Affiliation",
  "ch.i_feed": "Fil",
  "ch.i_messages": "Messages",
  "ch.i_notifications": "Notifications",
  "ch.i_circles": "Cercles",
  "ch.i_inner": "Inner Circle",
  "ch.i_mein": "Mon Cercle",
  "ch.i_pulse": "Pouls des clients",
  "ch.i_assistant": "Assistant de pratique IA",
  "ch.i_ads": "Publicité",
  "ch.i_recommendations": "Recommandations",
  "ch.i_content": "Social et contenu",
  "ch.i_consent": "Consentements",
  "ch.i_client_wins": "Réussites clients",
  "ch.i_collectives": "Collectifs",
  "ch.i_settings": "Paramètres",
  "ch.i_billing": "Facturation et abonnements",
  "ch.i_upgrade": "Coach Pro",
  "ch.i_support": "Support et aide",
  "ch.i_aff_link": "Parrainer et lien d'affiliation",
  "ch.i_aff_offerings": "Offres d'affiliation",
  "ch.i_aff_payouts": "Versements",
  "ch.s_feed": "Fil global et régional.",
  "ch.s_messages": "Messages directs et chats de cercle.",
  "ch.s_notifications": "Toutes vos alertes en un coup d'œil.",
  "ch.s_circles": "Aperçu Inner & Local Circle.",
  "ch.s_inner": "Définir l'abonnement, les avantages et les prix.",
  "ch.s_mein": "Configurer les abonnements complémentaires en détail.",
  "ch.s_pulse": "Clients silencieux et signaux d'alerte.",
  "ch.s_offerings": "Séances, forfaits, affiliation et prix.",
  "ch.s_bookings": "Séances, annulations et remboursements.",
  "ch.s_earnings": "Revenus, versements et impôts.",
  "ch.s_availability": "Ouvrir et fermer les créneaux hebdomadaires.",
  "ch.s_assistant": "Votre assistant de coaching autonome.",
  "ch.s_analytics": "Analyse en 12 blocs : croissance et rapports.",
  "ch.s_ads": "Campagnes, IA d'audience et crédits.",
  "ch.s_recommendations": "Impact des publications et recommandations chaleureuses.",
  "ch.s_collab": "Réseau, projets et offres communes.",
  "ch.s_content": "Publications, planificateur, stories et WEVA.",
  "ch.s_methods": "Créer des exercices : audio, vidéo, combo.",
  "ch.s_plans": "Partager des plans quotidiens et le breathwork hebdomadaire.",
  "ch.s_profile": "Profil public, bio et branding.",
  "ch.s_verify": "Télécharger les qualifications et le statut.",
  "ch.s_consent": "Formulaires de consentement et signatures.",
  "ch.s_client_wins": "Suggestions IA pour des témoignages de réussite.",
  "ch.s_collectives": "Alliances de coachs avec revenus partagés.",
  "ch.s_settings": "Politique d'annulation, reports, branding.",
  "ch.s_billing": "Crédits, abonnement plateforme et assistant IA.",
  "ch.s_upgrade": "Passez à : 10% de commission, branding et plus.",
  "ch.s_support": "Tickets à l'équipe, FAQ et visite guidée.",
  "ch.s_aff_link": "Partagez votre lien et gagnez.",
  "ch.s_aff_offerings": "Promouvoir des produits externes.",
  "ch.s_aff_payouts": "Commissions et versements.",
  "cc.title": "Cercles",
  "cc.subtitle": "Vos espaces d'accompagnement en un seul endroit — Inner Circle, Mon Cercle, Local et le Pouls des clients.",
  "cc.card_inner_sub": "Votre accompagnement exclusif",
  "cc.card_mein_sub": "Cercles individuels et guidés",
  "cc.card_local_sub": "Votre communauté gratuite",
  "cc.card_pulse_sub": "Gardez l'engagement en vue",
  "cc.your_circles": "Vos cercles",
  "cc.new_circle": "Nouveau cercle",
  "cc.empty": "Pas encore de cercles. Créez votre premier cercle.",
  "cc.archived": "Archivé",
  "cc.actions": "Actions du cercle",
  "cc.rename": "Renommer",
  "cc.archive": "Archiver",
  "cc.restore": "Restaurer",
  "cc.delete": "Supprimer",
  "cc.health_line": "{total} membres · {msgs} msg/7j · {active} actifs",
  "cc.health_active": "Actif",
  "cc.health_quiet": "Calme",
  "cc.health_silent": "Silencieux",
  "cc.copy_code": "Copier le code d'invitation",
  "cc.code_copied": "Code copié",
  "cc.my_clients": "Mes clients",
  "cc.no_clients": "Aucun client sans cercle pour le moment.",
  "cc.client": "Client",
  "cc.rename_title": "Renommer le cercle",
  "cc.rename_desc": "Donnez un nouveau nom au cercle. Tous les membres verront le nom mis à jour.",
  "cc.rename_ph": "Nom du cercle",
  "cc.cancel": "Annuler",
  "cc.save": "Enregistrer",
  "cc.renamed": "Cercle renommé",
  "cc.name_short": "Le nom est trop court (min. 2 caractères)",
  "cc.archived_toast": "Cercle archivé",
  "cc.restored_toast": "Cercle restauré",
  "cc.delete_title": "Supprimer le cercle « {name} » ?",
  "cc.delete_desc": "Cette action est irréversible. Le cercle et tous ses messages, annonces et activités seront définitivement supprimés.",
  "cc.delete_confirm": "Supprimer définitivement",
  "cc.deleted": "Cercle supprimé",
  "cc.kind_local": "LOCAL",
  "cc.kind_individual": "Mon Cercle",
  "cc.kind_inner": "Inner Circle",
  // === iter273 i18n · wave 2 (Billing, Membership) ===
  "tier.plus_blurb": "Pour une entrée en douceur dans la réflexion IA.",
  "tier.pro_blurb": "Plus de rapports et de plans de démarrage.",
  "tier.unlimited_blurb": "Réflexion illimitée, priorisée.",
  "tier.coach_pro_blurb": "Tout d'Unlimited + outils de coaching.",
  "feat.reports_unlimited": "Rapports WEVA illimités (usage raisonnable)",
  "feat.reports_count": "{n} rapports WEVA / mois",
  "feat.ad_free": "Sans publicité",
  "feat.voice_journal": "Journal vocal",
  "feat.starter_plans": "Plans de démarrage",
  "feat.priority": "Traitement prioritaire",
  "feat.commission": "Seulement {pct}% de commission plateforme",
  "feat.advanced_analytics": "Analyses coach avancées",
  "bill.title": "Facturation et abonnements",
  "bill.sub_coach": "Crédits, abonnement plateforme et l'Assistant de pratique IA — tout au même endroit. Paiement sécurisé via Stripe.",
  "bill.sub_client": "Crédits et abonnement plateforme — tout au même endroit. Paiement sécurisé via Stripe.",
  "bill.credits": "Crédits",
  "bill.credit_rate": "1 crédit = 0,10 € · TVA incl.",
  "bill.n_credits": "{n} crédits",
  "bill.popular": "Populaire",
  "bill.credits_word": "Crédits",
  "bill.incl_vat_per": "TVA incl. · {per}/crédit",
  "bill.buy": "Acheter",
  "bill.credits_added": "Crédits ajoutés !",
  "bill.purchase_failed": "L'achat a échoué.",
  "bill.payment_received": "Paiement reçu — merci !",
  "bill.cancelled": "Opération annulée.",
  "bill.sub_activated": "Abonnement activé — merci !",
  "bill.membership": "Abonnement plateforme",
  "bill.membership_sub": "Choisissez le plan adapté à votre travail intérieur. Annulable à tout moment.",
  "bill.current_plan": "Plan actuel : {name}",
  "bill.manage_hint": "Gérez votre abonnement, changez de moyen de paiement ou annulez — en toute sécurité via le portail Stripe. Votre accès reste actif jusqu'à la fin de la période.",
  "bill.manage": "Gérer l'abonnement",
  "bill.monthly": "Mensuel",
  "bill.yearly": "Annuel · économisez plus",
  "bill.recommended": "Recommandé",
  "bill.per_year": "an",
  "bill.per_month": "mois",
  "bill.current": "Plan actuel",
  "bill.choose": "Choisir",
  "bill.activated": "Abonnement activé !",
  "bill.finish_failed": "Impossible de finaliser.",
  "bill.stripe_note": "Paiement sécurisé via Stripe · TVA autrichienne incl.",
  "bill.stripe_note_vat": "Paiement sécurisé via Stripe · TVA autrichienne incl. · prix TTC.",
  "bill.manage_demo": "La gestion de l'abonnement n'est pas disponible en mode démo.",
  "bill.no_active_sub": "Aucun abonnement actif.",
  "bill.manage_failed": "Impossible d'ouvrir la gestion de l'abonnement.",
  "bill.ai_title": "Assistant de pratique IA",
  "bill.ai_sub": "Votre assistant de coaching autonome — briefing quotidien, tâches, chat et workflows.",
  "bill.ai_active": "Actif",
  "bill.ai_runs_until": "Actif jusqu'au {date}",
  "bill.ai_is_active": "Votre assistant est actif.",
  "bill.ai_open": "Ouvrir l'assistant",
  "bill.ai_upsell": "Automatisez les tâches de routine et recevez chaque matin un briefing clair.",
  "bill.ai_f_briefing": "Briefing quotidien",
  "bill.ai_f_tasks": "Délégation de tâches",
  "bill.ai_f_chat": "Chat IA",
  "bill.ai_f_workflows": "Workflows autonomes",
  "bill.ai_starting": "Démarrage…",
  "bill.ai_start_sub": "Démarrer l'abonnement",
  "bill.ai_trial": "Essai gratuit de 7 jours",
  "bill.ai_price": "{price} € / mois",
  "bill.ai_checkout_failed": "Le paiement a échoué.",
  "mem.title": "Abonnement",
  // === iter273 i18n · wave 3 (auth + public pages) ===
  "fp.meta": "Réinitialiser le mot de passe",
  "fp.title": "Mot de passe oublié ?",
  "fp.subtitle": "Nous vous enverrons un lien de réinitialisation.",
  "fp.back": "Retour à la connexion",
  "fp.sent": "Si cet e-mail est enregistré, vous recevrez bientôt un lien de réinitialisation.",
  "fp.email": "E-mail",
  "fp.email_ph": "vous@exemple.com",
  "fp.submit": "Envoyer le lien",
  "rp.meta": "Nouveau mot de passe",
  "rp.title": "Nouveau mot de passe",
  "rp.subtitle": "Choisissez un mot de passe sûr pour votre compte.",
  "rp.back": "Vers la connexion",
  "rp.no_token": "Ce lien n'est pas valide. Veuillez demander un nouveau lien de réinitialisation.",
  "rp.new_pw": "Nouveau mot de passe",
  "rp.pw_ph": "Au moins 8 caractères",
  "rp.submit": "Enregistrer le mot de passe",
  "rp.updated": "Mot de passe mis à jour.",
  "rp.failed": "La réinitialisation a échoué.",
  "cpg.meta": "Coachs",
  "cpg.meta_desc": "Découvrez des coachs vérifiés sur My Within — par thème, expertise et région.",
  "cpg.title": "Nos coachs",
  "cpg.subtitle": "Des accompagnant·es vérifié·es pour votre travail intérieur — trouvez la personne qui vous correspond.",
  "cpg.search_ph": "Recherchez par nom, expertise ou profession …",
  "cpg.empty_title": "Aucun coach trouvé",
  "cpg.empty_desc": "Essayez un autre terme de recherche.",
  "cpg.reset_search": "Réinitialiser la recherche",
  "od.fallback_title": "Offre",
  "od.notfound_title": "Offre introuvable",
  "od.notfound_desc": "Cette offre n'est plus disponible.",
  "od.to_marketplace": "Vers la marketplace",
  "od.marketplace": "Marketplace",
  "od.recommended": "Recommandé",
  "od.minutes": "{n} minutes",
  "od.included": "Ce qui est inclus",
  "od.savings": "Vous économisez {amount} dans le pack.",
  "od.price": "Prix",
  "od.cta": "Voir le coach et les disponibilités",
  "od.create_account": "Créez un compte",
  "od.signup_rest": " pour réserver et discuter.",
  "od.more_from": "Autres offres de {name}",
  "mkt.meta": "Marché",
  "mkt.meta_desc": "Découvre des offres de coaching, des cours et des forfaits de coachs vérifiés sur My Within.",
  "mkt.title": "Marché",
  "mkt.subtitle": "Offres, cours et forfaits de coachs vérifiés — trouve ce qui correspond à ton chemin.",
  "mkt.search_ph": "Rechercher par thème, titre ou coach …",
  "mkt.art": "Type",
  "mkt.all_types": "Tous les types",
  "mkt.region": "Région",
  "mkt.all_regions": "Toutes les régions",
  "mkt.theme": "Thème",
  "mkt.all_themes": "Tous les thèmes",
  "mkt.filters_active": "{n} filtres actifs",
  "mkt.reset": "Réinitialiser",
  "mkt.count_one": "{n} offre trouvée",
  "mkt.count_other": "{n} offres trouvées",
  "mkt.empty_title": "Aucune offre trouvée",
  "mkt.empty_desc": "Ajuste ta recherche ou tes filtres pour voir plus d'offres.",
  "mkt.reset_filters": "Réinitialiser les filtres",
  "mkt.loading": "Chargement …",
  "mkt.load_more": "Afficher plus",
  "cp.meta_fallback": "Coach",
  "cp.notfound_title": "Coach introuvable",
  "cp.notfound_desc": "Ce profil n'est pas disponible.",
  "cp.all_coaches": "Tous les coachs",
  "cp.since_year": "Dans le métier depuis {year}",
  "cp.about": "À propos de {name}",
  "cp.posts": "Publications",
  "cp.more_exclusive": "{n} publications exclusives de plus — à débloquer en tant que membre.",
  "cp.no_posts": "Pas encore de publications publiques.",
  "cp.focus": "Domaines clés",
  "cp.topics": "Thèmes",
  "cp.qualifications": "Qualifications",
  "cp.visit_website": "Visiter le site web",
  "cir.health_active": "Actif",
  "cir.health_quiet": "Calme",
  "cir.health_still": "Silencieux",
  "cir.kind_individual": "Mon Cercle",
  "cir.load_error": "Les cercles n'ont pas pu être chargés.",
  "cir.created": "Cercle créé",
  "cir.joined": "Cercle rejoint",
  "cir.join_failed": "Impossible de rejoindre",
  "cir.invite_sent": "Invitation envoyée",
  "cir.member_removed": "Membre retiré",
  "cir.remove_failed": "Impossible de retirer",
  "cir.code_copied": "Code copié",
  "cir.link_copied": "Lien copié",
  "cir.pin_updated": "Épingle mise à jour",
  "cir.eyebrow": "Communauté",
  "cir.title": "Cercles",
  "cir.subtitle": "Accompagne tes groupes et reste en lien avec tes client·es.",
  "cir.new_circle": "Nouveau cercle",
  "cir.new_circle_desc": "Choisis le type et donne un nom à ton cercle.",
  "cir.local_circle": "Cercle Local",
  "cir.local_circle_desc": "Groupe gratuit pour ta communauté.",
  "cir.mein_kreis": "Mon Cercle",
  "cir.mein_kreis_desc": "Cercle individuel et accompagné.",
  "cir.name_ph": "Nom du cercle",
  "cir.desc_ph": "Description (facultatif)",
  "cir.cancel": "Annuler",
  "cir.create": "Créer",
  "cir.invite_code_ph": "Code d'invitation",
  "cir.join": "Rejoindre",
  "cir.empty": "Pas encore de cercles. Crée-en un ou rejoins avec un code.",
  "cir.health_stat": "· {total} membres · {msgs} msg/7j · {active} actifs",
  "cir.copy_invite_code": "Copier le code d'invitation",
  "cir.select_circle": "Sélectionne un cercle à gauche.",
  "cir.invite_code_prefix": "Code d'invitation :",
  "cir.copy_code": "Copier le code",
  "cir.members_count": "{n} membres",
  "cir.share_link": "Partager le lien d'invitation",
  "cir.member_health": "Santé des membres",
  "cir.start_convo": "Lance la conversation",
  "cir.start_convo_desc": "Écris le premier message à ton cercle.",
  "cir.pin": "Épingler",
  "cir.msg_ph": "Écrire un message …",
  "cir.invite_email_ph": "Inviter par e-mail",
  "cir.invite": "Inviter",
  "cir.manage_members": "Gérer les membres",
  "cir.manage_members_desc": "Voir, inviter et retirer les membres de ton cercle.",
  "cir.no_members": "Pas encore de membres.",
  "cir.member_fallback": "Membre",
  "cir.coach": "Coach",
  "cir.remove": "Retirer",
  "cir.remove_member_q": "Retirer le membre ?",
  "cir.remove_member_desc": "{who} sera retiré du cercle. Cette action est irréversible.",
  "cir.this_member": "Ce membre",
  "mk.seo": "Coach · Mon Cercle",
  "mk.eyebrow": "Mon Cercle",
  "mk.title": "Mon Cercle",
  "mk.subtitle": "Cercles individuels et accompagnés avec ton propre prix, places et message de bienvenue.",
  "mk.new": "Nouveau",
  "mk.empty_title": "Pas encore de cercle à toi",
  "mk.empty_desc": "Crée ton premier cercle individuel avec prix et places.",
  "mk.create_circle": "Créer un cercle",
  "mk.bl_one_time": "unique",
  "mk.bl_monthly": "/mois",
  "mk.bl_yearly": "/an",
  "mk.free": "gratuit",
  "mk.seats": "{n} places",
  "mk.unlimited_seats": "Places illimitées",
  "mk.edit": "Modifier",
  "mke.seo_edit": "Coach · Modifier le cercle",
  "mke.seo_create": "Coach · Créer un cercle",
  "mke.title_edit": "Modifier le cercle",
  "mke.title_create": "Créer un cercle",
  "mke.subtitle": "Abonnement complémentaire — aussi détaillé que l'Inner Circle, avec/sans limite de temps et de places.",
  "mke.b_one_time": "Unique",
  "mke.b_monthly": "Mensuel",
  "mke.b_yearly": "Annuel",
  "mke.period_month": "par mois",
  "mke.period_week": "par semaine",
  "mke.period_total": "au total",
  "mke.unit_days": "Jours",
  "mke.unit_weeks": "Semaines",
  "mke.unit_months": "Mois",
  "mke.err_name": "Saisis un nom (min. 2 caractères).",
  "mke.saved": "Cercle enregistré",
  "mke.basics": "Informations de base",
  "mke.name": "Nom",
  "mke.description": "Description",
  "mke.desc_ph": "De quoi parle ce cercle ?",
  "mke.cover": "Image de couverture",
  "mke.cover_ph": "… ou colle une URL d'image",
  "mke.price_billing": "Prix et abonnement",
  "mke.price_eur": "Prix (€)",
  "mke.price_credits": "Prix (crédits)",
  "mke.price_hint": "Laisse vide (€ ou crédits) pour que la plateforme déduise automatiquement le prix manquant. 0 = gratuit.",
  "mke.access_section": "Participants et limite de temps",
  "mke.limit_seats": "Limiter le nombre de participants",
  "mke.limit_seats_hint": "Désactivé = membres illimités.",
  "mke.max_seats": "Participants maximum",
  "mke.seats_ph": "p. ex. 12",
  "mke.limit_time": "Accès limité dans le temps",
  "mke.limit_time_hint": "Désactivé = abonnement permanent sans limite de temps.",
  "mke.duration": "Durée",
  "mke.duration_ph": "p. ex. 3",
  "mke.perks_title": "Avantages inclus",
  "mke.perks_hint": "Regroupe des offres de toutes sortes — aussi détaillé que l'Inner Circle.",
  "mke.visibility": "Visibilité",
  "mke.vis_public": "Visible publiquement",
  "mke.vis_public_hint": "Apparaît sur ton profil de coach.",
  "mke.vis_invite": "Sur invitation uniquement",
  "mke.vis_invite_hint": "Rejoindre uniquement avec un code/lien d'invitation.",
  "mke.published": "Publié",
  "mke.published_hint": "Désactivé = enregistré mais masqué pour les client·es.",
  "mke.welcome_links": "Bienvenue et liens",
  "mke.welcome": "Message de bienvenue",
  "mke.welcome_ph": "Accueille les nouveaux membres …",
  "mke.zoom": "Lien Zoom",
  "mke.onboarding_video": "Vidéo d'accueil",
  "mke.video_ph": "… ou colle une URL de vidéo",
  "mke.sessions": "Séances incluses",
  "mke.add": "Ajouter",
  "mke.no_sessions": "Aucune séance ajoutée pour l'instant.",
  "mke.session_title_ph": "Titre de la séance",
  "mke.save": "Enregistrer",
  "mke.create": "Créer",
  "ctl.deliverables": "Livrables",
  "ctl.todos": "À faire",
  "ctl.clients": "Client·es",
  "ctl.chats": "Discussions",
  "ctl.weva": "Analyse de groupe WEVA",
  "ctl.members": "Santé des membres",
  "ctl.load_error": "Impossible de charger.",
  "ctl.deliverables_saved": "Livrables enregistrés",
  "ctl.weva_too_few": "Pas assez de données pour une analyse de groupe (min. 3 membres actifs).",
  "ctl.analysis_created": "Analyse créée",
  "ctl.analysis_pro": "Analyse impossible (Coach Pro uniquement).",
  "ctl.seo": "Coach · {title}",
  "ctl.back": "Tableau de bord",
  "ctl.inner_readonly": "Les livrables de l'Inner Circle sont gérés dans le plan Inner Circle (lecture seule ici).",
  "ctl.no_deliverables": "Aucun livrable disponible.",
  "ctl.save": "Enregistrer",
  "ctl.todo_behind": "En retard",
  "ctl.todo_behind_empty": "Tout est dans les temps.",
  "ctl.todo_dms": "DM ouverts",
  "ctl.todo_dms_empty": "Aucun DM ouvert.",
  "ctl.msg": "Message",
  "ctl.todo_snapshots": "Nouveaux snapshots",
  "ctl.todo_snapshots_empty": "Aucun nouveau snapshot.",
  "ctl.snapshot": "Snapshot",
  "ctl.no_clients": "Pas encore de client·es dans cette zone.",
  "ctl.client": "Client·e",
  "ctl.dm_limit": "Limite de DM active : {n}/mois.",
  "ctl.no_chats": "Aucune discussion.",
  "ctl.no_members": "Pas encore de membres dans cette zone.",
  "ctl.entries_30d": "{n} entrées (30j)",
  "ctl.last_emotion": " · dernière : {emotion}",
  "ctl.start_analysis": "Lancer l'analyse",
  "ctl.privacy_min": "Pour la confidentialité, les aperçus de groupe ne s'affichent qu'à partir de 3 membres actifs avec des données.",
  "ctl.themes": "Thèmes",
  "ctl.emotions": "Émotions",
  "ctl.beliefs": "Croyances",
  "ctl.latest_analysis": "Dernière analyse",
  "ctl.history": "Historique",
  "ctl.analysis": "Analyse",
  "ctl.privacy_note": "Les aperçus WEVA sont agrégés et anonymisés. Les entrées individuelles ne sont jamais partagées en clair.",
  "ctl.no_data": "Aucune donnée.",
  "cdb.weva": "Analyse WEVA",
  "cdb.load_error": "Impossible de charger l'aperçu.",
  "cdb.seo": "Coach · {title}",
  "cdb.subtitle": "Aperçu de l'activité, des revenus et des livrables.",
  "cdb.all_circles": "Tous les cercles",
  "cdb.active_members": "Membres actifs",
  "cdb.earnings_month": "Revenus (mois)",
  "cdb.snapshots_confirmed": "Snapshots confirmés",
  "cdb.entries_received": "Entrées reçues",
  "cdb.bookings": "Réservations",
  "cdb.active_offerings": "Offres actives",
  "cdb.included_deliverables": "Livrables inclus",
  "cdb.no_deliverables_defined": "Aucun livrable défini pour l'instant.",
  "cdb.per_month": "{n}× / mois",
  "cdb.earnings_this_month": "Revenus ce mois-ci",
  "cdb.bookings_received": "Réservations reçues",
  "cdb.areas": "Domaines",
  "perk.weva_snapshot_analysis": "Analyses de snapshots WEVA",
  "perk.user_entries_analysis": "Analyses des entrées",
  "perk.weekly_plan": "Plan hebdomadaire du coach",
  "perk.dm_monthly": "Messages directs par mois",
  "perk.paid_content": "Accès à tout le contenu payant",
  "perk.group_chat": "Chat de groupe privé avec d'autres membres",
  "perk.video_call": "Minutes d'appel vidéo 1:1 par mois",
  "perk.belief_text_beliefs": "Travail sur les croyances par texte · croyances par mois",
  "perk.belief_text_dms": "Travail sur les croyances par texte · DM par mois",
  "perk.belief_phone": "Travail sur les croyances par téléphone · minutes par mois",
  "perk.belief_video": "Travail sur les croyances par appel vidéo · minutes par mois",
  "perk.emergency_support": "Soutien émotionnel d'urgence",
  "perk.unit_month": "/mois",
  "perk.unit_dms_month": "DM/mois",
  "perk.unit_min_month": "min/mois",
  "perk.recommended": "· recommandé",
  "perk.custom_hint": "Ajoute tes propres avantages / offres (p. ex. « 5 messages vocaux / mois »).",
  "perk.min_short": "min",
  "perk.offer_name_ph": "Nom de l'offre",
  "perk.count_ph": "Nombre",
  "perk.add": "Ajouter",
  "cext.err_title": "Titre requis (min. 2 caractères).",
  "cext.published": "Annonce publiée",
  "cext.pinned": "Épinglé",
  "cext.unpin": "Détacher",
  "cext.announcements": "Annonces",
  "cext.new": "Nouveau",
  "cext.post_title": "Publier une annonce",
  "cext.post_desc": "Partage une nouveauté avec ton cercle.",
  "cext.title": "Titre",
  "cext.text": "Texte",
  "cext.body_ph": "Ton message …",
  "cext.require_confirm": "Exiger une confirmation de lecture",
  "cext.schedule": "Planifier (facultatif)",
  "cext.attachment": "Pièce jointe (facultatif)",
  "cext.post": "Publier",
  "cext.empty": "Pas encore d'annonces.",
  "cext.scheduled": "planifié",
  "cext.confirmed": "Confirmé",
  "cext.read": "Lu",
  "earn.p_month": "Mois",
  "earn.p_quarter": "Trimestre",
  "earn.p_year": "Année",
  "earn.p_all": "Total",
  "earn.src_inner": "Inner Circle",
  "earn.src_local": "Local Circle",
  "earn.src_sessions": "Séances",
  "earn.src_affiliate": "Affiliation",
  "earn.src_paid": "Contenu payant",
  "earn.src_other": "Autre",
  "earn.paid_status": "Versé",
  "earn.pending_status": "En attente",
  "earn.failed_status": "Échoué",
  "earn.seo": "Coach · Revenus",
  "earn.back": "Tableau de bord coach",
  "earn.eyebrow": "Revenus",
  "earn.title": "Revenus et versements",
  "earn.subtitle": "Revenus par source, versements et statut Stripe.",
  "earn.stripe_err": "Impossible de démarrer la configuration Stripe.",
  "earn.gross": "Revenu brut",
  "earn.paid_out": "Versé",
  "earn.pending": "En attente",
  "earn.next_payout": "Prochain versement",
  "earn.by_source": "Revenus par source",
  "earn.no_revenue": "Aucun revenu sur cette période.",
  "earn.stripe_payouts": "Versements Stripe",
  "earn.active": "Actif",
  "earn.setup_needed": "Configuration requise",
  "earn.opening_stripe": "Ouverture de Stripe…",
  "earn.continue_onboarding": "Continuer la configuration",
  "earn.connect_stripe": "Connecter Stripe",
  "earn.payouts": "Versements",
  "earn.no_payouts": "Pas encore de versements.",
  "earn.paid_on": "Versé {date}",
  "earn.created_on": "Créé {date}",
  "earn.step_connect": "Connecter le compte Stripe",
  "earn.step_identity": "Vérifier l'identité",
  "earn.step_bank": "Ajouter un compte bancaire pour les versements",
  "earn.step_documents": "Téléverser les documents demandés (si nécessaire)",
  "cpul.seg_all": "Tous",
  "cpul.seg_rising": "En hausse",
  "cpul.seg_stable": "Stable",
  "cpul.seg_dropping": "À risque",
  "cpul.seg_no_data": "Aucune donnée",
  "cpul.load_err": "Impossible de charger le pouls.",
  "cpul.seo": "Coach · Pouls des client·es",
  "cpul.eyebrow": "Pouls des client·es",
  "cpul.title": "Pouls des client·es",
  "cpul.subtitle": "Garde un œil sur l'engagement de tes client·es.",
  "cpul.refresh": "Actualiser",
  "cpul.alert_one": "{n} client·e à l'engagement en baisse.",
  "cpul.alert_other": "{n} client·es à l'engagement en baisse.",
  "cpul.all_good_title": "Tout est au vert",
  "cpul.all_good_desc": "Tou·tes les client·es stables ou en hausse.",
  "cpul.h7": "7j :",
  "cpul.h30": "30j :",
  "cpul.sessions": "Séances :",
  "mh.bucket_healthy": "Actif",
  "mh.bucket_silent": "Calme",
  "mh.bucket_inactive": "Inactif",
  "mh.bucket_churned": "Parti",
  "mh.load_err": "Impossible de charger la santé des membres.",
  "mh.nudge_sent": "Rappel envoyé",
  "mh.bulk_nudged": "{n} membres relancés",
  "mh.seo": "Coach · Santé des membres",
  "mh.eyebrow": "Membres",
  "mh.title": "Santé des membres",
  "mh.subtitle": "L'activité de tes membres et des relances ciblées.",
  "mh.all_silent": "Tous les silencieux ({n})",
  "mh.empty_title": "Pas encore de membres",
  "mh.empty_desc": "Dès que des membres rejoignent, tu verras leur activité ici.",
  "mh.not_active": "Pas encore actif",
  "mh.last_active": "Dernière activité il y a {n} jour(s)",
  "mh.expiring": " · abonnement bientôt expiré",
  "mh.nudge": "Relancer",
  "mh.nudge_title": "Relancer {name}",
  "mh.nudge_desc": "Un message chaleureux + notification.",
  "mh.nudge_ph": "Message facultatif …",
  "mh.send": "Envoyer",
  "mh.bulk_title": "Relancer tous les membres silencieux",
  "mh.bulk_desc": "Uniquement les membres récemment inactifs (max. 1× par 24h).",
  "av.wd_mon": "Lundi",
  "av.wd_tue": "Mardi",
  "av.wd_wed": "Mercredi",
  "av.wd_thu": "Jeudi",
  "av.wd_fri": "Vendredi",
  "av.wd_sat": "Samedi",
  "av.wd_sun": "Dimanche",
  "av.wds_mon": "Lun",
  "av.wds_tue": "Mar",
  "av.wds_wed": "Mer",
  "av.wds_thu": "Jeu",
  "av.wds_fri": "Ven",
  "av.wds_sat": "Sam",
  "av.wds_sun": "Dim",
  "av.load_err": "Impossible de charger la disponibilité.",
  "av.outlook_connected": "Calendrier Outlook connecté.",
  "av.outlook_failed": "Échec de la connexion Outlook.",
  "av.outlook_not_setup": "Outlook n'est pas encore configuré.",
  "av.outlook_disconnected": "Outlook déconnecté.",
  "av.saved": "Disponibilité enregistrée.",
  "av.save_failed": "Échec de l'enregistrement.",
  "av.day_updated": "{day} mis à jour.",
  "av.day_reset": "{day} réinitialisé.",
  "av.day_save_failed": "Impossible d'enregistrer le jour.",
  "av.seo": "Coach · Disponibilité",
  "av.eyebrow": "Disponibilité",
  "av.title": "Disponibilité et calendrier",
  "av.subtitle": "Ouvre des créneaux hebdomadaires ou ajuste des jours précis sur les prochaines semaines.",
  "av.outlook_cal": "Calendrier Outlook",
  "av.outlook_soon": "Configuré par l'équipe — bientôt disponible.",
  "av.connected": "Connecté",
  "av.reconnect_needed": " · reconnexion nécessaire",
  "av.outlook_hint": "Connecte ton calendrier Outlook pour la synchro libre/occupé.",
  "av.disconnect": "Déconnecter",
  "av.reconnect": "Reconnecter",
  "av.outlook_connect": "Connecter Outlook",
  "av.mode_uniform": "Uniforme",
  "av.mode_individual": "Individuel",
  "av.timezone": "Fuseau horaire",
  "av.uniform_hint": "Le modèle hebdomadaire s'applique à toutes les {weeks} semaines — jours ajustables ci-dessous.",
  "av.individual_hint": "Chaque jour est modifié individuellement.",
  "av.week_template": "Modèle hebdomadaire",
  "av.saving": "Enregistrement…",
  "av.save_template": "Enregistrer le modèle",
  "av.next_weeks": "{weeks} prochaines semaines",
  "av.tap_hint": "· touche un jour pour ajuster",
  "av.view": "Vue",
  "av.month": "Mois",
  "av.weeks_short": "{w} sem.",
  "av.custom": "Personnalisé",
  "av.adjust_day": "Ajuster {day}",
  "av.available": "Disponible",
  "av.reset": "Réinitialiser",
  "av.save": "Enregistrer",
  "av.slot": "Créneau",
  "ic.seo": "Coach · Inner Circle",
  "ic.subtitle": "Ton abonnement mensuel exclusif — regroupe des offres de toutes sortes en un accompagnement régulier.",
  "ic.tab_settings": "Réglages",
  "ic.tab_overview": "Aperçu",
  "ic.tab_clients": "Client·es",
  "ic.tab_weva": "WEVA",
  "ic.tab_invites": "Invitations",
  "ic.err_price": "Définis un prix en € ou en crédits.",
  "ic.err_min_eur": "Le prix minimum est de 4,99 € / mois.",
  "ic.err_min_credits": "Le prix minimum est de 50 crédits / mois.",
  "ic.saved_published": "Inner Circle enregistré et publié.",
  "ic.saved_hidden": "Inner Circle enregistré (masqué).",
  "ic.setup_intro": "Définis un prix mensuel et choisis ce que tes membres reçoivent chaque mois.",
  "ic.enable_card": "Activer les paiements par carte",
  "ic.enable_card_desc": "Complète les deux étapes pour que les client·es puissent s'abonner par carte.",
  "ic.step1": "1 · Connecter les versements Stripe",
  "ic.stripe_not_started": "Pas encore démarré — Stripe vérifie l'identité et les coordonnées bancaires pour tes versements.",
  "ic.stripe_submitted": "Soumis — Stripe vérifie encore (généralement <24h).",
  "ic.stripe_connected": "Connecté — tu peux recevoir des versements.",
  "ic.stripe_incomplete": "Démarré mais incomplet — termine le formulaire KYC.",
  "ic.stripe_start": "Démarrer la configuration Stripe",
  "ic.step2": "2 · Définir le prix en €",
  "ic.price_set": "{price}/mois défini. Enregistre pour activer.",
  "ic.price_enter": "Saisis un prix mensuel ci-dessous (min. 4,99 €/mois).",
  "ic.card_active": "Paiements par carte actifs",
  "ic.card_active_desc": "Les client·es peuvent s'abonner par carte (Stripe) ou crédits. {price}/mois · {share}% te reviennent.",
  "ic.price_eur": "Prix mensuel (€)",
  "ic.only_credits_hint": "Laisse vide si tu veux accepter uniquement les crédits.",
  "ic.price_credits": "Prix mensuel (crédits)",
  "ic.price_credits_ph": "p. ex. 50",
  "ic.credits_month": "crédits/mois",
  "ic.credits_auto_hint": "Laisse vide pour que la plateforme déduise automatiquement le prix en crédits.",
  "ic.revenue_split": "La plateforme garde {platform}% · Tu reçois {coach}%",
  "ic.coach_pro_hint": " · passer à Coach Pro réduit à 15%",
  "ic.description_label": "Description — ce que reçoivent les abonné·es",
  "ic.description_ph": "Un engagement mensuel envers ton travail intérieur …",
  "ic.whats_included": "Ce qui est inclus",
  "ic.core_hint": "Les quatre premiers sont des avantages clés (coaching WEVA) et sont recommandés.",
  "ic.visibility": "Visibilité",
  "ic.visibility_hint": "Ton Inner Circle apparaît-il publiquement sur ton profil ou uniquement sur invitation ?",
  "ic.vis_public": "Visible publiquement",
  "ic.vis_public_hint": "Apparaît sur ton profil de coach, tout le monde peut s'abonner.",
  "ic.vis_invite": "Sur invitation uniquement",
  "ic.vis_invite_hint": "Seul·es les client·es invité·es peuvent rejoindre.",
  "ic.waitlist": "{n} attendent ton Inner Circle",
  "ic.waitlist_hint": "Ils·elles seront notifié·es dès que tu actives « Publié ».",
  "ic.dm_limit": "Limite stricte de DM",
  "ic.dm_limit_hint": "Activé = les membres ne peuvent pas dépasser le quota mensuel de DM.",
  "ic.save": "Enregistrer l'Inner Circle",
  "ic.no_members": "Pas encore de membres de l'Inner Circle",
  "ic.no_members_hint": "Dès que quelqu'un s'abonne, il apparaît ici.",
  "ic.planned": "{n} à venir",
  "ic.past": "{n} passées",
  "ic.weva_err": "Impossible de charger le rapport WEVA.",
  "ic.snapshot7": "Snapshot (7j)",
  "ic.days30": "30 jours",
  "ic.history90": "Historique (90j)",
  "ic.members_one": "{n} membre",
  "ic.members_other": "{n} membres",
  "ic.period": "Période : {n} derniers jours",
  "ic.top_beliefs": "Croyances les plus fréquentes",
  "ic.upper_limits": "Points chauds de limite supérieure",
  "ic.not_enough": "Pas assez d'activité sur cette période pour un rapport.",
  "ic.min": "min",
  "ic.days": "jours",
  "ic.err_email": "Saisis au moins une adresse e-mail valide.",
  "ic.invites_created": "{n} invitation(s) créée(s).",
  "ic.invites_err": "Les invitations n'ont pas pu être envoyées.",
  "ic.invite_revoked": "Invitation retirée",
  "ic.emails_label": "Adresses e-mail",
  "ic.emails_hint": "Sépare plusieurs adresses par une virgule, un point-virgule ou un saut de ligne.",
  "ic.note_label": "Note personnelle (facultatif)",
  "ic.note_ph": "Bienvenue dans l'Inner Circle …",
  "ic.sending": "Envoi…",
  "ic.kpi_sent": "Envoyées",
  "ic.kpi_accept_rate": "Taux d'acceptation",
  "ic.kpi_accepted": "Acceptées",
  "ic.kpi_pending": "En attente",
  "ic.kpi_revoked": "Retirées",
  "ic.kpi_avg_time": "Temps moyen d'adhésion",
  "ic.kpi_active": "Membres actifs",
  "ic.kpi_retention": "Rétention 30j",
  "ic.sec_pending": "En attente",
  "ic.sec_pending_empty": "Pas encore d'invitations en attente.",
  "ic.sec_accepted": "Acceptées",
  "ic.sec_accepted_empty": "Pas encore d'acceptations.",
  "ic.sec_revoked": "Retirées",
  "ic.back": "Cercles",
  "ic.tile_deliverables": "Livraisons",
  "ic.tile_todos": "To-dos",
  "ic.tile_clients": "Client·es",
  "ic.tile_chats": "Chats",
  "ic.tile_weva": "Analyse WEVA",
  "ic.tile_members": "Santé des membres",
  "ic.save_err": "Échec de l'enregistrement.",
  "ic.stripe_onboard_err": "Impossible de démarrer la configuration Stripe.",
  "ic.opening_stripe": "Ouverture de Stripe…",
  "ic.continue_onboarding": "Continuer la configuration",
  "ic.ov_active_members": "Membres actifs",
  "ic.ov_earnings": "Revenus (mois)",
  "ic.ov_snapshots": "Snapshots confirmés",
  "ic.ov_entries": "Entrées reçues",
  "ic.ov_bookings": "Réservations",
  "ic.ov_offerings": "Offres actives",
  "ic.deliverables_title": "Livraisons incluses",
  "ic.no_deliverables": "Aucune livraison définie pour l'instant.",
  "ic.per_month": "{n}× / mois",
  "ic.areas": "Espaces",
  "ic.published": "Publié",
  "ic.published_hint": "Désactivé = enregistré mais masqué pour les client·es.",
  "ic.saving": "Enregistrement…",
  "ic.invite": "Inviter",
  "ic.month_suffix": "/mois",
  "ic.overview_err": "Impossible de charger l'aperçu.",

  // UX Rework 3.0
  "rw3.dw_areas": "Espaces",
  "rw3.dw_quick": "Accès rapide",
  "rw3.mem_on_free": "Vous utilisez actuellement le plan gratuit.",
  "rw3.mem_free_access": "Inclus : Respirer, Journal et Deep Within, ainsi que des rapports WEVA limités.",
  "rw3.mem_credits_title": "Crédits et facturation",
  "rw3.mem_credits_note": "Les séances et rapports individuels se paient avec des crédits — séparément de votre abonnement.",
  "rw3.mem_credits_cta": "Aller à la facturation",
  "rw3.mem_lifetime": "Vous avez un accès à vie — aucun abonnement nécessaire.",
  "rw3.mem_coach_note": "Les plans coach incluent tous les avantages personnels plus les outils de pratique.",
  "rw3.pl_confirm_multi": "Envoyer le plan « {name} » à {n} clients ?",
  "rw3.pl_confirm_circle": "Envoyer le plan « {name} » à tous les membres de ce cercle ?",
  "rw3.off_online": "En ligne",
  "rw3.off_inperson": "Sur place",
  "rw3.ic_this_month": "Ce mois-ci",
  "rw3.ic_recurring_est": "récurrent est. / mois",
  "ch.earn_title": "Revenus (mois)",
  "ch.earn_view": "Détails",
  "ch.earn_gross": "Brut",
  "ch.earn_pending": "En attente",
  "ch.earn_paid": "Versé",
  "ch.earn_next": "Prochain versement",
  "ch.earn_period_note": "Mois en cours · voir Revenus pour les périodes et le détail.",
  "ch.earn_vs_prev": "vs. mois dernier",
  "dw.progress_label": "{done} sur {total} transformés",
};

export default fr;
